import { React, theme } from "aaa";
import { CSSProperties } from "react";

// tslint:disable:max-line-length

export const LogoFinMagic = (props: {
    style?: { width: number; height: number };
}) => (
    <img
        width={props.style?.width}
        height={props.style?.height}
        src={require("../../assets/finMagic_logo.svg")}
    />
);

export const MaterialIconWrapper = (props: {
    className?: string;
    style?: React.CSSProperties;
    children: any;
    onClick?: () => void;
    viewBox?: string;
}) => {
    const size = 24;
    return (
        <svg
            className={props.className}
            xmlns="http://www.w3.org/2000/svg"
            style={{
                width: size,
                height: size,
                fill: "currentcolor",
                ...props.style,
            }}
            onClick={props.onClick}
            viewBox={props.viewBox || "0 0 24 24"}
            focusable="false"
        >
            {props.children}
        </svg>
    );
};

// Use this for icons in george-icons.svg (copy into index.html before use)
export const GeorgeIconWrapper = (props: {
    style?: React.CSSProperties;
    size: number;
    color: string;
    iconName: string;
}) => {
    return (
        <svg
            style={props.style}
            width={props.size}
            height={props.size}
            stroke={props.color}
            fill={props.color}
            focusable="false"
        >
            <use xlinkHref={props.iconName} />
        </svg>
    );
};

export const IconMessageOk = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 144 144"
    >
        <path d="M72,15 C103.480231,15 129,40.5197693 129,72 C129,103.480231 103.480231,129 72,129 C40.5197693,129 15,103.480231 15,72 C15,40.5197693 40.5197693,15 72,15 Z M72,21 C43.8334778,21 21,43.8334778 21,72 C21,100.166522 43.8334778,123 72,123 C100.166522,123 123,100.166522 123,72 C123,43.8334778 100.166522,21 72,21 Z M100.911333,48.6876834 C102.18839,49.7432832 102.367916,51.6342753 101.312317,52.9113325 L66.595632,94.9113325 C65.4725064,96.270082 63.4255065,96.3722063 62.1727192,95.1319905 L42.8894037,76.0421805 C41.7119379,74.8765303 41.7023594,72.9770596 42.8680095,71.7995937 C44.0336596,70.6221279 45.9331304,70.6125494 47.1105963,71.7781995 L64.0617685,88.5592691 L96.6876834,49.0886675 C97.7432832,47.8116103 99.6342753,47.6320836 100.911333,48.6876834 Z" />
    </MaterialIconWrapper>
);

export const IconCaretDown = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m256 290l92-92c8-8 21-8 30 0 8 9 8 22 0 30l-107 107c-8 8-22 8-30 0l-107-107c-8-8-8-21 0-30 9-8 22-8 30 0z" />
    </MaterialIconWrapper>
);

export const IconCaretUp = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m256 222l92 92c8 8 21 8 30 0 8-9 8-22 0-30l-107-107c-8-8-22-8-30 0l-107 107c-8 8-8 21 0 30 9 8 22 8 30 0z" />
    </MaterialIconWrapper>
);

export const IconPaymentPartial = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m417 172c-7-13-16-26-26-37l-110 110 63 0z m9 21l-52 52 63 0c-1-18-5-36-11-52z m-159-22l0 58 109-109c-10-9-22-17-34-24z m0-30l54-54c-17-7-35-11-54-12z m-11-88c112 0 203 91 203 203 0 6-5 11-11 11l-192 0c-6 0-11-5-11-11l0-192c0-6 5-11 11-11z m171 265c2-6 8-9 13-7 6 2 9 8 7 14-29 79-105 134-191 134-112 0-203-91-203-203 0-84 51-158 128-188 5-2 11 0 13 6 3 5 0 11-5 14-69 27-114 93-114 168 0 100 81 181 181 181 77 0 145-48 171-119z" />
    </MaterialIconWrapper>
);

export const IconWorld = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m142 397c31 25 71 40 114 40 100 0 181-81 181-181 0-3 0-7 0-10-8 1-18 2-21 6-6 6-6 24-12 24-6 0-18-42-24-42-6 0-12 6-18 0-6-6-12-12-12-12 0 0 12 24 12 30 0 6-18 24-24 18-6-6-18-42-18-42 0 0 0 48 6 54 6 6 16 1 18 6 3 7-18 17-18 23l0 18c0 6-30 36-36 42-7 6-19 0-25-6-6-6-12-18-12-24 0-6 6-12 6-18 0-6-18-35-24-35-6 0-18 5-24 5-6 0-30-17-30-23l0-36c0-6 60-30 66-30 6 0 12 12 18 12l43 0c6 0 6-12 0-12-6 0-12 0-12-6 0-6 24-18 18-24-6-6-24 12-31 12-6 0-18-12-24-12-6 0-36 24-42 24-6 0-12-6-12-12 0-6 12-29 18-29 6 0 42 0 48-6 6-6 6-24 0-24-6 0-24 12-30 6-4-4 24-30 30-30l37 0c2 0 13-6 23-12-23-11-48-16-75-16-41 0-78 13-108 36 5 5 12 14 12 17 0 7-19 44-25 44-7 0-7-25-13-25-6 0-19 12-19 19 0 6 13 37 13 43 0 4-25 17-40 25-1 7-1 15-1 22 0 16 2 31 5 45 10 4 22 10 25 13 7 7 7 25 13 32 6 6 31 6 31 19 0 6-3 20-7 32z m114-344c112 0 203 91 203 203 0 112-91 203-203 203-112 0-203-91-203-203 0-112 91-203 203-203z" />
    </MaterialIconWrapper>
);

export const IconPin = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 25 24"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.5 5H17.5C21.366 5 24.5 8.13401 24.5 12C24.5 15.866 21.366 19 17.5 19H7.5C3.63401 19 0.5 15.866 0.5 12C0.5 8.13401 3.63401 5 7.5 5ZM7.5 7C4.73858 7 2.5 9.23858 2.5 12C2.5 14.7614 4.73858 17 7.5 17H17.5C20.2614 17 22.5 14.7614 22.5 12C22.5 9.23858 20.2614 7 17.5 7H7.5ZM6.021 13.42C6.017 13.278 6.07999 13.138 6.20799 12.996L6.74897 12.397L5.956 12.222C5.77901 12.181 5.65001 12.104 5.57101 11.99C5.49102 11.879 5.47802 11.732 5.53501 11.547L5.58301 11.386C5.63901 11.21 5.73001 11.101 5.86 11.055C5.987 11.009 6.13199 11.027 6.29199 11.11L7.03696 11.46L6.93996 10.611C6.91696 10.429 6.94696 10.28 7.03096 10.168C7.11595 10.056 7.24595 10 7.42194 10H7.57794C7.75393 10 7.88292 10.056 7.96292 10.168C8.04292 10.28 8.07492 10.429 8.05792 10.611L7.96292 11.474L8.70789 11.11C8.87589 11.027 9.02088 11.009 9.14588 11.055C9.26987 11.101 9.35987 11.21 9.41687 11.386L9.46486 11.547C9.51986 11.732 9.51086 11.879 9.43386 11.99C9.35787 12.104 9.23187 12.181 9.05588 12.222L8.25091 12.397L8.79189 12.996C8.91988 13.138 8.98288 13.278 8.98288 13.42C8.98288 13.563 8.90689 13.688 8.75589 13.795L8.63589 13.882C8.4829 13.991 8.34291 14.024 8.21491 13.982C8.08692 13.941 7.97792 13.841 7.88992 13.684L7.49394 12.983L7.12195 13.684C7.02396 13.841 6.91296 13.941 6.78497 13.982C6.65697 14.024 6.51998 13.991 6.37598 13.882L6.24399 13.795C6.09899 13.688 6.025 13.563 6.021 13.42ZM11.244 13.795C11.099 13.688 11.025 13.563 11.021 13.42C11.017 13.278 11.08 13.138 11.208 12.996L11.749 12.397L10.956 12.222C10.779 12.181 10.65 12.103 10.571 11.99C10.491 11.879 10.478 11.732 10.535 11.547L10.583 11.386C10.639 11.21 10.73 11.101 10.86 11.055C10.987 11.009 11.132 11.027 11.292 11.11L12.037 11.46L11.94 10.611C11.917 10.429 11.947 10.28 12.031 10.167C12.116 10.056 12.2459 10 12.4219 10H12.5779C12.7539 10 12.8829 10.056 12.9629 10.167C13.0429 10.28 13.0749 10.429 13.0579 10.611L12.9629 11.473L13.7079 11.11C13.8759 11.027 14.0209 11.009 14.1459 11.055C14.2699 11.101 14.3599 11.21 14.4169 11.386L14.4649 11.547C14.5199 11.732 14.5109 11.879 14.4339 11.99C14.3579 12.103 14.2319 12.181 14.0559 12.222L13.2509 12.397L13.7919 12.996C13.9199 13.138 13.9829 13.278 13.9829 13.42C13.9829 13.563 13.9069 13.688 13.7559 13.795L13.6359 13.882C13.4829 13.991 13.3429 14.024 13.2149 13.982C13.0869 13.941 12.9779 13.841 12.8899 13.683L12.4939 12.983L12.122 13.683C12.024 13.841 11.913 13.941 11.785 13.982C11.657 14.024 11.52 13.991 11.376 13.882L11.244 13.795ZM16.0201 13.42C16.0161 13.279 16.0801 13.138 16.2081 12.996L16.7491 12.397L15.9551 12.223C15.7791 12.181 15.6501 12.104 15.5711 11.99C15.4911 11.879 15.4781 11.732 15.5351 11.548L15.5831 11.386C15.6391 11.21 15.7301 11.101 15.8591 11.055C15.9861 11.009 16.1321 11.027 16.2921 11.11L17.0371 11.46L16.9401 10.611C16.9171 10.429 16.9471 10.28 17.0311 10.168C17.1151 10.056 17.2451 10 17.4221 10H17.5781C17.7541 10 17.8821 10.056 17.9621 10.168C18.0431 10.28 18.0751 10.429 18.0581 10.611L17.9621 11.474L18.7081 11.11C18.8761 11.027 19.0211 11.009 19.1451 11.055C19.2691 11.101 19.3591 11.21 19.4171 11.386L19.4651 11.548C19.5201 11.732 19.5111 11.879 19.4341 11.99C19.3571 12.104 19.2311 12.181 19.0561 12.223L18.2511 12.397L18.7921 12.996C18.9201 13.138 18.9831 13.279 18.9831 13.42C18.9831 13.563 18.9071 13.688 18.7561 13.795L18.6351 13.883C18.4821 13.991 18.3431 14.024 18.2151 13.982C18.0871 13.941 17.9771 13.841 17.8901 13.684L17.4941 12.983L17.1211 13.684C17.0241 13.841 16.9131 13.941 16.7851 13.982C16.6561 14.024 16.5191 13.991 16.3761 13.883L16.2441 13.795C16.0991 13.688 16.0241 13.563 16.0201 13.42Z"
        />
    </MaterialIconWrapper>
);

export const IconBankCardXL = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m75 107l362 0c18 0 32 14 32 32l0 234c0 18-14 32-32 32l-362 0c-18 0-32-14-32-32l0-234c0-18 14-32 32-32z m0 21c-6 0-11 5-11 11l0 234c0 6 5 11 11 11l362 0c6 0 11-5 11-11l0-234c0-6-5-11-11-11z m42 128l107 0c6 0 11 5 11 11 0 6-5 10-11 10l-107 0c-6 0-10-4-10-10 0-6 4-11 10-11z m0 43l43 0c6 0 11 4 11 10 0 6-5 11-11 11l-43 0c-6 0-10-5-10-11 0-6 4-10 10-10z m-53-128l384 0 0 42-384 0z" />
    </MaterialIconWrapper>
);

export const IconCreditCard = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 25 24"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.5 19C21.6043 19 22.5 18.1043 22.5 17V7C22.5 5.89572 21.6043 5 20.5 5H4.5C3.39491 5 2.5 5.89552 2.5 7V17C2.5 18.1045 3.39491 19 4.5 19H20.5ZM4.5 7H20.5V17H4.5V7ZM8 14H7C6.72386 14 6.5 14.2239 6.5 14.5C6.5 14.7761 6.72386 15 7 15H8C8.27614 15 8.5 14.7761 8.5 14.5C8.5 14.2239 8.27614 14 8 14ZM11 14H10C9.72386 14 9.5 14.2239 9.5 14.5C9.5 14.7761 9.72386 15 10 15H11C11.2761 15 11.5 14.7761 11.5 14.5C11.5 14.2239 11.2761 14 11 14ZM13 14C12.7239 14 12.5 14.2239 12.5 14.5C12.5 14.7761 12.7239 15 13 15H14C14.2761 15 14.5 14.7761 14.5 14.5C14.5 14.2239 14.2761 14 14 14H13ZM17 14H16C15.7239 14 15.5 14.2239 15.5 14.5C15.5 14.7761 15.7239 15 16 15H17C17.2761 15 17.5 14.7761 17.5 14.5C17.5 14.2239 17.2761 14 17 14ZM7.5 10H8.5V11H7.5V10ZM8.5 9H7.5C6.94772 9 6.5 9.44772 6.5 10V11C6.5 11.5523 6.94772 12 7.5 12H8.5C9.05228 12 9.5 11.5523 9.5 11V10C9.5 9.44772 9.05228 9 8.5 9Z"
        />
    </MaterialIconWrapper>
);

export const IconCreditCardXL = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m437 405l-362 0c-18 0-32-14-32-32l0-234c0-18 14-32 32-32l362 0c18 0 32 14 32 32l0 234c0 18-14 32-32 32z m0-21c6 0 11-5 11-11l0-234c0-6-5-11-11-11l-362 0c-6 0-11 5-11 11l0 234c0 6 5 11 11 11z m-320-64c-6 0-10-5-10-11 0-6 4-10 10-10l22 0c6 0 10 4 10 10 0 6-4 11-10 11z m86 0c-6 0-11-5-11-11 0-6 5-10 11-10l21 0c6 0 11 4 11 10 0 6-5 11-11 11z m85 0c-6 0-11-5-11-11 0-6 5-10 11-10l21 0c6 0 11 4 11 10 0 6-5 11-11 11z m85 0c-6 0-10-5-10-11 0-6 4-10 10-10l22 0c6 0 10 4 10 10 0 6-4 11-10 11z m-245-107l0 22 21 0 0-22z m0-21l21 0c12 0 22 10 22 21l0 22c0 11-10 21-22 21l-21 0c-12 0-21-10-21-21l0-22c0-11 9-21 21-21z" />
    </MaterialIconWrapper>
);

export const IconPrepaidCardXL = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m373 320l0-53c0-6 5-11 11-11 6 0 11 5 11 11l0 53 53 0c6 0 11 5 11 11 0 6-5 10-11 10l-53 0 0 54c0 6-5 10-11 10-6 0-11-4-11-10l0-54-53 0c-6 0-11-4-11-10 0-6 5-11 11-11z m96-107c-7 0-14 0-21 0l0-74c0-6-5-11-11-11l-362 0c-6 0-11 5-11 11l0 234c0 6 5 11 11 11l217 0c4 8 10 15 16 21l-233 0c-18 0-32-14-32-32l0-234c0-18 14-32 32-32l362 0c18 0 32 14 32 32z m-352 43l107 0c6 0 11 5 11 11 0 6-5 10-11 10l-107 0c-6 0-10-4-10-10 0-6 4-11 10-11z m0 43l43 0c6 0 11 4 11 10 0 6-5 11-11 11l-43 0c-6 0-10-5-10-11 0-6 4-10 10-10z m-53-128l384 0 0 42-384 0z" />
    </MaterialIconWrapper>
);

export const IconPhoneXL = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m149 395l0 21c0 18 15 32 32 32l150 0c17 0 32-14 32-32l0-21z m0-299l214 0c0-18-15-32-32-32l-150 0c-17 0-32 14-32 32z m182 373l-150 0c-29 0-53-24-53-53l0-320c0-29 24-53 53-53l150 0c29 0 53 24 53 53l0 320c0 29-24 53-53 53z m-182-96l214 0 0-256-214 0z m118 37c7 6 7 16 0 23-6 6-16 6-22 0-7-7-7-17 0-23 6-6 16-6 22 0z" />
    </MaterialIconWrapper>
);

export const IconMailXL = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m77 135c-1 4-2 8-2 13l0 216c0 17 13 31 30 31l302 0c17 0 30-14 30-31l0-216c0-5-1-9-2-13-1 0-1 1-1 1l-143 128c-20 18-50 18-70 0l-143-128c0 0 0-1-1-1z m15-15l143 128c12 11 30 11 42 0l142-128c-3-2-8-3-12-3l-302 0c-4 0-9 1-13 3z m315 296l-302 0c-28 0-52-23-52-52l0-216c0-29 24-52 52-52l302 0c28 0 52 23 52 52l0 216c0 29-24 52-52 52z" />
    </MaterialIconWrapper>
);

export const IconHandCoins = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m117 277c12 0 22 10 22 22l0 10 170 0c17 0 31 14 32 30l0 2c0 1 0 2 0 3l53-17c15-5 31-3 44 5 3 3 6 5 7 9 5 10 2 23-8 28l-1 1-109 54c-30 16-65 18-97 8l-3-1-89-32c-2 10-10 17-21 17l-32 0c-11 0-21-10-21-21l0-96c0-12 10-22 21-22z m192 54l-170 0 0 45 95 34c26 10 55 9 80-3l3-2 109-54c0 0 0 0 0-1l0 0 0 0-2-1c-6-3-14-5-21-3l-2 1-74 25c-3 1-5 1-8 1l-2 0-63 0c-5 0-10-4-10-10 0-6 4-10 9-11l1 0 55 0c6 0 11-5 11-11 0-5-4-10-9-10z m-192-32l-32 0 0 96 32 0z m150-128c29 0 53 24 53 53 0 29-24 53-53 53-30 0-54-24-54-53 0-29 24-53 54-53z m0 21c-18 0-32 14-32 32 0 18 14 32 32 32 17 0 32-14 32-32 0-18-15-32-32-32z m0 11c5 0 10 4 10 9l0 1 0 22c0 6-4 10-10 10-6 0-10-4-11-9l0-1 0-22c0-6 5-10 11-10z m74-139c30 0 54 24 54 53 0 30-24 54-54 54-29 0-53-24-53-54 0-29 24-53 53-53z m0 21c-17 0-32 15-32 32 0 18 15 32 32 32 18 0 32-14 32-32 0-17-14-32-32-32z m0 11c6 0 10 4 11 9l0 2 0 21c0 6-5 11-11 11-5 0-10-4-10-10l0-1 0-21c0-6 4-11 10-11z" />
    </MaterialIconWrapper>
);

export const IconMilesAndMore = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <rect width="512" height="511" rx="255.5" fill="#0C2058" />
        <path
            d="M194.2 237V150H214.9V237H194.2ZM165.4 237V173.7H186.1V237H165.4ZM123.7 150H157V237H135.7V177.9H135.4L117.3 237H100L81.6 177.9H81.3V237H60V150H93.5L108.4 204.4H108.6L123.7 150ZM165.4 165.7V150H186.1V165.7H165.4ZM253.9 186.1C247.3 186.1 242.8 189.8 241.5 198.3H265.5C265.1 190.2 260.9 186.1 253.9 186.1ZM254.3 172C275.5 172 287.3 186 286.2 210.5H241.4C241.6 219.5 246.6 224.8 254.4 224.8C259.9 224.8 264 222.3 266 217.5H285.3C282 231.3 270.3 238.7 254.5 238.7C233.5 238.7 220.6 225.7 220.6 205.6C220.6 185.1 233.9 172 254.3 172ZM328.9 198.1C342.3 200.8 349.9 205.3 349.9 216.4C349.9 229.9 338.7 238.7 319.1 238.7C300.6 238.7 290 230.8 289.6 217.5H309.5C309.5 222 314 225.4 320 225.4C325.4 225.4 329.4 222.7 329.4 218.2C329.4 214.5 326.7 213.3 317.2 211.9C306 210.2 290.9 207.7 290.9 191.9C290.9 175.8 306.5 172 319.3 172C337.6 172 347.4 179.7 347.7 191.7H328.7C328.7 187.7 325.7 185.5 319.3 185.5C314.3 185.5 311.5 186.8 311.5 190.3C311.4 196.1 319.1 196.2 328.9 198.1Z"
            fill="white"
        />
        <path
            d="M415.8 308.4C409.2 308.4 404.7 312.1 403.4 320.6H427.4C427 312.5 422.9 308.4 415.8 308.4ZM416.3 294.3C437.5 294.3 449.3 308.3 448.2 332.8H403.4C403.7 341.8 408.6 347.1 416.4 347.1C421.9 347.1 426 344.6 428 339.8H447.3C444 353.6 432.3 361 416.5 361C395.5 361 382.6 348 382.6 327.9C382.6 307.4 395.8 294.3 416.3 294.3ZM92.3 344.2C85.2 344.2 79.9 340.8 79.9 334.5C79.9 330 82.6 326.7 88.7 323L103.3 340.2C99.8 342.9 96.4 344.2 92.3 344.2ZM95.7 285.7C99.7 285.7 103.4 288 103.4 292.7C103.4 296.3 101.2 299 95.1 303C90.7 298.4 88.4 295.7 88.4 292.2C88.4 288.4 91.3 285.7 95.7 285.7ZM144.9 359.3L127.6 339.8C133.3 332.7 137.1 324.4 138.4 314.6H120.6C119.6 319.2 118.2 323.4 116.1 326.9L105.3 314.8C115.1 308.8 120.2 302.4 120.2 293.1C120.2 279.8 109.6 270.7 95.6 270.7C81.3 270.7 70.1 280.2 70.1 292.3C70.1 298.9 73.5 303.9 78.5 309.7C66.1 315.9 60 324.3 60 334.9C60 350.3 72.9 361 90.1 361C98.7 361 106.4 358.3 113.8 352.5L119.6 359.3H144.9ZM229.1 272.4L214 327H213.8L198.9 272.4H165.4V359.4H186.7V300.4H186.9L205.3 359.4H222.6L240.8 300.4H241V359.4H262.3V272.4H229.1ZM301.5 345C310.3 345 314.3 339.8 314.3 328.2C314.3 316.4 310 310 301.5 310C292.7 310 288.9 316.6 288.9 328.2C289 339.7 292.6 345 301.5 345ZM301.6 294.3C321.6 294.3 334.9 307.6 334.9 328.1C334.9 348.1 322.2 361 301.5 361C280.8 361 268.1 348.2 268.1 328.3C268.1 307.5 281.7 294.3 301.6 294.3ZM381.1 294.8V313.1C380.1 313 378.3 312.8 376.9 312.8C367.4 312.8 361.3 319 361.3 327.9V359.2H340.6V296H360.6L360.9 303.4C364.3 298.3 369.1 294.5 377.8 294.5C379.4 294.6 380.5 294.7 381.1 294.8Z"
            fill="white"
        />
    </MaterialIconWrapper>
);

export const IconPercentageFees = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m117 64l267 0c12 0 21 10 21 21l-309 0c0-11 10-21 21-21z m342 160l10 0c12 0 22 10 22 21l0 43c0 12-10 21-22 21l-10 0 0 64c0 30-24 54-54 54l-298 0c-30 0-54-24-54-54l0-213c0-29 24-53 54-53l298 0c30 0 54 24 54 53z m-22 0l0-64c0-18-14-32-32-32l-298 0c-18 0-32 14-32 32l0 213c0 18 14 32 32 32l298 0c18 0 32-14 32-32l0-64-10 0c-12 0-22-9-22-21l0-43c0-11 10-21 22-21z m-10 64l42 0 0-43-42 0z m-235-21c-21 0-32-19-32-43 0-24 11-43 32-43 21 0 32 19 32 43 0 24-11 43-32 43z m0-22c6 0 11-6 11-21 0-15-5-21-11-21-6 0-11 6-11 21 0 15 5 21 11 21z m107 107c-22 0-32-19-32-43 0-23 10-42 32-42 21 0 32 19 32 42 0 24-11 43-32 43z m0-21c6 0 10-7 10-22 0-15-4-21-10-21-7 0-11 6-11 21 0 15 4 22 11 22z m-87 16c-3 5-10 7-15 4-5-3-7-10-4-15l86-149c3-5 9-7 14-4 5 3 7 9 4 14z" />
    </MaterialIconWrapper>
);

export const IconTollsXl = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m174 54c5 1 9 7 7 13l-107 384c-1 6-7 9-13 7-6-1-9-7-7-13l106-384c2-6 8-9 14-7z m164 0c-5 1-9 7-7 13l107 384c1 6 7 9 13 7 6-1 9-7 7-13l-106-384c-2-6-8-9-14-7z m-71 74c0-6-5-11-11-11-6 0-11 5-11 11l0 43c0 6 5 10 11 10 6 0 11-4 11-10z m-11 117c6 0 11 5 11 11l0 43c0 6-5 10-11 10-6 0-11-4-11-10l0-43c0-6 5-11 11-11z m11 139c0-6-5-11-11-11-6 0-11 5-11 11l0 43c0 6 5 10 11 10 6 0 11-4 11-10z" />
    </MaterialIconWrapper>
);

export const IconList = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m181 160c-6 0-10-5-10-11 0-6 4-10 10-10l235 0c6 0 11 4 11 10 0 6-5 11-11 11z m0 107c-6 0-10-5-10-11 0-6 4-11 10-11l235 0c6 0 11 5 11 11 0 6-5 11-11 11z m0 106c-6 0-10-4-10-10 0-6 4-11 10-11l235 0c6 0 11 5 11 11 0 6-5 10-11 10z m-53-224c0 12-10 22-21 22-12 0-22-10-22-22 0-11 10-21 22-21 11 0 21 10 21 21z m0 107c0 12-10 21-21 21-12 0-22-9-22-21 0-12 10-21 22-21 11 0 21 9 21 21z m0 107c0 11-10 21-21 21-12 0-22-10-22-21 0-12 10-22 22-22 11 0 21 10 21 22z" />
    </MaterialIconWrapper>
);

export const IconAirplane = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 48 48"
    >
        <path d="M36.0596 14.4431C36.0278 14.5328 35.9922 14.6207 35.9546 14.7081C35.8589 14.9167 35.6335 15.0336 35.4079 14.9913C35.1826 14.9491 35.0149 14.7584 35.0009 14.5297C35.0009 14.5297 34.9946 14.4507 34.9869 14.3864C34.9755 14.2914 34.9563 14.1614 34.9254 14.021C34.8571 13.71 34.7551 13.462 34.6465 13.3534C34.5379 13.2449 34.2899 13.1428 33.979 13.0745C33.8385 13.0436 33.7085 13.0245 33.6135 13.0131C33.5491 13.0053 33.4701 12.999 33.4701 12.999C33.2411 12.9853 33.0508 12.8175 33.0086 12.592C32.9663 12.3664 33.0833 12.141 33.2918 12.0453L33.2928 12.0449C33.3798 12.0074 33.4674 11.972 33.5568 11.9403C33.7114 11.8854 33.9287 11.818 34.1725 11.7725C34.6148 11.69 35.3486 11.6414 35.8536 12.1463C36.3586 12.6513 36.3099 13.3851 36.2274 13.8274C36.1819 14.0713 36.1146 14.2885 36.0596 14.4431Z" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.6047 24.8062C30.997 24.4374 31.3854 24.0682 31.768 23.7002C34.6856 20.8937 37.4567 17.9776 39.2516 15.4534C40.1379 14.2071 40.8877 12.9181 41.2414 11.6933C41.5956 10.4668 41.6606 8.83205 40.4142 7.58567C39.1679 6.33929 37.5332 6.40432 36.3067 6.75849C35.0818 7.11217 33.7928 7.86204 32.5465 8.74829C30.0224 10.5433 27.1063 13.3143 24.2997 16.2319C23.9317 16.6145 23.5626 17.0029 23.1937 17.3952C22.9433 17.2088 22.6483 17.0803 22.3288 17.0271L18.9262 16.46C18.8367 16.1398 18.6661 15.8375 18.4143 15.5857C17.6332 14.8046 16.3669 14.8046 15.5858 15.5857L15.3136 15.8579L10.3288 15.0271C9.69169 14.9209 9.04251 15.129 8.58579 15.5857L6.58579 17.5857C6.1687 18.0028 5.957 18.5827 6.00729 19.1704C6.05759 19.7581 6.36475 20.2937 6.84664 20.6338L15.1191 26.4732C14.6313 27.0427 14.1765 27.5758 13.762 28.0616L13.7583 28.066L13.7571 28.0674C13.1719 28.7533 12.6671 29.345 12.2626 29.8128L8.39226 29.0387C7.73654 28.9076 7.05866 29.1128 6.58582 29.5857L4.58582 31.5857C4.11044 32.0611 3.9057 32.7435 4.04088 33.402C4.17605 34.0606 4.63305 34.6072 5.25725 34.8568L8.71261 36.239L8.53887 37.1077C8.40773 37.7634 8.61297 38.4413 9.08582 38.9141C9.55867 39.3869 10.2365 39.5922 10.8923 39.461L11.7609 39.2873L13.1431 42.7427C13.3928 43.3669 13.9393 43.8239 14.5979 43.959C15.2565 44.0942 15.9389 43.8895 16.4142 43.4141L18.4142 41.4141C18.8871 40.9413 19.0923 40.2634 18.9612 39.6077L18.1871 35.7373C18.6546 35.3331 19.2464 34.8282 19.9317 34.2436L19.9326 34.2428C20.5626 33.7053 21.272 33.1001 22.0377 32.4426L27.2934 41.0428C27.6131 41.5659 28.1549 41.9135 28.7637 41.9859C29.3724 42.0583 29.9807 41.8476 30.4142 41.4141L32.4142 39.4141C32.8709 38.9574 33.0789 38.3082 32.9728 37.6711L32.142 32.6864L32.4143 32.4141C33.1953 31.633 33.1953 30.3667 32.4143 29.5857C32.1624 29.3338 31.8601 29.1632 31.5399 29.0737L30.9728 25.6711C30.9195 25.3517 30.791 25.0567 30.6047 24.8062ZM29.5858 29.5857L29.5959 29.5757L29.0427 26.2562C27.1775 27.967 25.2861 29.6335 23.5726 31.1188L29 39.9999L31 37.9999L29.6017 29.6102L29.5858 29.5857ZM18.376 18.3959L10 16.9999L8.00001 18.9999L16.4291 24.9498C18.0243 23.1028 19.8571 21.0141 21.7437 18.9572L18.4244 18.4039L18.4143 18.4141L18.376 18.3959ZM6.00003 32.9999L11 34.9999L10.5 37.4999L13 36.9999L15 41.9999L17 39.9999L16 34.9999C16.5479 34.4976 17.5409 33.651 18.8192 32.561L18.8201 32.5602C19.6777 31.8289 20.6637 30.9881 21.7299 30.0684C23.7895 28.2917 26.1485 26.2204 28.4593 24.0744C35.044 17.959 41.2375 11.2373 39 8.99988C35.5709 5.57073 21.6084 21.9454 15.4393 29.1803C14.3491 30.4588 13.5023 31.4519 13 31.9999L8.00003 30.9999L6.00003 32.9999Z"
        />
    </MaterialIconWrapper>
);

export const IconHolidaysXL = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 48 48"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.1441 8.63914C33.0755 9.88484 36.303 12.3043 38.6673 15.1336C42.3399 19.5306 43.7441 24.4574 42.6249 29.0083C42.6239 29.0133 42.6209 29.0183 42.6199 29.0233C42.5899 29.1403 42.5379 29.2463 42.4719 29.3402C42.462 29.355 42.4494 29.3674 42.4368 29.3799C42.4264 29.3902 42.4159 29.4005 42.4069 29.4122C42.3469 29.4812 42.2828 29.5432 42.2078 29.5942C42.2011 29.5985 42.1957 29.6045 42.1904 29.6104C42.1847 29.6167 42.1791 29.623 42.1718 29.6272C42.1437 29.6447 42.1136 29.6559 42.0839 29.6669C42.0714 29.6715 42.059 29.6761 42.0468 29.6812C42.0362 29.6858 42.0259 29.6907 42.0157 29.6955C41.9951 29.7052 41.9749 29.7148 41.9528 29.7221C41.8548 29.7521 41.7558 29.7721 41.6548 29.7721C41.5757 29.7721 41.4957 29.7631 41.4147 29.7431C41.4133 29.7431 41.4123 29.7426 41.4111 29.7419C41.4107 29.7417 41.4103 29.7414 41.4097 29.7411C41.2967 29.7121 41.1927 29.6592 41.0947 29.5922C41.0717 29.5772 41.0487 29.5612 41.0277 29.5432C40.9406 29.4732 40.8606 29.3932 40.7996 29.2912C40.7986 29.2912 40.7986 29.2902 40.7986 29.2902C39.7615 27.5777 38.1222 26.3729 36.181 25.8961C34.2417 25.4182 32.2304 25.7271 30.5171 26.7628C30.5004 26.7732 30.4823 26.7783 30.4641 26.7834C30.4507 26.7871 30.4372 26.7909 30.4241 26.7968C30.3641 26.8258 30.3021 26.8478 30.2371 26.8648C30.2294 26.8666 30.2221 26.8697 30.2148 26.8727C30.2059 26.8764 30.1969 26.8802 30.1871 26.8818C30.1561 26.8888 30.1261 26.8918 30.0931 26.8948C30.0802 26.8961 30.0676 26.8985 30.055 26.9009C30.0371 26.9044 30.0192 26.9078 30.0011 26.9078C29.927 26.9078 29.856 26.8958 29.785 26.8798C29.7805 26.8788 29.7759 26.8786 29.7713 26.8783C29.7667 26.8781 29.762 26.8778 29.757 26.8768C29.648 26.8498 29.546 26.7988 29.452 26.7359C29.443 26.7299 29.435 26.7239 29.427 26.7179L29.4268 26.7178C29.4129 26.7078 29.3989 26.6978 29.385 26.6869H29.384C29.293 26.6149 29.2089 26.5319 29.1439 26.4259C28.2378 24.9293 26.8706 23.8195 25.2454 23.2457C25.2436 23.2551 25.2436 23.2646 25.2436 23.274C25.2436 23.2856 25.2437 23.2971 25.2404 23.3087L21.1438 37.6373C22.0779 37.9422 23.009 38.2681 23.9362 38.596L23.9389 38.597C29.0898 40.4193 34.4136 42.3027 39.5544 39.7098C40.0475 39.4608 40.6486 39.6598 40.8976 40.1527C41.1467 40.6456 40.9487 41.2464 40.4556 41.4954C38.3013 42.5801 36.17 43 34.0626 43C30.3944 43.001 26.8001 41.7296 23.2786 40.484L23.2691 40.4806C17.0732 38.2891 11.7194 36.3966 6.70067 41.3164C6.30561 41.7023 5.67052 41.6973 5.28646 41.3024C4.8994 40.9085 4.9054 40.2746 5.29946 39.8887C9.73911 35.5398 14.4898 35.7447 19.2295 37.0534L23.2931 22.8408C21.7539 22.7238 20.2166 23.0797 18.8694 23.8945C18.8684 23.8945 18.8674 23.8948 18.8666 23.8951C18.8657 23.8955 18.8649 23.896 18.8644 23.8965L18.8624 23.8975C18.8509 23.9044 18.8388 23.9077 18.8267 23.9109C18.8178 23.9133 18.8089 23.9157 18.8004 23.9195C18.6964 23.9735 18.5864 24.0115 18.4664 24.0255C18.4622 24.026 18.4581 24.0266 18.4538 24.0273C18.4488 24.0281 18.4437 24.029 18.4384 24.0295C18.426 24.0307 18.4139 24.0328 18.4017 24.035C18.3832 24.0382 18.3646 24.0415 18.3454 24.0415C18.2733 24.0415 18.2013 24.0305 18.1293 24.0145C18.1253 24.0135 18.121 24.0132 18.1166 24.013C18.1122 24.0127 18.1078 24.0125 18.1033 24.0115C17.9943 23.9835 17.8913 23.9325 17.7963 23.8695C17.792 23.8671 17.7881 23.8639 17.7842 23.8607C17.7816 23.8586 17.779 23.8565 17.7763 23.8545C17.7549 23.8399 17.7367 23.8221 17.7183 23.8041C17.7091 23.7952 17.6999 23.7862 17.6903 23.7776C17.6153 23.7146 17.5432 23.6486 17.4892 23.5606C16.4531 21.848 14.8128 20.6433 12.8726 20.1664C10.9343 19.6885 8.92599 19.9954 7.21474 21.0292C7.10172 21.0982 6.97571 21.1442 6.84169 21.1652C6.72967 21.1812 6.61765 21.1712 6.50764 21.1512C6.49859 21.1493 6.48976 21.1496 6.48095 21.15C6.47126 21.1504 6.46158 21.1508 6.45163 21.1482C6.43525 21.1444 6.42185 21.1367 6.40851 21.129C6.3974 21.1226 6.38634 21.1163 6.37362 21.1122C6.2776 21.0802 6.18259 21.0432 6.09958 20.9832C5.99856 20.9082 5.91455 20.8143 5.84754 20.7093C5.84617 20.707 5.84396 20.7051 5.84168 20.7032C5.83897 20.7009 5.83617 20.6985 5.83454 20.6953C5.83368 20.6936 5.83338 20.6919 5.83307 20.6901C5.83266 20.6879 5.83225 20.6856 5.83054 20.6833C5.76653 20.5743 5.72252 20.4553 5.70352 20.3294C5.68352 20.1974 5.68852 20.0644 5.72052 19.9365C6.83969 15.3855 10.3722 11.6714 15.664 9.47994C19.4125 7.92631 23.8622 7.29146 27.1596 7.77634C27.0586 7.5374 27.0036 7.27446 27.0036 6.99953C27.0036 5.89479 27.8987 5 29.0039 5C30.1081 5 31.0042 5.89479 31.0042 6.99953C31.0042 7.67937 30.6632 8.27822 30.1441 8.63914ZM17.9163 20.8622C19.0175 17.2611 20.6277 14.0119 22.546 11.5724C23.1551 10.8006 23.7651 10.1538 24.3652 9.61291C22.0449 9.66889 19.2265 10.1678 16.4301 11.3265C14.0947 12.2943 10.2622 14.4138 8.40491 18.3448C9.99915 17.873 11.6924 17.817 13.3496 18.2249C15.1189 18.6598 16.6851 19.5775 17.9163 20.8622ZM25.0043 21.0892C26.7226 21.5111 28.2498 22.3909 29.464 23.6186C31.0112 15.1936 28.6269 10.1578 27.7627 9.91484C27.7607 9.91384 27.7577 9.91284 27.7547 9.91184C27.7537 9.91184 27.7507 9.91184 27.7487 9.91084C26.8786 9.72688 22.423 13.0821 19.8836 21.2601C21.5288 20.7373 23.2871 20.6663 25.0043 21.0892ZM36.659 23.9535C38.3153 24.3614 39.7925 25.1952 40.9857 26.3539C41.1637 22.009 38.7513 18.3548 37.1311 16.4153C35.1908 14.0918 32.9245 12.3433 30.8952 11.2185C31.1772 11.9753 31.4193 12.8321 31.5993 13.7979C32.1694 16.8492 32.0874 20.4743 31.3923 24.1755C33.0795 23.6086 34.8928 23.5206 36.659 23.9535Z"
        />
    </MaterialIconWrapper>
);

export const IconLoungeXL = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 48 48"
    >
        <rect width="48" height="48" fill="white" fillOpacity="0.01" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.9871 37.4899C26.5754 36.8638 26.4868 36.2151 26.4868 35.488H14.5132C14.5132 36.2123 14.419 36.8724 14.0129 37.4899C13.4784 38.3029 12.4812 38.9601 10.807 38.96C9.13447 38.9599 8.10003 38.308 7.50239 37.5506C7.14952 37.1034 6.89096 36.5534 6.81579 35.9817V27.3703C5.31462 26.5801 4.25 25.097 4.25 23.3352C4.25 20.8946 5.83461 19.1055 7.7129 18.4264C7.81456 17.482 8.15896 15.4292 9.38393 13.3422C11.063 10.4815 14.3322 7.71002 20.5001 7.71002C25.9521 7.71002 29.1391 9.87537 30.9652 12.3537C30.508 12.7607 30.22 13.3537 30.22 14.014V14.3575C30.196 14.3153 30.1716 14.273 30.1468 14.2307C28.7688 11.8831 26.0511 9.44615 20.5001 9.44615C14.9492 9.44615 12.2314 11.8831 10.8534 14.2307C9.98637 15.708 9.62433 17.2051 9.47843 18.1277C12.3081 18.1848 14.5132 20.748 14.5132 23.3352V25.0713H26.4868V23.3352C26.4868 21.1255 28.3584 18.8918 30.4429 18.2869C30.641 18.8833 30.9636 19.4225 31.3799 19.8741C29.7525 20.0258 28.1973 21.695 28.1974 23.3351V35.488C28.1974 36.7992 29.0526 37.2242 30.3355 37.2242C31.6184 37.2242 32.4737 36.8727 32.4737 35.488V31.4791L32.5002 31.4792H34.1786C34.1751 33.5917 34.1725 35.3123 34.177 35.7118C34.1842 36.3561 33.834 37.1242 33.4976 37.5506C32.9 38.308 31.8655 38.9599 30.193 38.96C28.5188 38.9601 27.5216 38.3029 26.9871 37.4899ZM26.4868 30.2797V26.8074H14.5132V30.2797H26.4868ZM14.5132 33.7519H26.4868V32.0158H14.5132V33.7519ZM12.8026 35.488V23.3351C12.8027 21.615 11.2526 19.8627 9.38169 19.8629C7.70045 19.8631 5.96053 21.2717 5.96053 23.3352C5.96053 24.8922 7.23354 25.7439 8.52632 26.1817V35.488C8.52632 36.7994 9.38158 37.2241 10.6645 37.2242C11.9474 37.2242 12.8026 36.7992 12.8026 35.488Z"
            fill="#A3B5C9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33.8857 14.0112C33.8857 13.6125 34.2089 13.2892 34.6076 13.2892C35.0063 13.2892 35.3295 13.6125 35.3295 14.0112V16.9017C35.3295 17.3004 35.0063 17.6236 34.6076 17.6236C34.2089 17.6236 33.8857 17.3004 33.8857 16.9017V14.0112Z"
            fill="#A3B5C9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.0514 19.0673C36.0514 18.5306 36.1368 17.7333 36.2878 16.7268C36.3286 16.4549 36.3736 16.1719 36.4222 15.8805C36.502 15.4016 36.5874 14.9232 36.6729 14.4675C36.7242 14.1937 36.7642 13.9879 36.7873 13.8724C36.8548 13.535 37.1511 13.2921 37.4952 13.2921H41.8267C42.1708 13.2921 42.4671 13.535 42.5345 13.8724C42.5576 13.9879 42.5977 14.1937 42.649 14.4675C42.7344 14.9232 42.8199 15.4016 42.8997 15.8805C42.9483 16.1719 42.9933 16.4549 43.0341 16.7268C43.185 17.7333 43.2705 18.5306 43.2705 19.0673C43.2705 20.8135 42.0303 22.2702 40.3828 22.6046V24.8418H41.8267C42.2254 24.8418 42.5486 25.165 42.5486 25.5637C42.5486 25.9624 42.2254 26.2856 41.8267 26.2856H39.7336C39.7097 26.288 39.6855 26.2892 39.6609 26.2892C39.6364 26.2892 39.6122 26.288 39.5883 26.2856H37.4952C37.0965 26.2856 36.7733 25.9624 36.7733 25.5637C36.7733 25.165 37.0965 24.8418 37.4952 24.8418H38.939V22.5976C37.319 22.2395 36.0514 20.7177 36.0514 19.0673ZM37.7157 16.941C37.5748 17.8803 37.4952 18.6226 37.4952 19.0673C37.4952 20.1701 38.5211 21.233 39.6609 21.233C40.8569 21.233 41.8267 20.2633 41.8267 19.0673C41.8267 18.6226 41.7471 17.8803 41.6062 16.941C41.5667 16.6772 41.5229 16.4018 41.4755 16.1179C41.3976 15.6501 41.314 15.1819 41.2304 14.7359H38.0915C38.0079 15.1819 37.9243 15.6501 37.8464 16.1179C37.799 16.4018 37.7552 16.6772 37.7157 16.941Z"
            fill="#A3B5C9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.3295 19.0673C35.3295 18.6686 35.0063 18.3454 34.6076 18.3454C33.8094 18.3454 33.1638 17.6998 33.1638 16.9016V14.014C33.1638 13.6153 32.8406 13.2921 32.4419 13.2921C32.0432 13.2921 31.72 13.6153 31.72 14.014V16.9016C31.72 18.2479 32.6398 19.3781 33.8857 19.6984V25.5673C33.8857 25.966 34.2089 26.2892 34.6076 26.2892C35.0063 26.2892 35.3295 25.966 35.3295 25.5673V19.0673Z"
            fill="#A3B5C9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M31.7502 28.7292C31.7502 28.315 32.086 27.9792 32.5002 27.9792H43.0002C43.4145 27.9792 43.7502 28.315 43.7502 28.7292C43.7502 29.1435 43.4145 29.4792 43.0002 29.4792H38.3127V38.9793H40.094C40.4564 38.9793 40.7502 39.2731 40.7502 39.6356C40.7502 39.998 40.4564 40.2918 40.094 40.2918H35.4065C35.0441 40.2918 34.7502 39.998 34.7502 39.6356C34.7502 39.2731 35.0441 38.9793 35.4065 38.9793H37.0002V29.4792H32.5002C32.086 29.4792 31.7502 29.1435 31.7502 28.7292Z"
            fill="#A3B5C9"
        />
    </MaterialIconWrapper>
);

export const IconMessageError = (props: {
    className?: string;
    style: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 144 144"
    >
        <path d="M72,15 C103.480231,15 129,40.5197693 129,72 C129,103.480231 103.480231,129 72,129 C40.5197693,129 15,103.480231 15,72 C15,40.5197693 40.5197693,15 72,15 Z M72,21 C43.8334778,21 21,43.8334778 21,72 C21,100.166522 43.8334778,123 72,123 C100.166522,123 123,100.166522 123,72 C123,43.8334778 100.166522,21 72,21 Z M50.1213203,45.8786797 L72,67.757 L93.8786797,45.8786797 C95.0502525,44.7071068 96.9497475,44.7071068 98.1213203,45.8786797 C99.2928932,47.0502525 99.2928932,48.9497475 98.1213203,50.1213203 L76.243,72 L98.1213203,93.8786797 C99.2928932,95.0502525 99.2928932,96.9497475 98.1213203,98.1213203 C96.9497475,99.2928932 95.0502525,99.2928932 93.8786797,98.1213203 L72,76.243 L50.1213203,98.1213203 C48.9497475,99.2928932 47.0502525,99.2928932 45.8786797,98.1213203 C44.7071068,96.9497475 44.7071068,95.0502525 45.8786797,93.8786797 L67.757,72 L45.8786797,50.1213203 C44.7071068,48.9497475 44.7071068,47.0502525 45.8786797,45.8786797 C47.0502525,44.7071068 48.9497475,44.7071068 50.1213203,45.8786797 Z" />
    </MaterialIconWrapper>
);

export const IconCheckmarkCircle = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper className={props.className} style={props.style}>
        <path d="M12,0.9988 C18.0722847,0.9988 23,5.92651525 23,11.9988 C23,18.0717549 18.0726146,22.9988 12,22.9988 C5.92738538,22.9988 1,18.0717549 1,11.9988 C1,5.92651525 5.92771525,0.9988 12,0.9988 Z M12,2.9988 C7.03228475,2.9988 3,7.03108475 3,11.9988 C3,16.9671545 7.03192396,20.9988 12,20.9988 C16.968076,20.9988 21,16.9671545 21,11.9988 C21,7.03108475 16.9677153,2.9988 12,2.9988 Z M15.7360576,7.82074401 C16.0857952,7.39330742 16.7158194,7.33031997 17.143256,7.68005759 C17.5706926,8.02979521 17.63368,8.6598194 17.2839424,9.08725599 L17.2839424,9.08725599 L11.5989424,16.035256 C11.2243002,16.49313 10.5362265,16.52744 10.1178932,16.1091068 L10.1178932,16.1091068 L6.95989322,12.9511068 C6.56936893,12.5605825 6.56936893,11.9274175 6.95989322,11.5368932 C7.35041751,11.1463689 7.98358249,11.1463689 8.37410678,11.5368932 L8.37410678,11.5368932 L10.750781,13.9135675 Z" />
    </MaterialIconWrapper>
);

export const IconSettings = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
    >
        <path d="M7.45454545,12 C7.45454545,9.48974114 9.48974114,7.45454545 12,7.45454545 C14.5102589,7.45454545 16.5454545,9.48974114 16.5454545,12 C16.5454545,14.5102589 14.5102589,16.5454545 12,16.5454545 C9.48974114,16.5454545 7.45454545,14.5102589 7.45454545,12 Z M9.27272727,12 C9.27272727,13.5061048 10.4938952,14.7272727 12,14.7272727 C13.5061048,14.7272727 14.7272727,13.5061048 14.7272727,12 C14.7272727,10.4938952 13.5061048,9.27272727 12,9.27272727 C10.4938952,9.27272727 9.27272727,10.4938952 9.27272727,12 Z M9.14464768,6.29540026 C8.63749994,6.50381714 8.06475406,6.48433914 7.57127952,6.24021445 L6.97036273,5.94111308 C6.77790754,5.84585422 6.54561009,5.88399815 6.39373344,6.03555162 L6.03623438,6.39304995 C5.88399815,6.54561009 5.84585422,6.77790754 5.94021445,6.96855225 L6.24119949,7.57326463 C6.48478479,8.06565492 6.50383439,8.63946593 6.29374073,9.14646812 L5.94802182,9.98256134 C5.73780442,10.4898628 5.31921431,10.8811032 4.79531852,11.059219 L4.15984472,11.2722502 C3.95540008,11.3412624 3.81818182,11.5322191 3.81818182,11.7472727 L3.81818182,12.2527273 C3.81818182,12.4677809 3.95540008,12.6587376 4.15915045,12.7275158 L4.79642685,12.9420624 C5.31788516,13.1176201 5.73748056,13.5102647 5.94815252,14.0186633 L6.29347636,14.8528932 C6.50383439,15.3605341 6.48478479,15.9343451 6.24021445,16.4287205 L5.94111308,17.0296373 C5.84585422,17.2220925 5.88399815,17.4543899 6.03636584,17.6070818 L6.39236427,17.9639912 C6.54507781,18.1160563 6.77783344,18.1541825 6.96855225,18.0597856 L7.57326463,17.7588005 C8.06565492,17.5152152 8.63946593,17.4961656 9.1467912,17.7063929 L9.98165225,18.0519782 C10.4897353,18.2625194 10.8823799,18.6821148 11.0579388,19.2035768 L11.2722502,19.8401553 C11.3412624,20.0445999 11.5322191,20.1818182 11.7472727,20.1818182 L12.2527273,20.1818182 C12.4677809,20.1818182 12.6587376,20.0445999 12.7275158,19.8408496 L12.9420624,19.2035731 C13.1174303,18.6826784 13.5095288,18.2631702 14.0180773,18.0517138 L14.8518733,17.706947 C15.3590414,17.4960627 15.934196,17.5151414 16.4287205,17.7597856 L17.0296373,18.0588869 C17.2221666,18.1541825 17.4549222,18.1160563 17.6054523,17.9661727 L17.9637656,17.6069501 C18.1160019,17.4543899 18.1541458,17.2220925 18.0597856,17.0314478 L17.7588005,16.4267354 C17.5152152,15.9343451 17.4961656,15.3605341 17.7063929,14.8532088 L18.0519782,14.0183477 C18.2625194,13.5102647 18.6821148,13.1176201 19.2035768,12.9420612 L19.8401553,12.7277498 C20.0445999,12.6587376 20.1818182,12.4677809 20.1818182,12.2527273 L20.1818182,11.7472727 C20.1818182,11.5322191 20.0445999,11.3412624 19.8419542,11.2728554 L19.2009975,11.0579752 C18.6807857,10.8811032 18.2621956,10.4898628 18.0517138,9.98192267 L17.7065236,9.1471068 C17.4961656,8.63946593 17.5152152,8.06565492 17.7597856,7.57127952 L18.0588869,6.97036273 C18.1541458,6.77790754 18.1160019,6.54561009 17.9644484,6.39373344 L17.6069501,6.03623438 C17.4543899,5.88399815 17.2220925,5.84585422 17.0314478,5.94021445 L16.4267354,6.24119949 C15.9350987,6.484412 15.3610106,6.50391985 14.8527517,6.29432678 L14.0164188,5.94759846 C13.5095288,5.73682979 13.1174303,5.3173216 12.9420612,4.79642317 L12.7277498,4.15984472 C12.6587376,3.95540008 12.4677809,3.81818182 12.2527273,3.81818182 L11.7472727,3.81818182 C11.5322191,3.81818182 11.3412624,3.95540008 11.2724842,4.15915045 L11.0579376,4.79642685 C10.8824107,5.31779386 10.4898728,5.73733362 9.98191913,5.9479112 L9.14464768,6.29540026 Z M9.28515537,4.2685347 C9.30915856,4.25858803 9.32695595,4.23956903 9.33478848,4.2163041 L9.54956798,3.5783371 C9.86795706,2.63512816 10.7518187,2 11.7472727,2 L12.2527273,2 C13.2481813,2 14.1320429,2.63512816 14.4506661,3.57903137 L14.6652103,4.21630042 C14.6730967,4.23972552 14.6911795,4.25907235 14.713612,4.26840049 L15.547481,4.61410855 C15.5704027,4.62356081 15.5981171,4.62261906 15.6185522,4.61251283 L16.22309,4.31161419 C17.1141301,3.87057924 18.1873167,4.04679965 18.8919153,4.74990293 L19.2507798,5.10876824 C19.9532003,5.81268326 20.1294208,6.88586988 19.6874872,7.77872048 L19.3884722,8.37946265 C19.3774687,8.40170553 19.3765991,8.42789725 19.386468,8.45171369 L19.7316582,9.28652957 C19.7412849,9.30976089 19.7606448,9.32785589 19.7825912,9.33532647 L20.4216629,9.54956798 C21.3648718,9.86795706 22,10.7518187 22,11.7472727 L22,12.2527273 C22,13.2481813 21.3648718,14.1320429 20.4209686,14.4506661 L19.7836996,14.6652103 C19.760431,14.673044 19.741412,14.6908414 19.7317889,14.7140639 L19.3862036,15.548925 C19.3765991,15.5721028 19.3774687,15.5982945 19.3874872,15.6185522 L19.6883858,16.22309 C20.1294208,17.1141301 19.9532003,18.1873167 19.2509113,18.8911 L18.8905461,19.2523724 C18.1864708,19.953458 17.1136601,20.1291881 16.2212795,19.6874872 L15.6205374,19.3884722 C15.5984915,19.3775661 15.5718268,19.3766816 15.5482863,19.386468 L14.7144903,19.7312348 C14.6911795,19.7409277 14.6730967,19.7602745 14.6652115,19.7836959 L14.450432,20.4216629 C14.1320429,21.3648718 13.2481813,22 12.2527273,22 L11.7472727,22 C10.7518187,22 9.86795706,21.3648718 9.54933394,20.4209686 L9.33478972,19.7836996 C9.32695595,19.760431 9.30915856,19.741412 9.28593607,19.7317889 L8.45107502,19.3862036 C8.42789725,19.3765991 8.40170553,19.3774687 8.38144775,19.3874872 L7.77691,19.6883858 C6.88633992,20.1291881 5.81352923,19.953458 5.10727053,19.2501909 L4.74922016,18.8912318 C4.04679965,18.1873167 3.87057924,17.1141301 4.31251283,16.2212795 L4.61152778,15.6205374 C4.62253133,15.5982945 4.62340085,15.5721028 4.61366566,15.5486094 L4.26834182,14.7143795 C4.25858803,14.6908414 4.23956903,14.673044 4.2163041,14.6652115 L3.5783371,14.450432 C2.63512816,14.1320429 2,13.2481813 2,12.2527273 L2,11.7472727 C2,10.7518187 2.63512816,9.86795706 3.58013603,9.54896283 L4.21372479,9.33657023 C4.2393552,9.32785589 4.25871514,9.30976089 4.26807745,9.28716824 L4.61379637,8.45107502 C4.62340085,8.42789725 4.62253133,8.40170553 4.61251283,8.38144775 L4.31161419,7.77691 C3.87057924,6.88586988 4.04679965,5.81268326 4.74990293,5.10808474 L5.10876824,4.74922016 C5.81268326,4.04679965 6.88586988,3.87057924 7.77872048,4.31251283 L8.37946265,4.61152778 C8.40207927,4.62271622 8.42931786,4.62364255 8.45060992,4.61489834 L9.28515537,4.2685347 Z" />
    </MaterialIconWrapper>
);

export const IconPen = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m73 439l91 0-91-91z m30-122l245-244 91 91-244 245z" />
    </MaterialIconWrapper>
);

export const IconTimes = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
    >
        <path d="M5.29289322,5.32399322 C5.68341751,4.93346893 6.31658249,4.93346893 6.70710678,5.32399322 L6.70710678,5.32399322 L12,10.6161 L17.2928932,5.32399322 C17.6533772,4.96350926 18.2206082,4.93577972 18.6128994,5.24080461 L18.7071068,5.32399322 C19.0976311,5.71451751 19.0976311,6.34768249 18.7071068,6.73820678 L18.7071068,6.73820678 L13.415,12.0311 L18.7071068,17.3239932 C19.0675907,17.6844772 19.0953203,18.2517082 18.7902954,18.6439994 L18.7071068,18.7382068 C18.3165825,19.1287311 17.6834175,19.1287311 17.2928932,18.7382068 L17.2928932,18.7382068 L12,13.4461 L6.70710678,18.7382068 C6.34662282,19.0986907 5.77939176,19.1264203 5.38710056,18.8213954 L5.29289322,18.7382068 C4.90236893,18.3476825 4.90236893,17.7145175 5.29289322,17.3239932 L5.29289322,17.3239932 L10.585,12.0311 L5.29289322,6.73820678 C4.93240926,6.37772282 4.90467972,5.81049176 5.20970461,5.41820056 Z" />
    </MaterialIconWrapper>
);

export const IconInfoCircleHollow = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 16 16"
    >
        <path
            d="M8,0.642466667 C12.0481898,0.642466667 15.3333333,3.92761017 15.3333333,7.9758 C15.3333333,12.0244366 12.0484097,15.3091333 8,15.3091333 C3.95159025,15.3091333 0.666666667,12.0244366 0.666666667,7.9758 C0.666666667,3.92761017 3.95181017,0.642466667 8,0.642466667 Z M8,1.9758 C4.68818983,1.9758 2,4.66398983 2,7.9758 C2,11.2880363 4.68794931,13.9758 8,13.9758 C11.3120507,13.9758 14,11.2880363 14,7.9758 C14,4.66398983 11.3118102,1.9758 8,1.9758 Z M8,6.64246667 C8.36818983,6.64246667 8.66666667,6.9409435 8.66666667,7.30913333 L8.66666667,7.30913333 L8.66666667,11.3091333 C8.66666667,11.6773232 8.36818983,11.9758 8,11.9758 C7.63181017,11.9758 7.33333333,11.6773232 7.33333333,11.3091333 L7.33333333,11.3091333 L7.33333333,7.30913333 C7.33333333,6.9409435 7.63181017,6.64246667 8,6.64246667 Z M8,3.97386667 C8.368,3.97386667 8.66666667,4.27186667 8.66666667,4.64053333 C8.66666667,4.97507879 8.41983471,5.25232397 8.09847233,5.29996734 L8,5.3072 C7.632,5.3072 7.33333333,5.00853333 7.33333333,4.64053333 C7.33333333,4.27186667 7.632,3.97386667 8,3.97386667 Z"
            id="path-1"
        />
    </MaterialIconWrapper>
);

export const IconCopy = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper className={props.className} style={props.style}>
        <path d="M10,18 C10.5522847,18 11,18.4477153 11,19 C11,19.5522847 10.5522847,20 10,20 C9.44771525,20 9,19.5522847 9,19 C9,18.4477153 9.44771525,18 10,18 Z M13,18 C13.5522847,18 14,18.4477153 14,19 C14,19.5522847 13.5522847,20 13,20 C12.4477153,20 12,19.5522847 12,19 C12,18.4477153 12.4477153,18 13,18 Z M19,18 C19.5522847,18 20,18.4477153 20,19 C20,19.5522847 19.5522847,20 19,20 C18.4477153,20 18,19.5522847 18,19 C18,18.4477153 18.4477153,18 19,18 Z M16,18 C16.5522847,18 17,18.4477153 17,19 C17,19.5522847 16.5522847,20 16,20 C15.4477153,20 15,19.5522847 15,19 C15,18.4477153 15.4477153,18 16,18 Z M16,4 C16.5522847,4 17,4.44771525 17,5 L17,8 L15,8 L15,6 L6,6 L6,15 L8,15 L8,17 L5,17 C4.44771525,17 4,16.5522847 4,16 L4,5 C4,4.44771525 4.44771525,4 5,4 L16,4 Z M10,15 C10.5522847,15 11,15.4477153 11,16 C11,16.5522847 10.5522847,17 10,17 C9.44771525,17 9,16.5522847 9,16 C9,15.4477153 9.44771525,15 10,15 Z M19,15 C19.5522847,15 20,15.4477153 20,16 C20,16.5522847 19.5522847,17 19,17 C18.4477153,17 18,16.5522847 18,16 C18,15.4477153 18.4477153,15 19,15 Z M10,12 C10.5522847,12 11,12.4477153 11,13 C11,13.5522847 10.5522847,14 10,14 C9.44771525,14 9,13.5522847 9,13 C9,12.4477153 9.44771525,12 10,12 Z M19,12 C19.5522847,12 20,12.4477153 20,13 C20,13.5522847 19.5522847,14 19,14 C18.4477153,14 18,13.5522847 18,13 C18,12.4477153 18.4477153,12 19,12 Z M10,9 C10.5522847,9 11,9.44771525 11,10 C11,10.5522847 10.5522847,11 10,11 C9.44771525,11 9,10.5522847 9,10 C9,9.44771525 9.44771525,9 10,9 Z M19,9 C19.5522847,9 20,9.44771525 20,10 C20,10.5522847 19.5522847,11 19,11 C18.4477153,11 18,10.5522847 18,10 C18,9.44771525 18.4477153,9 19,9 Z M13,9 C13.5522847,9 14,9.44771525 14,10 C14,10.5522847 13.5522847,11 13,11 C12.4477153,11 12,10.5522847 12,10 C12,9.44771525 12.4477153,9 13,9 Z M16,9 C16.5522847,9 17,9.44771525 17,10 C17,10.5522847 16.5522847,11 16,11 C15.4477153,11 15,10.5522847 15,10 C15,9.44771525 15.4477153,9 16,9 Z" />
    </MaterialIconWrapper>
);

export const IconCopy2 = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper className={props.className} style={props.style}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 18V20C16 21.6569 14.6569 23 13 23H6C4.34315 23 3 21.6569 3 20V9C3 7.34315 4.34315 6 6 6H8V4C8 2.34315 9.34315 1 11 1H15.2149C16.0354 1 16.8201 1.33607 17.3863 1.92995L20.1714 4.85142C20.7033 5.40935 21 6.15062 21 6.92146V15C21 16.6569 19.6569 18 18 18H16ZM11 3C10.4477 3 10 3.44772 10 4V6H10.2149C11.0354 6 11.8201 6.33607 12.3863 6.92995L15.1714 9.85142C15.7033 10.4094 16 11.1506 16 11.9215V16H18C18.5523 16 19 15.5523 19 15V8.19231H15.05C14.4977 8.19231 14.05 7.74459 14.05 7.19231V3H11ZM16.05 6.19231H18.6865L16.05 3.42676V6.19231ZM5 9V20C5 20.5523 5.44772 21 6 21H13C13.5523 21 14 20.5523 14 20V13.1923H10.05C9.49772 13.1923 9.05 12.7446 9.05 12.1923V8H6C5.44772 8 5 8.44772 5 9ZM11.05 11.1923H13.6865L11.05 8.42676V11.1923Z"
        />
    </MaterialIconWrapper>
);

export const IconMoreHorizontal = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper className={props.className} style={props.style}>
        <path d="M5,10 C6.1045695,10 7,10.8954305 7,12 C7,13.1045695 6.1045695,14 5,14 C3.8954305,14 3,13.1045695 3,12 C3,10.8954305 3.8954305,10 5,10 Z M12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 Z M19,10 C20.1045695,10 21,10.8954305 21,12 C21,13.1045695 20.1045695,14 19,14 C17.8954305,14 17,13.1045695 17,12 C17,10.8954305 17.8954305,10 19,10 Z" />
    </MaterialIconWrapper>
);

export const IconSID = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 512 512"
    >
        <path d="m165 213l-54 0c-2 0-4 2-4 4l0 143c0 1 2 3 4 3l54 0c2 0 3-2 3-3l0-143c1-2-1-4-3-4z m267-29c-10-17-25-31-44-41-19-10-41-15-65-15l-98 0c-2 0-3 2-3 4l0 228c0 1 1 3 3 3l95 0c25 0 47-5 67-15 19-10 34-23 45-41 11-18 16-39 16-61 0-24-5-44-16-62z m-55 97c-4 11-12 19-21 24-9 6-20 9-31 9l-39 0c-2 0-3-1-3-4l0-128c0-2 1-4 3-4l36 0c12 0 22 3 32 8 9 7 17 14 23 25 5 10 8 22 8 35 0 13-3 25-8 35z m-239-153c-17 0-31 14-31 31 0 18 14 32 31 32 17 0 32-14 32-32-1-17-15-31-32-31z" />
    </MaterialIconWrapper>
);

export const IconDownload = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
    >
        <path d="M21,13.035 C21.5522847,13.035 22,13.4827153 22,14.035 L22,14.035 L22,17.035 C22,18.6912847 20.6562847,20.035 19,20.035 L19,20.035 L5,20.035 C3.34371525,20.035 2,18.6912847 2,17.035 L2,17.035 L2,14.035 C2,13.4827153 2.44771525,13.035 3,13.035 C3.55228475,13.035 4,13.4827153 4,14.035 L4,14.035 L4,17.035 C4,17.5867153 4.44828475,18.035 5,18.035 L5,18.035 L19,18.035 C19.5517153,18.035 20,17.5867153 20,17.035 L20,17.035 L20,14.035 C20,13.4827153 20.4477153,13.035 21,13.035 Z M12,3.035 C12.5522847,3.035 13,3.48271525 13,4.035 L13,4.035 L13,11.62 L16.2928932,8.32789322 C16.6533772,7.96740926 17.2206082,7.93967972 17.6128994,8.24470461 L17.7071068,8.32789322 C18.0976311,8.71841751 18.0976311,9.35158249 17.7071068,9.74210678 L17.7071068,9.74210678 L12.7071068,14.7421068 C12.3165825,15.1326311 11.6834175,15.1326311 11.2928932,14.7421068 L11.2928932,14.7421068 L6.29289322,9.74210678 C5.90236893,9.35158249 5.90236893,8.71841751 6.29289322,8.32789322 C6.68341751,7.93736893 7.31658249,7.93736893 7.70710678,8.32789322 L7.70710678,8.32789322 L11,11.62 L11,4.035 C11,3.52216416 11.3860402,3.09949284 11.8833789,3.04172773 Z" />
    </MaterialIconWrapper>
);

export const IconTPPConnection = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={{
            width: 140,
            height: 140,
            fill: "currentcolor",
            ...props.style,
        }}
        viewBox="0 0 48 48"
    >
        <path d="M27.2688173,14.5994601 C26.8806036,14.9922815 26.2474497,14.9960168 25.8546283,14.6078032 C25.4618069,14.2195896 25.4580716,13.5864357 25.8462852,13.1936143 L28.1226981,10.8901825 C30.6108643,8.3700536 34.6509622,8.3700536 37.13845,10.889496 C39.6204601,13.3985413 39.6204601,17.4658568 37.1387894,19.9769828 L28.7870754,28.4278244 C26.717813,30.5241729 23.3575728,30.5241729 21.2883104,28.4278244 C20.9003337,28.0347691 20.9044506,27.4016176 21.2975059,27.0136408 C21.6905612,26.625664 22.3237128,26.629781 22.7116896,27.0228362 C23.9978534,28.3258357 26.0775323,28.3258357 27.3641198,27.0224074 L35.7162574,18.571137 C37.4278576,16.8392215 37.4278576,14.0259291 35.7159184,12.295342 C34.0108137,10.5683338 31.2510128,10.5683338 29.5455691,12.2956852 L27.2688173,14.5994601 Z M20.7311827,32.4007115 C21.1193964,32.0078901 21.7525503,32.0041548 22.1453717,32.3923684 C22.5381931,32.780582 22.5419284,33.413736 22.1537148,33.8065574 L19.8773019,36.1099892 C17.3891357,38.630118 13.3490378,38.630118 10.86155,36.1106757 C8.3795399,33.6016303 8.3795399,29.5343148 10.8612106,27.0231888 L19.2129247,18.5723472 C21.282187,16.4759987 24.6424272,16.4759987 26.7116896,18.5723472 C27.0996663,18.9654025 27.0955494,19.5985541 26.7024941,19.9865309 C26.3094388,20.3745076 25.6762872,20.3703907 25.2883104,19.9773354 C24.0021466,18.674336 21.9224677,18.674336 20.6358802,19.9777642 L12.2837426,28.4290347 C10.5721424,30.1609502 10.5721424,32.9742425 12.2840816,34.7048296 C13.9891863,36.4318379 16.7489872,36.4318379 18.4544309,34.7044865 L20.7311827,32.4007115 Z" />
    </MaterialIconWrapper>
);

export const IconVoucher = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={{ width: 138, height: 99, fill: "currentcolor", ...props.style }}
        viewBox="0 0 138 99"
    >
        <path d="M128.142857,0 C133.586807,0 138,4.43238098 138,9.9 L138,89.1 C138,94.567619 133.586807,99 128.142857,99 L9.85714286,99 C4.41319318,99 0,94.567619 0,89.1 L0,9.9 C0,4.43238098 4.41319318,0 9.85714286,0 L128.142857,0 Z M55.857,6.6 L9.85714286,6.6 C8.04249296,6.6 6.57142857,8.07746033 6.57142857,9.9 L6.571,46.2 L16.4285714,46.2 C18.2432213,46.2 19.7142857,47.6774603 19.7142857,49.5 C19.7142857,51.3225397 18.2432213,52.8 16.4285714,52.8 L6.571,52.8 L6.57142857,89.1 C6.57142857,90.9225397 8.04249296,92.4 9.85714286,92.4 L55.857,92.399 L55.8571429,69.3 C55.8571429,67.4774603 57.3282073,66 59.1428571,66 C60.957507,66 62.4285714,67.4774603 62.4285714,69.3 L62.428,92.399 L128.142857,92.4 C129.957507,92.4 131.428571,90.9225397 131.428571,89.1 L131.428,52.8 L101.857143,52.8 C100.042493,52.8 98.5714286,51.3225397 98.5714286,49.5 C98.5714286,47.6774603 100.042493,46.2 101.857143,46.2 L131.428,46.2 L131.428571,9.9 C131.428571,8.07746033 129.957507,6.6 128.142857,6.6 L62.428,6.6 L62.4285714,29.7 C62.4285714,31.5225397 60.957507,33 59.1428571,33 C57.3282073,33 55.8571429,31.5225397 55.8571429,29.7 L55.857,6.6 Z M78.8591537,29.7 C87.8420622,29.7 95.2877251,36.2432809 95.2877251,44.55 C95.2877251,52.8567191 87.8420622,59.4 78.8591537,59.4 L78.8591537,59.4 L72.3202937,59.3986327 C77.2014375,62.9157569 80.4388256,66.9524959 81.9727297,71.5518935 C82.5490771,73.2800659 81.6214032,75.1502797 79.9007121,75.7291329 C78.180021,76.3079861 76.3179033,75.3762789 75.741556,73.6481065 C73.9818249,68.3715688 68.5298367,63.652902 59.1412843,59.6681685 C49.7438224,63.6471059 44.2949174,68.3673453 42.5467585,73.6530426 C41.9747164,75.3826573 40.1149248,76.319039 38.3927976,75.7445098 C36.6706704,75.1699806 35.7383422,73.3021028 36.3103843,71.5724881 C37.835223,66.9620174 41.0692107,62.9185462 45.9518047,59.3991139 L39.4285714,59.4 C30.4456629,59.4 23,52.8567191 23,44.55 C23,36.2432809 30.4456629,29.7 39.4285714,29.7 C47.9069555,29.7 54.4374885,35.3832225 59.143876,46.2190424 C63.8502367,35.3832225 70.3807696,29.7 78.8591537,29.7 Z M39.4285714,36.3 C33.8942808,36.3 29.5714286,40.0989413 29.5714286,44.55 C29.5714286,49.0010587 33.8942808,52.8 39.4285714,52.8 L54.6596396,52.8 C50.7531108,41.5540658 45.6187529,36.3 39.4285714,36.3 Z M78.8591537,36.3 C72.6689722,36.3 67.5346143,41.5540658 63.6280855,52.8 L63.6280855,52.8 L78.8591537,52.8 C84.3934443,52.8 88.7162966,49.0010587 88.7162966,44.55 C88.7162966,40.0989413 84.3934443,36.3 78.8591537,36.3 Z" />
    </MaterialIconWrapper>
);

export const IconHelp = (props: {
    onClick?: () => void;
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 22 22"
        onClick={props.onClick}
    >
        <path d="M11,2 C6.02913374,2 2,6.02913374 2,11 C2,15.9702256 6.02949548,20 11,20 C15.9705045,20 20,15.9702256 20,11 C20,6.02913374 15.9708663,2 11,2 Z M11,0 C17.0754356,0 22,4.92456438 22,11 C22,17.0747642 17.0751051,22 11,22 C4.9248949,22 0,17.0747642 0,11 C0,4.92456438 4.92456438,0 11,0 Z M11,14.9959 C11.552,14.9959 12,15.4429 12,15.9959 C12,16.5084714 11.6137143,16.9313694 11.1165685,16.9891682 L11,16.9959 C10.448,16.9959 10,16.5479 10,15.9959 C10,15.4429 10.448,14.9959 11,14.9959 Z M7.80964986,7.85721691 C8.48808788,5.93017884 10.6011356,4.91667893 12.5272601,5.59479565 C14.01042,6.11568359 15.0026399,7.51884263 14.9999057,9.0893 C14.9999057,10.3137186 14.221947,11.2472621 13.0143958,11.9717929 C12.6631606,12.182534 12.3157587,12.3535608 11.9999,12.487353 L11.9999,12.487353 L11.9999,12.9963 C11.9999,13.5485847 11.5521847,13.9963 10.9999,13.9963 C10.4476153,13.9963 9.9999,13.5485847 9.9999,12.9963 L9.9999,12.9963 L9.9999,11.7893 C9.9999,11.3476918 10.2895682,10.9583689 10.7125521,10.8314737 C10.7794171,10.8114142 10.9158468,10.7646383 11.0972593,10.6920733 C11.4025482,10.5699578 11.7072394,10.423706 11.9854042,10.2568071 C12.652853,9.85633785 12.9999,9.43988139 12.9999015,9.08755632 C13.0011604,8.36561058 12.5452415,7.72086779 11.8638169,7.48155014 C10.9791415,7.17008903 10.0078802,7.63594376 9.69615014,8.52138309 C9.51274571,9.04232575 8.94175958,9.31595456 8.42081691,9.13255014 C7.89987425,8.94914571 7.62624544,8.37815958 7.80964986,7.85721691 Z" />
    </MaterialIconWrapper>
);

export const IconClear = (props: {
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper style={props.style} onClick={props.onClick}>
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </MaterialIconWrapper>
);

export const IconUser = (props: {
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m256 277c47 0 85-38 85-85 0-47-38-85-85-85-47 0-85 38-85 85 0 47 38 85 85 85z m0 43c-71 0-128-57-128-128 0-71 57-128 128-128 71 0 128 57 128 128 0 71-57 128-128 128z m-153 140c-7 10-20 12-30 5-10-6-12-20-5-29 41-59 111-95 188-95 77 0 146 36 188 95 7 9 5 23-5 29-10 7-23 5-30-5-33-47-90-76-153-76-63 0-120 29-153 76z" />
    </MaterialIconWrapper>
);
export const IconWarning = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper className={props.className} style={props.style}>
        <path d="M14.6280146,3.66877882 L22.2450575,17.517857 C23.3445079,19.5172666 21.8974119,21.9637 19.6158,21.9637 L4.3818,21.9637 C2.10015567,21.9637 0.654107747,19.5172382 1.75358543,17.5177788 L9.37070467,3.66856209 C10.5106952,1.5970793 13.4879048,1.5970793 14.6280146,3.66877882 Z M11.1230146,4.63262118 L3.50605754,18.481543 C3.1394696,19.148203 3.62149134,19.9637 4.3818,19.9637 L19.6158,19.9637 C20.3764312,19.9637 20.858975,19.1479204 20.4925854,18.4816212 L12.8757047,4.63283791 C12.4956952,3.9423207 11.5029048,3.9423207 11.1230146,4.63262118 Z M12,15.9608 C12.552,15.9608 13,16.4078 13,16.9608 C13,17.4733714 12.6137143,17.8962694 12.1165685,17.9540682 L12,17.9608 C11.448,17.9608 11,17.5128 11,16.9608 C11,16.4078 11.448,15.9608 12,15.9608 Z M11.999,7.9637 C12.5512847,7.9637 12.999,8.41141525 12.999,8.9637 L12.999,8.9637 L12.999,12.9637 C12.999,13.5159847 12.5512847,13.9637 11.999,13.9637 C11.4467153,13.9637 10.999,13.5159847 10.999,12.9637 L10.999,12.9637 L10.999,8.9637 C10.999,8.41141525 11.4467153,7.9637 11.999,7.9637 Z" />
    </MaterialIconWrapper>
);

// Alias
export const IconClose = IconClear;

export const IconPower = (props: {
    style?: React.CSSProperties;
    className?: string;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        style={props.style}
        onClick={props.onClick}
        className={props.className}
    >
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z" />
    </MaterialIconWrapper>
);

export const IconPlus = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
    >
        <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </MaterialIconWrapper>
);

export const IconMinus = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
    >
        <path d="M19 13H5v-2h14v2z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </MaterialIconWrapper>
);

export const IconArrowTopRight = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m384 158l-262 262c-9 9-22 9-30 0-9-8-9-21 0-30l262-262-183 0c-12 0-22-10-22-21 0-12 10-22 22-22l234 0c12 0 22 10 22 22l0 234c0 12-10 22-22 22-11 0-21-10-21-22z" />
    </MaterialIconWrapper>
);

export const IconArrowBottomLeft = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m128 354l262-262c9-9 22-9 30 0 9 8 9 21 0 30l-262 262 183 0c12 0 22 10 22 21 0 12-10 22-22 22l-234 0c-12 0-22-10-22-22l0-234c0-12 10-22 22-22 11 0 21 10 21 22z" />
    </MaterialIconWrapper>
);

export const IconArrowUpDown = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m320 397l0-162c0-12 10-22 21-22 12 0 22 10 22 22l0 162 49-49c8-9 21-9 30 0 8 8 8 22 0 30l-86 85c-8 9-21 9-30 0l-85-85c-8-8-8-22 0-30 8-9 22-9 30 0z m-128-281l0 161c0 12-10 22-21 22-12 0-22-10-22-22l0-161-49 49c-8 8-21 8-30 0-8-9-8-22 0-31l86-85c8-8 21-8 30 0l85 85c8 9 8 22 0 31-8 8-22 8-30 0z" />
    </MaterialIconWrapper>
);

export const IconPortfolio = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m404 219l26-39c7-10 20-12 30-6 10 7 12 20 6 30l-43 64c-8 12-26 13-35 1l-40-54-51 134c-7 18-32 18-39 0l-63-157-68 220c-6 19-34 20-41 0l-42-128c-4-11 2-23 13-27 11-4 24 2 27 14l22 64 66-213c6-20 32-21 40-2l65 162 44-119c6-16 27-19 37-5z" />
    </MaterialIconWrapper>
);

export const IconUmbrella = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m278 44c119 11 213 112 213 234 0 12-10 21-22 21l-10 0c-7 0-14-4-18-10-9-15-25-25-42-25-18 0-34 10-43 25-4 6-11 10-18 10l-21 0c-8 0-15-4-19-10-5-9-12-15-21-20l0 148c0 41-33 74-74 74-42 0-75-33-75-74 0-12 10-22 21-22 12 0 22 10 22 22 0 17 14 32 32 32 17 0 32-15 32-32l0-148c-9 5-16 11-21 20-4 6-11 10-19 10l-21 0c-7 0-14-4-18-10-9-15-25-25-43-25-17 0-33 10-42 25-4 6-11 10-18 10l-10 0c-12 0-22-9-22-21 0-123 94-223 214-234l0-1c0-11 10-21 22-21 11 0 21 10 21 21z m49 212c17-21 43-34 72-34 15 0 30 4 44 11-20-84-96-147-187-147-90 0-166 63-187 147 14-7 29-11 44-11 29 0 55 13 72 34 0 0 0 0 0 1 3 3 5 6 8 10l-19 11 0-21 21 0 0 21-18-11c2-4 5-7 7-10 0-1 1-1 1-1 17-21 43-34 71-34 28 0 54 13 71 34 0 0 1 0 1 1 2 3 5 6 7 10l-18 11 0-21 21 0 0 21-19-11c3-4 5-7 8-10 0-1 0-1 0-1z" />
    </MaterialIconWrapper>
);

export const IconUmbrellaWithPlusXL = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 96 96"
    >
        <rect width="96" height="96" fill="white" fillOpacity="0.01" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M50.0798 6.09977V8.23977C61.2176 9.03647 71.6358 14.0379 79.223 22.2304C86.8102 30.423 90.9988 41.1938 90.9398 52.3598V52.4598C90.9492 52.5996 90.9492 52.74 90.9398 52.8798C90.9034 53.0066 90.8496 53.1278 90.7798 53.2398C90.725 53.3534 90.658 53.4608 90.5798 53.5598L90.2798 53.8798H90.1798C90.0556 53.9534 89.9206 54.0074 89.7798 54.0398C89.6526 54.0942 89.5176 54.128 89.3798 54.1398H88.9998C88.8556 54.1278 88.714 54.094 88.5798 54.0398C88.4526 54.0142 88.3308 53.967 88.2198 53.8998L87.8798 53.6798L87.5798 53.3998C80.7798 43.3998 70.6198 43.3998 63.8198 53.3998L63.6598 53.5598H63.5598V53.6598L63.3998 53.8398L63.0598 53.9998H61.9398C61.867 54.0114 61.7926 54.0114 61.7198 53.9998H61.5998C61.4778 53.9672 61.3628 53.913 61.2598 53.8398C61.1968 53.797 61.1426 53.7428 61.0998 53.6798V53.5798H60.9998C60.9416 53.5316 60.888 53.478 60.8398 53.4198C59.602 51.5394 58.0028 49.9238 56.135 48.667C54.2672 47.4104 52.168 46.5378 49.9598 46.0998V79.4398C49.8302 82.6868 48.4492 85.7578 46.106 88.0092C43.763 90.2608 40.6394 91.5182 37.3898 91.5182C34.1402 91.5182 31.0166 90.2608 28.6736 88.0092C26.3304 85.7578 24.9494 82.6868 24.8198 79.4398C24.8198 78.8828 25.041 78.3486 25.4348 77.9548C25.8286 77.561 26.3628 77.3398 26.9198 77.3398C27.4768 77.3398 28.0108 77.561 28.4048 77.9548C28.7986 78.3486 29.0198 78.8828 29.0198 79.4398C29.0198 81.6622 29.9026 83.7938 31.4742 85.3654C33.0458 86.9368 35.1772 87.8198 37.3998 87.8198C39.6224 87.8198 41.7538 86.9368 43.3254 85.3654C44.897 83.7938 45.7798 81.6622 45.7798 79.4398V46.2398C43.5734 46.683 41.4764 47.5578 39.6094 48.814C37.7422 50.0702 36.1416 51.683 34.8998 53.5598L34.7198 53.7598H34.6198C34.5636 53.8362 34.4962 53.9036 34.4198 53.9598C34.1942 54.1014 33.9426 54.1966 33.6798 54.2398H32.7198C32.4544 54.1726 32.2036 54.0574 31.9798 53.8998C31.9092 53.8434 31.8484 53.7758 31.7998 53.6998L31.6998 53.5998V53.4998L31.5198 53.2998C25.5198 43.4398 13.9998 43.4398 7.3798 53.2998V53.3998C7.29032 53.5158 7.18984 53.623 7.0798 53.7198L6.7598 53.9398L6.3998 54.0998H5.1798L4.7998 53.9598L4.6998 53.8598C4.58374 53.7702 4.47658 53.6698 4.3798 53.5598C4.29526 53.4612 4.2215 53.354 4.1598 53.2398C4.0982 53.1236 4.04474 53.0034 3.9998 52.8798C3.9903 52.74 3.9903 52.5996 3.9998 52.4598V52.3598C3.99044 52.3204 3.99044 52.2792 3.9998 52.2398C3.9869 40.9252 8.33324 30.0404 16.136 21.8466C23.9388 13.6528 34.598 8.77979 45.8998 8.23977V6.09977C45.8998 5.54547 46.12 5.01387 46.512 4.62193C46.9038 4.22997 47.4354 4.00977 47.9898 4.00977C48.544 4.00977 49.0756 4.22997 49.4676 4.62193C49.8596 5.01387 50.0798 5.54547 50.0798 6.09977ZM56.076 43.6774C58.5978 44.8986 60.8288 46.6452 62.6198 48.7998C69.7198 40.3598 79.5198 39.4998 87.2998 46.1398C85.8668 36.7598 81.1264 28.2016 73.9352 22.0112C66.7438 15.8208 57.5756 12.4063 48.087 12.3846C38.5982 12.3628 29.4144 15.7353 22.1948 21.8926C14.9753 28.0502 10.1958 36.5864 8.7198 45.9598C16.2598 39.5398 26.7398 40.5198 33.5198 48.7398C35.2984 46.6106 37.509 44.8838 40.0052 43.6734C42.5016 42.4632 45.2266 41.7972 47.9998 41.7198C50.8008 41.7888 53.5544 42.4562 56.076 43.6774Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M77.9998 70H73.9998V66C73.9998 65.4696 73.789 64.9608 73.414 64.5858C73.039 64.2106 72.5302 64 71.9998 64C71.4694 64 70.9606 64.2106 70.5856 64.5858C70.2106 64.9608 69.9998 65.4696 69.9998 66V70H65.9998C65.4694 70 64.9606 70.2106 64.5856 70.5858C64.2106 70.9608 63.9998 71.4696 63.9998 72C63.9998 72.5304 64.2106 73.0392 64.5856 73.4142C64.9606 73.7892 65.4694 74 65.9998 74H69.9998V78C69.9998 78.5304 70.2106 79.0392 70.5856 79.4142C70.9606 79.7892 71.4694 80 71.9998 80C72.5302 80 73.039 79.7892 73.414 79.4142C73.789 79.0392 73.9998 78.5304 73.9998 78V74H77.9998C78.5302 74 79.039 73.7892 79.414 73.4142C79.789 73.0392 79.9998 72.5304 79.9998 72C79.9998 71.4696 79.789 70.9608 79.414 70.5858C79.039 70.2106 78.5302 70 77.9998 70Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M71.9998 56C68.8352 56 65.7418 56.9384 63.1106 58.6964C60.4794 60.4546 58.4288 62.9534 57.2178 65.877C56.0068 68.8006 55.6898 72.0178 56.3072 75.1214C56.9246 78.2252 58.4484 81.076 60.686 83.3136C62.9238 85.5514 65.7746 87.0752 68.8784 87.6926C71.982 88.3098 75.1992 87.993 78.1228 86.782C81.0464 85.571 83.5452 83.5202 85.3034 80.889C87.0614 78.258 87.9998 75.1644 87.9998 72C87.9998 67.7566 86.314 63.6868 83.3136 60.6862C80.313 57.6856 76.2432 56 71.9998 56ZM71.9998 84C69.6264 84 67.3064 83.2962 65.333 81.9776C63.3596 80.659 61.8214 78.7848 60.9132 76.5922C60.005 74.3994 59.7674 71.9866 60.2304 69.6588C60.6934 67.3312 61.8362 65.193 63.5146 63.5146C65.1928 61.8364 67.331 60.6936 69.6588 60.2306C71.9864 59.7676 74.3992 60.0052 76.592 60.9134C78.7848 61.8216 80.6588 63.3598 81.9774 65.3332C83.296 67.3066 83.9998 69.6266 83.9998 72C83.9998 73.5758 83.6894 75.1362 83.0864 76.5922C82.4832 78.048 81.5994 79.371 80.485 80.4852C79.3708 81.5996 78.048 82.4834 76.592 83.0866C75.136 83.6896 73.5756 84 71.9998 84Z"
            fill="white"
        />
    </MaterialIconWrapper>
);

// Icons used for FIT breakdown

export const IconChildren = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m139 146c-12 17-22 36-27 58-2 6-5 11-10 14-10 5-17 16-17 27 0 12 7 22 17 28 5 3 8 8 10 13 17 70 76 119 144 119 68 0 127-49 144-119 2-5 5-10 10-13 10-6 17-16 17-28 0-11-7-22-17-27-5-3-8-8-10-14-5-22-15-41-27-58-24 22-55 38-89 44 14-18 20-43 9-62-5 10-10 19-16 27-5 7-11 14-17 20-6 6-12 11-19 16-39-3-75-20-102-45z m114-61c1 0 2 0 3 0 1 0 2 0 2 0 0 0-1 0-2 0-1 0-2 0-3 0z m216 160c0 24-11 46-30 60-24 84-98 143-183 143-85 0-159-59-183-143-19-14-30-36-30-60 0-24 11-45 30-59 24-84 98-143 183-143 85 0 159 59 183 143 19 14 30 35 30 59z m-256-10c0 11-9 21-21 21-12 0-21-10-21-21 0-12 9-22 21-22 12 0 21 10 21 22z m128 0c0 11-9 21-21 21-12 0-21-10-21-21 0-12 9-22 21-22 12 0 21 10 21 22z m-85 128c-24 0-43-19-43-43l86 0c0 24-19 43-43 43z" />
    </MaterialIconWrapper>
);

export const IconBriefcase = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m277 64c36 0 64 29 64 64l64 0c36 0 64 29 64 64l0 171c0 35-28 64-64 64l-298 0c-36 0-64-29-64-64l0-171c0-35 28-64 64-64l64 0c0-35 28-64 64-64z m128 107l-298 0c-12 0-22 9-22 21l0 171c0 11 10 21 22 21l298 0c12 0 22-10 22-21l0-171c0-12-10-21-22-21z m-128-64l-42 0c-12 0-22 9-22 21l86 0c0-11-9-20-19-21z" />
    </MaterialIconWrapper>
);

export const IconMoney = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m442 404c-49-15-90-14-183 1-99 16-144 18-201-1-9-2-15-11-15-20l0-256c0-14 14-25 28-20 49 15 89 14 182-1 99-16 144-18 202 1 8 3 14 11 14 20l0 256c0 15-14 25-27 20z m-15-260c-43-11-84-8-168 5-82 13-127 17-174 7l0 212c43 11 84 8 168-5 83-13 128-17 174-7z m-278 112c0 12-9 21-21 21-12 0-21-9-21-21 0-12 9-21 21-21 12 0 21 9 21 21z m256 0c0 12-9 21-21 21-12 0-21-9-21-21 0-12 9-21 21-21 12 0 21 9 21 21z m-70 0c0 47-35 85-79 85-44 0-78-38-78-85 0-47 34-85 78-85 44 0 79 38 79 85z m-43 0c0-24-17-43-36-43-19 0-36 19-36 43 0 24 17 43 36 43 19 0 36-19 36-43z" />
    </MaterialIconWrapper>
);

export const IconTradingPreferences = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 24 24"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.95928 4.00085C9.38283 3.98347 9.77131 4.23503 9.92875 4.62862L12.9702 12.2322L15.0639 6.64888C15.1922 6.30684 15.4968 6.06195 15.8584 6.01012C16.22 5.95829 16.5811 6.10776 16.8003 6.40001L18.9522 9.26929L20.1682 7.44531C20.4746 6.98578 21.0954 6.8616 21.555 7.16796C22.0145 7.47431 22.1387 8.09518 21.8323 8.55471L19.8323 11.5547C19.6523 11.8247 19.3524 11.9906 19.028 11.9996C18.7036 12.0086 18.395 11.8596 18.2003 11.6L16.2956 9.06045L13.9366 15.3511C13.7916 15.7377 13.424 15.9955 13.0111 15.9999C12.5983 16.0044 12.2251 15.7547 12.0718 15.3714L9.12336 8.00032L5.95605 18.2941C5.82821 18.7096 5.44658 18.9949 5.0119 18.9999C4.57721 19.005 4.18906 18.7286 4.05159 18.3162L2.05159 12.3162C1.87694 11.7923 2.1601 11.226 2.68404 11.0513C3.20799 10.8767 3.77431 11.1598 3.94895 11.6838L4.96218 14.7234L8.04449 4.70592C8.16916 4.30076 8.53573 4.01822 8.95928 4.00085Z"
            fill="black"
        />
    </MaterialIconWrapper>
);

export const IconEducation = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m320 363l-43-32-42 32 0-97c-26-15-43-42-43-74 0-47 38-85 85-85 47 0 86 38 86 85 0 32-17 59-43 74z m-171-320l214 0c35 0 64 28 64 64l0 298c0 36-29 64-64 64l-214 0c-35 0-64-28-64-64l0-298c0-36 29-64 64-64z m0 42c-11 0-21 10-21 22l0 298c0 12 10 22 21 22l214 0c11 0 21-10 21-22l0-298c0-12-10-22-21-22z m128 150c24 0 43-19 43-43 0-24-19-43-43-43-23 0-42 19-42 43 0 24 19 43 42 43z" />
    </MaterialIconWrapper>
);

export const IconInsurance = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m278 44c119 11 213 112 213 234 0 12-10 21-22 21l-10 0c-7 0-14-4-18-10-9-15-25-25-42-25-18 0-34 10-43 25-4 6-11 10-18 10l-21 0c-8 0-15-4-19-10-5-9-12-15-21-20l0 148c0 41-33 74-74 74-42 0-75-33-75-74 0-12 10-22 21-22 12 0 22 10 22 22 0 17 14 32 32 32 17 0 32-15 32-32l0-148c-9 5-16 11-21 20-4 6-11 10-19 10l-21 0c-7 0-14-4-18-10-9-15-25-25-43-25-17 0-33 10-42 25-4 6-11 10-18 10l-10 0c-12 0-22-9-22-21 0-123 94-223 214-234l0-1c0-11 10-21 22-21 11 0 21 10 21 21z m49 212c17-21 43-34 72-34 15 0 30 4 44 11-20-84-96-147-187-147-90 0-166 63-187 147 14-7 29-11 44-11 29 0 55 13 72 34 0 0 0 0 0 1 3 3 5 6 8 10l-19 11 0-21 21 0 0 21-18-11c2-4 5-7 7-10 0-1 1-1 1-1 17-21 43-34 71-34 28 0 54 13 71 34 0 0 1 0 1 1 2 3 5 6 7 10l-18 11 0-21 21 0 0 21-19-11c3-4 5-7 8-10 0-1 0-1 0-1z" />
    </MaterialIconWrapper>
);

export const IconInsuranceXl = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m256 53c124 0 224 101 224 224 0 6-5 11-11 11-6 0-10-5-10-11 0-112-91-202-203-202-112 0-203 90-203 202 0 6-4 11-10 11-6 0-11-5-11-11 0-123 100-224 224-224z m83 218c4 5 3 12-2 15-5 3-12 2-15-2-37-51-95-51-132 0-3 4-10 5-15 2-5-3-6-10-2-15 45-63 121-63 166 0z m-149 1c4 5 2 11-3 14-5 4-12 2-15-3-31-50-89-50-120 0-3 5-10 7-15 3-5-3-7-9-3-14 39-64 117-64 156 0z m288-1c3 5 2 12-3 15-5 3-11 2-14-3-35-50-87-50-122 0-3 5-9 6-14 3-5-3-6-10-3-15 43-63 113-63 156 0z m-339 145c0-6 4-11 10-11 6 0 11 5 11 11 0 24 19 43 43 43 23 0 42-19 42-43l0-181c0-6 5-11 11-11 6 0 11 5 11 11l0 181c0 35-29 64-64 64-36 0-64-29-64-64z m106-373c0-6 5-11 11-11 6 0 11 5 11 11l0 21c0 6-5 11-11 11-6 0-11-5-11-11z" />
    </MaterialIconWrapper>
);

export const IconAirRefund = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 64 64"
    >
        <path
            d="M10.9731 32.5757L10 41.4164L20.2983 36.0316L10.9731 32.5757Z"
            fill="#004C9B"
        />
        <path
            d="M54 23L32.0743 40.4794L10.9675 32.5699L54 23Z"
            fill="#E30079"
        />
    </MaterialIconWrapper>
);

export const IconAvis = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 64 64"
    >
        <path
            d="M54.5831 26.4503V26.0686H54.8012C54.9273 26.0686 55.069 26.1044 55.069 26.2509C55.069 26.4128 54.9119 26.4495 54.7711 26.4495H54.5831V26.4503ZM54.3414 27.2047H54.5823V26.6448H54.7581L55.0681 27.2047H55.3603L54.9998 26.6187C55.1886 26.5764 55.309 26.4511 55.309 26.2574C55.309 25.9701 55.0616 25.8651 54.8053 25.8651H54.3414V27.2055V27.2047ZM53.8026 26.5398C53.8026 25.9848 54.2519 25.5355 54.8028 25.5355C55.3538 25.5355 55.812 25.9839 55.812 26.5398C55.812 27.0957 55.3603 27.5449 54.8028 27.5449C54.2453 27.5449 53.8026 27.0892 53.8026 26.5398ZM53.6146 26.5398C53.6146 27.1998 54.1477 27.7158 54.8036 27.7158C55.4596 27.7158 56.0008 27.1998 56.0008 26.5398C56.0008 25.8798 55.4669 25.3532 54.8036 25.3532C54.1404 25.3532 53.6146 25.8806 53.6146 26.5398ZM36.278 39.2944H39.6644V25.3532H36.278V39.2944ZM34.9295 25.3532H31.2085L27.9792 35.4278L24.692 25.3532H20.9117L26.1879 39.2944H29.5556L34.9286 25.3532H34.9295ZM22.9659 39.2944L17.264 25.3532H13.9102L8 39.2944H11.725L12.7472 36.5583H18.1446L19.227 39.2944H22.9667H22.9659ZM17.2177 33.8612H13.714L15.4842 29.0758L17.2177 33.8612ZM50.1704 28.8324C49.2849 28.0381 48.4743 27.7752 47.6084 27.7752C46.7425 27.7752 45.6584 28.0715 45.6584 29.1742C45.6584 30.0988 46.4861 30.4113 47.8062 30.8272C49.6959 31.4375 52.1375 32.2262 52.1375 35.0022C52.1375 38.2112 49.5576 39.6485 46.8019 39.6485C44.8128 39.6485 42.8034 38.9201 41.5835 37.6399L43.6482 35.5214C44.471 36.4069 45.6983 36.8724 46.8019 36.8724C47.8249 36.8724 48.7315 36.4769 48.7315 35.3562C48.7315 34.2925 47.667 33.9369 45.8367 33.3444C44.0657 32.7739 42.2736 31.89 42.2736 29.3712C42.2736 26.2794 45.0692 25 47.667 25C49.2434 25 51.0152 25.5917 52.236 26.7115L50.1704 28.8316V28.8324Z"
            fill="#D4002A"
        />
    </MaterialIconWrapper>
);

export const IconHertz = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 64 64"
    >
        <path
            d="M52.7258 40.9919H8L8.51345 38.5739L53.2418 38.5726L52.7258 40.9919Z"
            fill="#FFD100"
        />
        <path
            d="M42.0028 34.4157C41.6031 33.9857 41.8422 33.1295 42.047 32.1633L42.7451 28.8816H45.6146L46.1344 26.4383H43.2624L43.772 24H41.0669L39.2939 32.3872C39.027 33.6405 38.9271 34.6206 39.4697 35.6766C39.9755 36.6579 41.7031 37.595 43.8896 37.0032L44.3727 34.7357C42.8906 34.919 42.2949 34.7268 42.0028 34.4157Z"
            fill="black"
        />
        <path
            d="M19.0923 24L17.8011 30.0577H13.0536L14.341 24H11.6106L8.84985 37.0032H11.5777L12.5313 32.4972H17.2813L16.3252 37.0032H19.0316L21.7949 24H19.0923Z"
            fill="black"
        />
        <path
            d="M34.6804 27.3564C33.7332 28.1468 33.1957 29.1826 32.8467 30.8165L31.5327 37.0019H34.2403L35.3317 31.8725C35.5897 30.6723 35.787 29.9224 36.2372 29.4608C36.8569 28.8272 37.7561 28.7918 38.8348 28.8816L39.3559 26.4383C37.4526 25.9552 35.7908 26.4294 34.6804 27.3564Z"
            fill="black"
        />
        <path
            d="M55.8141 26.4383H47.3624L46.8451 28.8816H51.7482L45.6159 34.6535L45.1176 37.0032H53.568L54.0891 34.5611H49.1582L55.3209 28.7627L55.8141 26.4383Z"
            fill="black"
        />
        <path
            d="M27.291 26.2448C26.3767 26.2448 25.126 26.528 23.8967 27.493C21.1259 29.6669 19.7499 37.1954 25.7001 37.1954C27.243 37.1954 28.9591 36.7085 30.1492 35.8093L29.0729 33.9908C28.1725 34.6838 23.6362 36.19 24.1142 32.5137H31.2052C31.2077 32.5061 32.1094 29.567 30.8093 27.7889C29.7027 26.2713 27.6629 26.2448 27.291 26.2448ZM29.0514 30.2752H24.7112C24.8642 29.6909 25.7861 28.253 27.4972 28.4099C29.3385 28.5806 29.0514 30.2752 29.0514 30.2752Z"
            fill="black"
        />
        <path
            d="M55.398 35.6462C55.3967 35.6462 55.3955 35.6462 55.3904 35.6462C54.9693 35.6487 54.5659 35.9889 54.4773 36.4012C54.466 36.4543 54.4609 36.5074 54.4609 36.5593C54.4622 36.8932 54.7024 37.1486 55.0679 37.1499C55.0692 37.1499 55.0705 37.1486 55.0705 37.1486C55.4916 37.1461 55.8937 36.8034 55.9835 36.3924C55.9949 36.3392 56 36.2861 56 36.2368C56.0025 35.9017 55.7597 35.6475 55.398 35.6462ZM55.8811 36.3734C55.8065 36.7325 55.4334 37.0487 55.0705 37.0462C54.753 37.0399 54.5709 36.8438 54.5646 36.5593C54.5646 36.515 54.5697 36.4682 54.5798 36.4214C54.6519 36.0635 55.0224 35.7499 55.3854 35.7486C55.7091 35.755 55.89 35.9497 55.8963 36.2368C55.8975 36.2785 55.8912 36.3253 55.8811 36.3734Z"
            fill="#9D9D9C"
        />
        <path
            d="M55.3373 36.0383H55.0161L54.8631 36.7578H55.0224L55.0717 36.5251H55.1982L55.3019 36.7578H55.4891L55.3664 36.4998C55.4663 36.467 55.5447 36.3924 55.57 36.2747C55.6003 36.1255 55.5093 36.0383 55.3373 36.0383ZM55.4056 36.2849C55.3917 36.3468 55.3386 36.3898 55.2589 36.3898H55.1008L55.1451 36.1786H55.2994C55.3803 36.1786 55.4208 36.214 55.4056 36.2849Z"
            fill="#9D9D9C"
        />
    </MaterialIconWrapper>
);

export const IconRentalcars = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 106 14"
    >
        <g clip-path="url(#clip0_13913_121330)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M92.9522 12.2413C93.9359 12.2413 94.7338 11.4434 94.7338 10.4597C94.7338 9.47321 93.9359 8.67528 92.9566 8.67528C91.9773 8.67528 91.1794 9.47321 91.1794 10.4525C91.1794 11.4318 91.9773 12.2297 92.9638 12.2297L92.9522 12.2413ZM92.9638 13.9271C94.8861 13.9271 96.4457 12.3675 96.4457 10.4452C96.4457 8.52295 94.8861 6.96336 92.9638 6.96336C91.0416 6.96336 89.482 8.52295 89.482 10.4452C89.482 12.3675 91.0416 13.9271 92.9638 13.9271ZM81.053 13.9271C81.6964 13.9271 82.2136 13.4063 82.2136 12.7665C82.2136 12.1245 81.6964 11.6059 81.053 11.6059C80.4146 11.6059 79.8923 12.1245 79.8923 12.7665C79.8923 13.4063 80.4146 13.9271 81.053 13.9271ZM105.547 9.14679C105.368 7.91072 104.299 6.96336 103.006 6.96336C102.35 6.96336 101.75 7.20782 101.294 7.61186C100.842 7.20782 100.242 6.96191 99.5823 6.96191C99.4952 6.96191 99.4111 6.96482 99.327 6.9728C99.3103 6.9757 99.2907 6.98005 99.2726 6.98005C99.2073 6.98948 99.142 6.99818 99.0803 7.01124C99.0607 7.01342 99.044 7.01849 99.0295 7.0214C98.9643 7.0359 98.899 7.05041 98.8337 7.07217L98.7974 7.08233C98.7271 7.10409 98.6596 7.12875 98.5943 7.15632C98.5871 7.15849 98.5798 7.16357 98.5726 7.16502C98.5015 7.19404 98.4318 7.22668 98.3644 7.26295L98.3571 7.26658C98.1825 7.36106 98.0194 7.47547 97.8711 7.60751L97.8638 7.62202C97.388 8.05 97.0732 8.65352 97.0253 9.32668L97.0144 9.34627V13.9278H98.7263V9.35787C98.7263 8.91031 99.089 8.54761 99.5388 8.54761H99.6207C100.07 8.54761 100.433 8.91031 100.433 9.35787V13.9336H102.148V9.35787C102.148 8.91176 102.513 8.54907 102.963 8.54907H103.042C103.492 8.54907 103.855 8.91176 103.855 9.35787V13.9336H105.567V9.36513C105.567 9.29477 105.559 9.22585 105.542 9.16057"
                fill="#00487A"
            />
            <path
                d="M87.6411 11.464C87.594 11.5307 87.5432 11.5945 87.4866 11.654C87.1725 11.9833 86.7301 12.1886 86.239 12.1886C85.2887 12.1886 84.5169 11.4161 84.5169 10.4658C84.5169 9.51556 85.2894 8.7423 86.2397 8.7423C86.7765 8.7423 87.248 8.98385 87.5672 9.36251C87.6324 9.43359 87.6832 9.51049 87.7267 9.591L89.192 8.62624C89.0759 8.44126 88.9454 8.26789 88.8003 8.10831C88.1692 7.42064 87.2552 6.99121 86.2469 6.99121C84.3319 6.99121 82.7723 8.54644 82.7723 10.4658C82.7723 12.3852 84.3319 13.9404 86.2469 13.9404C87.2262 13.9404 88.1039 13.54 88.735 12.8937C88.8728 12.7537 88.9962 12.6021 89.1122 12.4403L87.6542 11.464H87.6411Z"
                fill="#00487A"
            />
            <path
                d="M33.9169 11.4576C33.6957 11.5591 33.457 11.615 33.1988 11.615C32.2253 11.615 31.4462 10.8243 31.4462 9.8501V7.0073H34.3572V4.68606H31.4462V2.37207H29.125V9.85083C29.125 12.1032 30.9457 13.9362 33.1988 13.9362C33.9387 13.9362 34.6191 13.7382 35.2183 13.3922L33.9169 11.4576V11.4576ZM39.6402 11.6222C38.3614 11.6222 37.3248 10.5849 37.3248 9.30679C37.3248 8.02793 38.3621 6.99135 39.6402 6.99135C40.9191 6.99135 41.9557 8.02865 41.9557 9.30679C41.9557 10.5856 40.9184 11.6222 39.6402 11.6222V11.6222ZM39.6402 4.68026C37.0847 4.68026 35.0122 6.75124 35.0122 9.30679C35.0122 11.8623 37.0847 13.9348 39.6402 13.9348C40.4788 13.9348 41.2651 13.7099 41.9433 13.3196V13.9362H44.2646V9.4243C44.2646 9.3844 44.2675 9.34596 44.2675 9.30679C44.2675 6.75124 42.1929 4.67881 39.6395 4.67881L39.6402 4.68026ZM61.6115 11.628C60.3276 11.628 59.2903 10.5907 59.2903 9.31186C59.2903 8.033 60.3276 6.99642 61.6043 6.99642C62.8809 6.99642 63.9182 8.03373 63.9182 9.31186C63.9182 10.5907 62.8809 11.6273 61.6043 11.6273L61.6115 11.628ZM61.6043 4.67808C59.0436 4.67808 56.9763 6.74544 56.9763 9.30606C56.9763 11.8667 59.0436 13.934 61.6043 13.934C62.4385 13.934 63.2291 13.7092 63.9037 13.3175V13.934H66.225V9.30606C66.225 6.74544 64.1504 4.67808 61.597 4.67808"
                fill="#00487A"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M44.9945 13.9371H47.3158V1.20801H44.9945V13.9371Z"
                fill="#00487A"
            />
            <path
                d="M28.4122 13.9362H26.091V8.75834C26.091 7.78487 25.2988 6.99275 24.3254 6.99275C23.3519 6.99275 22.5598 7.78487 22.5598 8.75834V13.9362H20.2385V8.75834C20.2385 6.50456 22.0723 4.6715 24.3254 4.6715C26.5784 4.6715 28.4122 6.50456 28.4122 8.75834V13.9362V13.9362ZM54.4341 10.7822C54.0133 11.2863 53.3793 11.6077 52.6714 11.6077C51.4063 11.6077 50.377 10.5776 50.377 9.31181C50.377 8.04674 51.407 7.01668 52.6721 7.01668C53.3793 7.01668 54.0126 7.33803 54.4348 7.84218C54.5146 7.94373 54.5849 8.04529 54.6488 8.14684L56.6001 6.8629C56.4477 6.61627 56.2736 6.38415 56.0778 6.17378C55.2363 5.25979 54.0249 4.68674 52.6757 4.68674C50.1223 4.68674 48.0477 6.76135 48.0477 9.31472C48.0477 11.8681 50.1223 13.9427 52.6757 13.9427C54.0249 13.9427 55.2363 13.3696 56.0778 12.4556C56.2736 12.2453 56.455 12.0132 56.6073 11.7665L54.656 10.4826C54.598 10.5914 54.5255 10.693 54.4457 10.7873L54.4341 10.7822ZM2.52888 7.81244V5.06757C2.52888 3.55295 3.7664 2.32124 5.28754 2.32124C6.80795 2.32124 8.04401 3.55295 8.04401 5.06757C8.04401 6.58145 6.80795 7.81389 5.28754 7.81389H2.52888V7.81244ZM10.9122 13.9333L9.66598 11.6744H9.65873L8.26598 9.15876C9.53614 8.23751 10.3631 6.74611 10.3631 5.06757C10.3631 2.27337 8.08536 0 5.28536 0C2.48536 0 0.207642 2.27337 0.207642 5.06757V13.9347H2.52888V10.1337H5.28536C5.57116 10.1337 5.85116 10.1083 6.12318 10.0633L8.25945 13.9325H10.9107L10.9122 13.9333Z"
                fill="#00487A"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M76.2866 8.38923V8.38633C76.2866 8.38633 75.5858 8.28115 75.2812 8.09617C75.2406 8.06716 75.2028 8.03596 75.168 8.00187C75.1608 7.99172 75.1535 7.98446 75.1463 7.98011C74.9939 7.82052 74.9091 7.61742 74.925 7.40343L74.9395 7.31275C74.9359 7.33089 74.9323 7.34539 74.9308 7.35845C74.9381 7.33669 74.9381 7.31275 74.9453 7.29027V7.31928C74.9598 7.26125 74.9888 7.16695 75.0469 7.0799C75.1629 6.90581 75.3588 6.76799 75.5909 6.69545C75.7142 6.66643 75.8593 6.64467 76.0334 6.65192C76.6478 6.66643 77.2622 6.87679 77.6656 7.05089L78.6521 5.29545C78.0138 5.0198 76.5847 4.49752 75.3864 4.7369V4.74198C73.895 4.92332 72.809 5.94612 72.7147 7.2569C72.6378 8.30146 73.2153 9.25897 74.1895 9.80301C74.233 9.82477 74.3128 9.86829 74.4143 9.91182L74.4796 9.94083C74.7582 10.0671 75.1702 10.2208 75.4843 10.2498C75.8905 10.2861 76.1081 10.3369 76.1553 10.3492C76.5818 10.4798 76.8771 10.8258 76.8495 11.2103L76.835 11.3017L76.8459 11.256C76.8386 11.2799 76.8386 11.3024 76.8314 11.3249L76.8343 11.3031C76.8197 11.364 76.7907 11.4533 76.7327 11.5454C76.6166 11.7238 76.4259 11.8602 76.1937 11.9298C76.0704 11.9632 75.9253 11.9806 75.7541 11.9777C74.7023 11.9509 73.6534 11.351 73.6534 11.351L72.5145 13.0121L72.7974 13.1753C72.7974 13.1753 74.8032 14.2112 76.4026 13.8935V13.8891C77.8948 13.7078 78.9807 12.685 79.075 11.3764C79.1809 9.9227 78.0275 8.64892 76.3011 8.40229"
                fill="#00487A"
            />
            <path
                d="M72.6548 5.01803C72.1475 4.79898 71.6006 4.68616 71.048 4.68652C68.795 4.68652 66.9641 6.52031 66.9641 8.77336V13.9367H69.2854V8.77336C69.2854 7.79989 70.0746 7.00777 71.048 7.00777C71.2874 7.00777 71.5123 7.05709 71.7198 7.14341"
                fill="#00487A"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.8533 6.82221C15.8783 6.82221 16.7524 7.46273 17.102 8.36438H12.6046C12.9542 7.4649 13.8283 6.82656 14.8533 6.82656V6.82221ZM16.5631 11.0266C16.5362 11.0556 16.5094 11.0773 16.4811 11.1064H16.4796C16.04 11.4763 15.4735 11.7012 14.8533 11.7012C13.8073 11.7012 12.9093 11.0701 12.527 10.1633H19.4037C19.453 9.89495 19.4806 9.61205 19.4806 9.32915C19.4806 6.77433 17.406 4.70117 14.8526 4.70117C12.2992 4.70117 10.2246 6.77433 10.2246 9.32915C10.2246 11.884 12.292 13.9571 14.8526 13.9571C16.7749 13.9571 18.4288 12.7791 19.1251 11.1035L19.1469 11.0382H16.5573L16.5631 11.0266Z"
                fill="#00487A"
            />
        </g>
        <defs>
            <clipPath id="clip0_13913_121330">
                <rect
                    width="105.399"
                    height="14"
                    fill="white"
                    transform="translate(0.207642)"
                />
            </clipPath>
        </defs>
    </MaterialIconWrapper>
);

export const IconEPaper = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 64 64"
    >
        <path
            d="M35.5642 13H28.4377C25.2992 13.0033 22.2901 14.2539 20.0708 16.4774C17.8515 18.7009 16.6033 21.7157 16.6 24.8602V48.0625C16.6 48.6153 16.7557 49.1568 17.0492 49.6249C17.3427 50.0929 17.7619 50.4685 18.2589 50.7086C18.7559 50.9486 19.3104 51.0433 19.8586 50.9817C20.4069 50.9202 20.9267 50.705 21.3583 50.3607L29.4671 43.8604H35.5642C38.703 43.8571 41.7123 42.6066 43.932 40.3831C46.1517 38.1597 47.4005 35.1449 47.4044 32.0002V24.8602C47.4005 21.7155 46.1517 18.7007 43.932 16.4773C41.7123 14.2538 38.703 13.0033 35.5642 13ZM41.5375 32.0002C41.5355 33.5868 40.9056 35.1079 39.7858 36.2298C38.666 37.3517 37.1478 37.9829 35.5642 37.9848H28.4377C27.772 37.9852 27.1263 38.2125 26.6067 38.6294L22.4644 41.949V24.8602C22.4664 23.2736 23.0963 21.7525 24.2161 20.6306C25.3359 19.5087 26.8541 18.8775 28.4377 18.8756H35.5642C37.1478 18.8775 38.666 19.5087 39.7858 20.6306C40.9056 21.7525 41.5355 23.2736 41.5375 24.8602V32.0002Z"
            fill="#2BC48C"
        />
        <path
            d="M34.8886 37.9848L28.4377 37.9848C27.772 37.9852 27.1263 38.2125 26.6067 38.6294L22.4644 41.949L22.4644 48.0626C22.4642 48.5043 22.3646 48.9402 22.1731 49.3381C21.9816 49.736 21.7032 50.0855 21.3583 50.3607L29.4671 43.8604L34.8886 43.8604V37.9848Z"
            fill="url(#paint0_linear_25_160)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_25_160"
                x1="20.3809"
                y1="49.0071"
                x2="32.6015"
                y2="39.8887"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopOpacity="0.4" />
                <stop offset="1" stopOpacity="0" />
            </linearGradient>
        </defs>
    </MaterialIconWrapper>
);

export const IconEPaperNew = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={{ fill: "none", ...props.style }}
        onClick={props.onClick}
        viewBox="0 0 1023.9 595.3"
    >
        <>
            <g>
                <path
                    fill="#082542"
                    d="M379.6,348.3c-29.9,0-52.2-23.3-52.2-52.9c0-29.3,21.8-53.2,52.9-53.2c18.9,0,30.4,6.6,40.2,16L409,271.4 c-8.2-7.6-17-12.8-28.8-12.8c-19.6,0-33.9,16.1-33.9,36.4c0,20.2,14.2,36.7,33.9,36.7c12.6,0,20.7-5.1,29.5-13.3l11.6,11.7 C410.6,341.3,398.9,348.3,379.6,348.3"
                />
                <path
                    fill="#082542"
                    d="M481,264.7l-17.6,41.1h35.4L481,264.7z M534.8,346.5h-19.1l-10.4-24.8h-48.5l-10.6,24.8h-18.5l45.2-103.4h16.7 L534.8,346.5z"
                />
                <path
                    fill="#082542"
                    d="M593.8,260.3h-26.2v34.5h26.4c12.9,0,21.1-6.7,21.1-17.3C615,266.2,607.1,260.3,593.8,260.3 M615.3,346.5 l-25.2-35.8h-22.6v35.8h-18V243.9h45.8c23.6,0,38.1,12.5,38.1,32.6c0,17-10.1,27.3-24.5,31.2l27.7,38.9H615.3z"
                />
                <path
                    fill="#082542"
                    d="M699.1,260.3h-26.2v34.5h26.4c12.9,0,21.1-6.7,21.1-17.3C720.3,266.2,712.4,260.3,699.1,260.3 M720.6,346.5 l-25.2-35.8h-22.6v35.8h-18V243.9h45.8c23.6,0,38.1,12.5,38.1,32.6c0,17-10.1,27.3-24.5,31.2l27.7,38.9H720.6z"
                />
                <rect
                    x="760.4"
                    y="243.9"
                    fill="#082542"
                    width="18"
                    height="102.7"
                />
                <polygon
                    fill="#082542"
                    points="882,260 823.9,260 823.9,286.7 875.4,286.7 875.4,302.8 823.9,302.8 823.9,330.4 882.7,330.4 882.7,346.5 805.9,346.5 805.9,243.9 882,243.9"
                />
                <path
                    fill="#082542"
                    d="M948.4,260.3h-26.2v34.5h26.4c12.9,0,21.1-6.7,21.1-17.3C969.7,266.2,961.8,260.3,948.4,260.3 M970,346.5 l-25.2-35.8h-22.6v35.8h-18V243.9h45.8c23.6,0,38.1,12.5,38.1,32.6c0,17-10.1,27.3-24.5,31.2l27.7,38.9H970z"
                />
                <rect
                    x="60.5"
                    y="112.3"
                    fill="#082542"
                    width="103.6"
                    height="103.6"
                />
                <rect
                    x="191.1"
                    y="112.3"
                    fill="#082542"
                    width="103.6"
                    height="103.6"
                />
                <rect
                    x="60.5"
                    y="242.9"
                    fill="#082542"
                    width="103.6"
                    height="103.6"
                />
                <rect
                    x="191.1"
                    y="242.9"
                    fill="#139BAE"
                    width="103.6"
                    height="103.6"
                />
                <polygon
                    fill="#082542"
                    points="412.6,113.2 381.3,161.8 350.1,113.2 330.9,113.2 330.9,215.9 348.6,215.9 348.6,142.5 380.7,190.7 381.3,190.7 413.7,142.3 413.7,215.9 431.8,215.9 431.8,113.2"
                />
                <polygon
                    fill="#082542"
                    points="458.2,113.2 458.2,215.9 535,215.9 535,199.8 476.2,199.8 476.2,172.2 527.7,172.2 527.7,156 476.2,156 476.2,129.4 534.3,129.4 534.3,113.2"
                />
                <path
                    fill="#082542"
                    d="M594.7,129.6h-20.2v69.8h20.2c21.6,0,35.6-14.5,35.6-34.8C630.4,144.5,616.3,129.6,594.7,129.6 M594.7,215.9 h-38.3V113.2h38.3c32.3,0,54.6,22.1,54.6,51.2S627,215.9,594.7,215.9"
                />
                <rect
                    x="671.4"
                    y="113.2"
                    fill="#082542"
                    width="18"
                    height="102.7"
                />
                <path
                    fill="#082542"
                    d="M760.6,134l17.7,41.1H743L760.6,134z M752.5,112.5l-45.2,103.4h18.5l10.6-24.8h48.6l10.4,24.8h19.1 l-45.2-103.4H752.5z"
                />
            </g>
            <g>
                <path
                    fill="#082542"
                    d="M380.3,381.7c-3.5-5-9-7.6-16.5-7.6s-13,1.4-16.3,4c-4.7,3.5-7,9.2-7,16.7c0,5.2,1.1,11.6,3.2,19.1 c2.3,7.5,4.7,14.5,7.3,20.8c2.7,6.3,5.2,12.5,7.3,18.9c2.3,6.4,3.4,11.2,3.4,14.4c0,6.7-8.2,9.5-11.5,6.6 c-6.7-2.3-11.8-9.5-13.6-15.1c-1.8-6-3.2-12.1-4-12.5c-2.1-1.5-4.4-0.6-5.7-0.6c-3.1,0-4.1,1.5-4.1,5.3c0,5.4,1.1,9.5,3.4,12.7 c6,12.1,16.8,18.2,27.3,18.2c9.2,0,17.1-4.7,19.6-12.5c0.6-1.1,0.9-2.6,0.9-4.3c0-4.3-1.8-11.2-5.5-20.5l-10.8-28.3 c-3.5-9.5-5-16.5-4.9-20.9c0.2-5.4,0.2-5.8,1.4-8.4c0.8-1.4,1.7-2.6,3.1-3.7c2.9-2,5.3-2.9,7.2-2.9c2.3,0,4.4,1.2,6.1,3.8 c2.1,3.5,3.2,8.1,3.2,13.4c0,3.2-0.3,6.7-0.8,10.5c-0.5,1.2,0.3,2.6,2.3,4s4,2.1,5.7,2.1c1.2,0,2-0.5,2.3-1.2 c1.5-4.1,2.3-8.7,2.3-13.7C385.5,392.7,383.8,386.7,380.3,381.7z"
                />
                <path
                    fill="#082542"
                    d="M422.8,440.3c-1.7-1.2-5.3-3.8-7-5.2c-1.2-1.1-1.8-1.7-1.8-2.1v-0.3c0-0.6-0.3-1.5-0.9-2.9 c-1.2-2-5.2-5.2-7.5-5c-3.1,0.3-7,6.3-9.9,11.2c-1.8,3.1-4.3,7.9-4.7,8.7c-3.8,6.9-5.8,13.3-5.8,19.6c0,6,2.4,9.6,7.3,11.3 c2,1.1,4,1.5,6,1.5c4.9,0,10.8-4,18-12.1l4.1-4.7c0.5-0.5,0.9-1.1,1.7-2.1c2-2.7,3.4-5,3.7-8.7c0.2-0.5,0.2-1.2,0.2-2.1 C426,444.2,424.4,441.6,422.8,440.3z M407.8,458.5c-6,6.4-9.9,9.6-12.1,9.6c-0.8,0-1.2-0.6-1.2-1.8c0-1.4,0.6-3.7,1.8-6.9 c3.4-9.2,6.9-14.8,10.4-16.8c2-1.1,4.9-0.5,7.3,0.2l1.8,0.5c0.6,0.6,0.9,1.2,0.9,2C416.8,447.7,413.7,452.1,407.8,458.5z"
                />
                <path
                    fill="#082542"
                    d="M586.5,421.8c1.8,0,3.8-1.7,5.8-4.9c2-3.2,3.1-6,3.1-7.9c0-2.1-0.5-3.7-1.4-4.6c-1.7-1.7-3.4-2.6-4.7-2.6 c-2,0-3.5,1.5-4.7,4.4c-1.1,2.9-1.7,5.5-1.7,7.8c0,2.6,0.3,4.6,0.9,5.7C584.6,421.1,585.5,421.8,586.5,421.8z"
                />
                <path
                    fill="#082542"
                    d="M637.7,440.3c-1.7-1.2-5.4-3.8-7-5.2c-1.2-1.1-1.8-1.7-1.8-2.1v-0.3c0-0.6-0.3-1.5-0.9-2.9 c-1.2-2-5.2-5.2-7.5-5c-3.1,0.3-7,6.3-9.9,11.2c-1.8,3.1-4.3,7.9-4.7,8.7c-3.5,6.3-5.5,12.3-5.7,18.1l-2,1.3 c-2,1.4-4.1,2.8-6.1,3.8c-3.8,2.3-10.2,4.7-13.1,2.4c-1.4-0.8-2.1-2.4-2.1-5c0-6.9,2.7-16.2,8.2-27.6c1.4-2.6-0.1-4.3-4.6-5.3 c-0.4-0.2-0.8-0.3-1.1-0.4c0.3-0.8-0.2-1.2-1.6-1.2c-3.1,0-9.5,0.6-12.1,0.6c-1.7,0-6.4,0.6-8.7,0.6c2.7-7,4.7-11.8,6-14.4 c5.4-12.7,8.1-18.9,8.1-19.1c0.5-1.1-0.2-2.4-1.7-4.1c-1.5-1.7-3.2-2.4-4.9-2.4c-0.3,0-0.8,0.2-1.4,0.3c-1.4,0.6-3.4,4.3-6,11 l-6.9,16.2l-5.2,13c-4.3,0.9-7.8,0.8-9,1.8c-1.2,0.8-1.4,2-1.4,4.4s1.1,3.7,3.4,3.7c0.6,0,3.1-0.3,3.7-0.2 c-3.2,8.2-5.4,15.6-6.4,22.2c-6,3.4-12.6,6.2-16.6,6.2c-2.9,0-3.4-4.6-2.1-10.8c1.4-6.6,3.2-12.2,5-17.3c0.9-3.8,2.3-4.3,0.3-7.5 c-1.2-2.3-4.4-4.4-6.7-4.3c-2.1-0.5-7.3,8.6-8.6,9.9c-1.1,1.2-2.9,3.4-5.2,6.3l-3.7,4.7c-7.3,7.9-12.2,13.6-14.4,16.2 c-1.8,2-2.6,2.8-2.7,2.8h-0.6c-0.9-0.5,0-4.9,2.6-13.1c4.1-9.9,8.6-18.5,9.9-21.1c0.8-1.4,1.1-2.6,1.1-3.5c0-2.3-1.2-4.3-3.7-6.3 c-2.3-2-4.3-2.6-5.7-2.1c-1.5,0.6-3.5,4.6-6.1,11.8c-2.6,7.2-4.4,13.4-5.8,18.5c-0.7,2.4-1.1,4.7-1.5,6.8c-0.4,0.3-0.8,0.7-1.4,1.2 c-1.4,1.4-2.4,2.4-3.5,3.2c-5.7,5-11.3,7.5-16.6,7.5c-5.7,0-8.4-3.5-8.4-10.5c5.8-4.1,13-12.5,21.4-25.5c5.6-8.3,10.5-17.6,15-28.1 c3.2-7.5,4.6-15,4.4-22.8c-0.1-5.5-6.3-9-11.9-9c-1.2,0-2.1,0.2-2.6,0.3c-3.4,1.1-6.6,4-9.6,8.6c-4.6,6.7-8.5,13.9-12.1,21.4 c-3.7,8.1-6.6,15.7-8.9,22.9c-3.8,12.1-5.7,21.4-5.7,28c0,9.2,1.2,15.1,7.2,18.6c3.5,2.1,7.9,3.2,13,3.2c5.3,0,11-2.9,16.8-8.7 c0.8-0.8,1.5-1.8,2.2-2.9c0,7.5,2.9,11.8,8.8,12.9c4.1,0.5,9.9-4.9,19.6-16.3c4.9-5.8,8.1-9.5,9.5-11c-1.7,8.4-1.1,14.8,1.8,18.9 c2.9,4.1,6.9,6.1,11.8,5.7c3.9-0.5,8.3-3.1,13.1-8.1c0,1.9,0.2,3.4,0.8,4.2c1.1,2.3,2.9,3.7,5.2,3.8c2.1,0.2,3.4-0.5,3.7-2 c0-0.6-0.5-2.9-0.3-4.1c0-0.2,0.9-4.4,2.6-12.7c2.9-9.6,5.2-15.7,6.6-18.2l6.3-1.1l6.1-0.9c0.1,0,0.3,0,0.5-0.2 c2.9-0.6,5.5-1.6,7.9-3c-3,7.5-5.1,14-6.2,19.6c-1.7,7.9-0.8,13.7,2.7,17.6c3.5,3.7,7.9,5.3,13,4.9c4-0.3,8.4-3.1,13.3-8.3 c1.5-1.5,2.7-2.9,3.7-4.1c0.6,4.6,3,7.5,7.2,9c2,1.1,4,1.5,6,1.5c4.9,0,10.8-4,18-12.1l4.1-4.7c0.5-0.5,0.9-1.1,1.7-2.1 c2-2.7,3.4-5,3.7-8.7c0.2-0.5,0.2-1.2,0.2-2.1C640.9,444.2,639.4,441.6,637.7,440.3z M448.4,429.8c4-9.6,8.5-19.4,13.7-29.2 c5.3-9.9,8.9-14.8,10.5-14.8c0.6,0,0.9,0.6,0.9,2c0,0.8,0,1.2-0.1,1.7c-0.5,6.1-3.5,14.8-6,19.9l-3.1,6.4l-2.6,5.6 c-2.6,5.8-6.3,11.8-10.7,18c-3.1,4.4-6.4,8.7-10.1,12.8C442.8,444.8,445.2,437.3,448.4,429.8z M622.8,458.5 c-6,6.4-9.9,9.6-12.1,9.6c-0.8,0-1.2-0.6-1.2-1.8c0-1.4,0.6-3.7,1.8-6.9c3.4-9.2,6.9-14.8,10.4-16.8c2-1.1,4.9-0.5,7.3,0.2l1.8,0.5 c0.6,0.6,0.9,1.2,0.9,2C631.8,447.7,628.7,452.1,622.8,458.5z"
                />
                <path
                    fill="#082542"
                    d="M728,426.1c-8.1,1.1-12.1,6.1-12.1,15.3c0,4.1,1.1,9.5,3.4,15.7c3.5,10.2,4.9,15.7,4,16.3 c-1.7-0.8-3.8-3.1-6.7-7.2c-2.9-4.1-4.7-6.1-5.8-6.1c-0.5,0-1.1,0.2-1.7,0.5c-1.7,0.9-2.4,2-2.4,3.1c0,0.5,0.1,1.1,0.3,1.8 l-0.3,0.2l-6.1,4c-1.8,1.1-4.9,2.3-6.9,2.3c-3.5,0-5.3-3.4-5.3-9.9c0-3.2,0.6-7.6,2-13.3c1.2-5.8,1.8-9,1.8-9.5 c0-2.9-4.4-6.4-7-6.4c-1.5,0-3.8,0.9-6.7,2.9c-2.9,1.8-5.2,3.7-7,5.5l-14.5,14.4c3.1-8.1,7.6-21.7,8-22.2c1.1-2.4,0.5-4.6-3.8-6.9 c-4.1-2.4-5.7-2.3-6.9,3.1l-5.8,20.5l-4.3,14.8c-0.9,3.1-1.4,5-1.4,6.1c0,1.4,0.6,2.9,2,4.7c1.4,1.7,2.8,2.6,4.1,2.6 c1.8,0,4.3-2.1,7.3-6.3c2.3-2.9,6-6.9,11-11.9c0.2-0.2,12.2-12.7,13.9-13.9c-3.5,12.4-3.7,21.2-0.5,26.3c2.6,4.1,8.1,6.3,12.2,6.3 c1.4,0,2.7-0.2,4-0.5c3.5-0.8,7.5-3.4,11.6-7.8l0.9-1.1c0,0,0,0,0,0c1.2,1.6,2.8,3.4,4.9,5.4c5,4.7,9.2,7.2,12.4,7.2 c0.6,0.2,1.4,0.2,2.4,0.2c3.5,0,4.7-1.5,4.7-6c0-1.1-0.9-6.4-2.9-16c-0.3-1.1-1.8-5.3-3.7-14.4c-1.4-8.1,0.2-12.1,3.1-12.1 c1.5,0,2.6,1.1,3.4,3.2c0.3,1.1,0.5,2,0.5,2.8c0,1.4-0.6,3.7-0.6,4.3c0,0.8,0.5,1.7,1.2,2.4c1.4,1.4,2.7,2,4.1,2 c2.7,0,4.1-2.4,4.1-7.3C742.9,432.4,736.6,425.4,728,426.1z"
                />
            </g>
        </>
    </MaterialIconWrapper>
);

export const IconPriorityPass = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 64 64"
    >
        <path
            d="M31.2235 49.5124H34.149V50H18.14V49.5124H21.0655C22.122 49.5124 22.6908 49.3499 23.0971 49.1061C23.5034 48.8623 23.7472 48.3747 23.8285 47.8059C23.9098 47.237 23.991 46.0181 23.991 44.149V17.088H18.14V16.6004H18.6276C23.8285 16.6004 26.5915 14.6501 28.2168 14.0813V44.2302C28.2168 46.0993 28.298 47.3183 28.3793 47.8871C28.4606 48.456 28.7043 48.8623 29.1107 49.1874C29.4357 49.3499 30.1671 49.5124 31.2235 49.5124Z"
            fill="#867533"
        />
        <path
            d="M34.0678 50C33.2552 50 31.3861 50 30.8173 49.5937C30.3297 49.2686 30.0859 48.6998 29.9234 48.0497C29.8421 47.4808 29.7608 46.2619 29.7608 44.3928V14H30.5735V44.3928C30.5735 46.1806 30.6547 47.3995 30.736 47.9684C30.8173 48.456 30.9798 48.781 31.3048 48.9436C31.5486 49.1061 32.9301 49.5124 34.0678 49.5124V50Z"
            fill="#867533"
        />
        <path
            d="M30.0045 32.0406V31.553H31.1422C34.7991 31.553 40.3251 31.7156 40.3251 22.4515C40.3251 14.3251 35.5305 14.4876 32.3612 14.4876H30.0858V14H34.0677C45.2822 14 45.851 21.395 45.851 22.9391C45.851 25.9458 44.4695 28.465 41.9504 30.0903C38.8623 32.0406 34.7991 32.0406 32.8488 32.0406H30.0045Z"
            fill="#867533"
        />
    </MaterialIconWrapper>
);

export const IconSixt = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 64 64"
    >
        <path
            d="M44.2387 29.9077L42.1255 32.8753L47.0076 40.0165V29.9077H44.2387ZM29.6328 30.509V39.6543L34.2406 32.8102L32.08 29.9798C33.8855 29.4823 35.524 28.7105 36.9533 27.5924L38.3457 29.3557L40.988 25.3649H56V29.8954H52.6228V40.9518L40.9863 40.9553L38.0081 36.5057L34.9122 40.9553H23.9666V37.9139C23.179 40.0657 20.6966 41.3755 15.7706 41.3755C8.46588 41.3755 8.11076 38.7929 8 35.8358H13.7769C13.7963 36.7184 13.944 37.3583 14.2991 37.7785C14.6718 38.1987 15.1746 38.4184 15.92 38.4184C17.0944 38.4184 18.3619 38.0879 18.3619 36.808C18.3619 36.5215 18.2688 36.2789 18.1193 36.0802C17.3546 35.0641 10.9254 34.3151 9.11812 32.4393C8.39204 31.6886 8.16701 30.5635 8.16701 29.6581C8.16701 26.1718 10.8691 24.6037 16.2558 24.6037C21.9765 24.6037 23.3319 26.6061 23.4058 29.8954H17.8433C17.8064 29.0129 17.5409 28.3237 17.1542 28.0037C16.7797 27.6943 16.4545 27.5519 15.8848 27.5625C14.6929 27.5853 14.0582 28.0916 14.0582 28.9091C14.0582 29.1517 14.1321 29.4612 14.3008 29.637C15.1764 30.6303 21.4016 31.337 23.1895 33.2339C23.4743 33.5346 23.7627 33.9266 23.9684 34.4698V30.7973C25.8143 30.8658 27.7376 30.8061 29.6328 30.509Z"
            fill="black"
        />
        <path
            d="M23.9842 25.3579C29.7611 25.7833 33.0153 24.1483 34.1316 22H40.0316C38.2578 27.13 32.7252 30.3437 23.9859 29.9042V25.3579H23.9842Z"
            fill="#EF7C00"
        />
    </MaterialIconWrapper>
);

export const IconSmartDelay = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 65 65"
    >
        <rect
            width="64"
            height="64"
            transform="translate(0.0799866 0.0800171)"
            fill="white"
        />
        <path
            d="M37.9024 7.48404C36.0332 7.04323 34.0838 6.81 32.08 6.81C18.1238 6.81 6.81 18.1238 6.81 32.08C6.81 46.0362 18.1238 57.35 32.08 57.35C46.0362 57.35 57.35 46.0362 57.35 32.08C57.35 30.0762 57.1168 28.1268 56.676 26.2576C55.9932 27.0296 55.2221 27.7217 54.3784 28.318C54.5834 29.5415 54.69 30.7983 54.69 32.08C54.69 44.5672 44.5672 54.69 32.08 54.69C19.5928 54.69 9.47 44.5672 9.47 32.08C9.47 19.5928 19.5928 9.47 32.08 9.47C33.3617 9.47 34.6185 9.57664 35.842 9.78155C36.4383 8.93794 37.1304 8.16683 37.9024 7.48404Z"
            fill="#A3B5C9"
        />
        <path
            d="M17.45 34.8161C17.4462 34.0815 18.0386 33.483 18.7731 33.4792L30.75 33.4169V18.78C30.75 18.0455 31.3455 17.45 32.08 17.45C32.8145 17.45 33.41 18.0455 33.41 18.78V34.74C33.4101 35.4714 32.8186 36.0662 32.0864 36.07L32.08 36.07L18.7869 36.1391C18.0524 36.143 17.4538 35.5506 17.45 34.8161Z"
            fill="#A3B5C9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M47.8627 13.0489V18.3689C47.8627 19.0055 47.3466 19.5215 46.71 19.5215C46.0734 19.5215 45.5573 19.0055 45.5573 18.3689V13.0489C45.5573 12.4123 46.0734 11.8962 46.71 11.8962C47.3466 11.8962 47.8627 12.4123 47.8627 13.0489ZM46.71 20.7654C47.3463 20.7654 47.8627 21.2817 47.8627 21.9181C47.8627 22.5555 47.3462 23.0708 46.71 23.0708C46.0738 23.0708 45.5573 22.5555 45.5573 21.9181C45.5573 21.2817 46.0736 20.7654 46.71 20.7654Z"
            fill="#A3B5C9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M46.7167 24.9778C50.8558 24.9778 54.2112 21.6224 54.2112 17.4832C54.2112 13.3441 50.8558 9.9887 46.7167 9.9887C42.5775 9.9887 39.2221 13.3441 39.2221 17.4832C39.2221 21.6224 42.5775 24.9778 46.7167 24.9778ZM46.7167 27.6378C52.3249 27.6378 56.8712 23.0915 56.8712 17.4832C56.8712 11.875 52.3249 7.3287 46.7167 7.3287C41.1084 7.3287 36.5621 11.875 36.5621 17.4832C36.5621 23.0915 41.1084 27.6378 46.7167 27.6378Z"
            fill="#A3B5C9"
        />
    </MaterialIconWrapper>
);

export const IconVisaLuxuryHotels = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 64 64"
    >
        <rect width="64" height="64" fill="white" />
        <path
            d="M38.2644 24.19C34.8563 24.19 31.8106 25.9635 31.8106 29.2395C31.8106 32.9968 37.2121 33.2563 37.2121 35.1441C37.2121 35.9389 36.305 36.6504 34.755 36.6504C32.5558 36.6504 30.9121 35.6563 30.9121 35.6563L30.2086 38.9626C30.2086 38.9626 32.1022 39.8024 34.6161 39.8024C38.3422 39.8024 41.2746 37.942 41.2746 34.6097C41.2746 30.6392 35.8505 30.3874 35.8505 28.6356C35.8505 28.0129 36.5952 27.3309 38.1404 27.3309C39.8841 27.3309 41.3063 28.0539 41.3063 28.0539L41.9948 24.8609C41.9948 24.8609 40.4467 24.19 38.2639 24.19H38.2644ZM7.08264 24.4312L7 24.913C7 24.913 8.43375 25.1764 9.72529 25.7021C11.3882 26.3045 11.5064 26.6556 11.7865 27.7447L14.8381 39.5535H18.9289L25.2309 24.4312H21.1497L17.1002 34.7129L15.4478 25.9973C15.2965 24.9998 14.5286 24.4307 13.5893 24.4307H7.08312L7.08264 24.4312ZM26.8722 24.4312L23.6708 39.5535H27.5626L30.7526 24.4312H26.8722ZM48.5784 24.4312C47.64 24.4312 47.1427 24.9357 46.778 25.8169L41.0762 39.5535H45.1574L45.9468 37.2639H50.9188L51.3988 39.5535H55L51.8586 24.4312H48.5784ZM49.1093 28.5169L50.3192 34.1915H47.0783L49.1098 28.5169H49.1093Z"
            fill="#1434CB"
        />
    </MaterialIconWrapper>
);

export const IconCardNewXl = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m267 149c0 2 0 4 0 6 0 7 2 11 6 16l-198 0c-6 0-11 4-11 10l0 235c0 6 5 11 11 11l362 0c6 0 11-5 11-11l0-154c1-1 1-2 2-4 8-4 14-8 19-11l0 169c0 18-14 32-32 32l-362 0c-18 0-32-14-32-32l0-235c0-17 14-32 32-32z m100 107l-303 0 0-43 267 0c0 2 0 4 0 6 0 14 6 20 36 37z m-250 64c-6 0-10-5-10-11 0-6 4-10 10-10l107 0c6 0 11 4 11 10 0 6-5 11-11 11z m0 43c-6 0-10-5-10-11 0-6 4-11 10-11l43 0c6 0 11 5 11 11 0 6-5 11-11 11z m318-168c23 13 34 21 34 24 0 3-11 11-34 24-13 23-21 34-24 34-3 0-11-11-24-34-23-13-35-21-35-24 0-3 12-11 35-24 13-23 21-35 24-35 3 0 11 12 24 35z m-94-56c14 9 22 14 22 16 0 2-8 7-22 15-9 15-14 22-16 22-2 0-7-7-15-22-15-8-22-13-22-15 0-2 7-7 22-16 8-14 13-22 15-22 2 0 7 8 16 22z m81-59c10 6 15 9 15 11 0 1-5 5-15 11-6 10-10 15-11 15-2 0-5-5-11-15-11-6-16-10-16-11 0-2 5-5 16-11 6-11 9-16 11-16 1 0 5 5 11 16z" />
    </MaterialIconWrapper>
);

export const IconCardReplacementXl = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m384 235l0-22 53 0c18 0 32 15 32 32l0 171c0 18-14 32-32 32l-256 0c-17 0-32-14-32-32l0-96 22 0 0 96c0 6 4 11 10 11l256 0c6 0 11-5 11-11l0-171c0-6-5-10-11-10z m-53 64l-256 0c-18 0-32-15-32-32l0-171c0-18 14-32 32-32l256 0c17 0 32 14 32 32l0 171c0 17-15 32-32 32z m0-22c6 0 10-4 10-10l0-171c0-6-4-11-10-11l-256 0c-6 0-11 5-11 11l0 171c0 6 5 10 11 10z m-267-160l277 0 0 43-277 0z m32 86c-6 0-11-5-11-11 0-6 5-11 11-11l107 0c6 0 10 5 10 11 0 6-4 11-10 11z m0 42c-6 0-11-4-11-10 0-6 5-11 11-11l43 0c6 0 10 5 10 11 0 6-4 10-10 10z m373-157l0 80c0 1 0 2-1 2-1 1-2 1-3 0l-48-40c-1 0-1-1-1-2 0-1 0-2 1-2l48-40c1-1 2-1 3 0 1 0 1 1 1 2z m-426 336l0-80c0-1 0-2 1-2 1-1 2-1 3 0l48 40c1 0 1 1 1 2 0 1 0 2-1 2l-48 40c-1 1-2 1-3 0-1 0-1-1-1-2z" />
    </MaterialIconWrapper>
);

export const IconHomeSecondary = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m304 183l-32-29 62-57c16-15 42-15 58 0l57 53c13 12 20 29 20 47l0 101c0 12-9 22-21 22l-85 0 0-43 64 0 0-80c0-6-3-12-7-16l-57-53z m-133 158l0 64c0 12-10 22-22 22l-85 0c-12 0-21-10-21-22l0-130c0-18 7-36 21-48l85-78c24-22 62-22 86 0l85 78c14 12 21 30 21 48l0 130c0 12-9 22-21 22l-85 0c-12 0-22-10-22-22l0-64z m128 43l0-109c0-6-3-12-7-16l-86-78c-8-8-20-8-28 0l-86 78c-4 4-7 10-7 16l0 109 43 0 0-64c0-12 9-22 21-22l86 0c12 0 21 10 21 22l0 64z" />
    </MaterialIconWrapper>
);

export const IconCart = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m201 397c16 17 16 44 0 61-17 16-44 16-60 0-17-17-17-44 0-61 16-16 43-16 60 0z m235 0c16 17 16 44 0 61-17 16-44 16-61 0-16-17-16-44 0-61 17-16 44-16 61 0z m-317-266c3-2 6-2 9-2l320 0c13 0 23 11 21 24l-21 149c-2 10-9 17-19 19l-277 35c-11 1-21-5-23-16l-60-233-48 0c-11 0-21-9-21-21 0-12 10-21 21-21l64 0c10 0 19 6 21 16z m10 40l36 140 243-31 15-109z" />
    </MaterialIconWrapper>
);

export const IconHealth = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m224 320l-64 0 0-64 64 0 0-64 64 0 0 64 64 0 0 64-64 0 0 64-64 0z m-53-192c0-35 28-64 64-64l42 0c36 0 64 29 64 64l43 0c35 0 64 29 64 64l0 192c0 35-29 64-64 64l-256 0c-35 0-64-29-64-64l0-192c0-35 29-64 64-64z m42 0l86 0c0-12-10-21-22-21l-42 0c-12 0-22 9-22 21z m-106 256c0 12 9 21 21 21l256 0c12 0 21-9 21-21l0-192c0-12-9-21-21-21l-256 0c-12 0-21 9-21 21z" />
    </MaterialIconWrapper>
);

export const IconLiving = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m160 403l0 45c0 12-10 21-21 21-12 0-22-9-22-21l0-45c-51-11-85-63-71-117l51-205c11-44 73-44 83 0l52 205c13 54-21 106-72 117z m309-178c14 11 22 28 22 45l0 178c0 12-10 21-22 21l-85 0c-12 0-21-9-21-21l0-64-43 0 0 64c0 12-10 21-21 21l-124 0c4-6 6-13 6-21l0-21 96 0 0-64c0-12 10-22 22-22l85 0c12 0 21 10 21 22l0 64 43 0 0-157c0-4-2-8-5-11l-125-97c-5-4-12-4-17 0l-66 51-11-46 50-39c21-16 50-16 70 0l0 0z m-330 138c34 0 60-33 51-66l-51-206c0 0-1 0-1 0l-51 206c-8 33 17 66 52 66z" />
    </MaterialIconWrapper>
);

export const IconTaxes = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m149 43l214 0c35 0 64 28 64 64l0 298c0 36-29 64-64 64l-214 0c-35 0-64-28-64-64l0-298c0-36 29-64 64-64z m0 42c-11 0-21 10-21 22l0 298c0 12 10 22 21 22l214 0c11 0 21-10 21-22l0-298c0-12-10-22-21-22z m54 128c-22 0-32-19-32-42 0-24 10-43 32-43 21 0 32 19 32 43 0 23-11 42-32 42z m0-21c6 0 10-6 10-21 0-15-4-22-10-22-7 0-11 7-11 22 0 15 4 21 11 21z m106 85c-21 0-32-19-32-42 0-24 11-43 32-43 22 0 32 19 32 43 0 23-10 42-32 42z m0-21c7 0 11-6 11-21 0-15-4-22-11-22-6 0-10 7-10 22 0 15 4 21 10 21z m-128 64l150 0c6 0 10 5 10 11 0 6-4 10-10 10l-150 0c-6 0-10-4-10-10 0-6 4-11 10-11z m0 43l150 0c6 0 10 4 10 10 0 6-4 11-10 11l-150 0c-6 0-10-5-10-11 0-6 4-10 10-10z m41-90c-3 4-10 6-15 3-4-4-6-10-3-15l86-128c3-5 10-6 15-3 4 3 6 10 3 15z" />
    </MaterialIconWrapper>
);

export const IconFood = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m341 339l0 66 43 0c12 0 21 10 21 22 0 11-9 21-21 21l-62 0c-1 0-1 0-2 0-1 0-1 0-2 0l-62 0c-12 0-21-10-21-21 0-12 9-22 21-22l43 0 0-66c-48-11-86-56-86-104 0-16 3-40 7-69 2-9 3-17 4-26 3-14 5-28 8-41 1-8 2-14 3-18 2-10 11-17 21-17l128 0c10 0 19 7 21 17 1 4 2 10 3 18 3 13 5 27 8 41 1 9 2 17 4 26 4 29 7 53 7 69 0 51-37 94-86 104z m-192-254c0-12 10-21 22-21 11 0 21 9 21 21l0 86c0 11-10 21-21 21-12 0-22-10-22-21z m117 63c-1 8-2 16-3 24-5 28-7 50-7 63 0 32 30 64 64 64 35 0 64-29 64-64 0-13-2-35-7-63-1-8-2-16-3-24-3-14-5-28-8-41l-92 0c-3 13-5 27-8 41z m-74 87l0 192c0 12-10 21-21 21-12 0-22-9-22-21l0-174c-36-9-64-43-64-82l0-86c0-11 10-21 22-21 11 0 21 10 21 21l0 86c0 23 19 42 43 42 11 0 21 10 21 22z" />
    </MaterialIconWrapper>
);

export const IconShopping = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m128 107c0-47 38-86 85-86 47 0 86 39 86 86l42 0c11 0 21 8 22 19l3 43-43 3-1-23-217 0-18 235 126 0 0 43-149 0c-12 0-22-11-21-23l21-278c1-11 10-19 21-19z m43 0l85 0c0-24-19-43-43-43-23 0-42 19-42 43z m128 149l0-11c0-29 24-53 53-53 29 0 53 24 53 53l0 11 22 0c10 0 20 8 21 19l21 170c2 13-8 24-21 24l-192 0c-13 0-23-11-21-24l21-170c2-11 11-19 21-19z m64 0l0-11c0-6-5-10-11-10-6 0-11 4-11 10l0 11z m45 43l-112 0-16 128 144 0z" />
    </MaterialIconWrapper>
);

export const IconPublicTransport = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m219 43c7-13 21-22 37-22 16 0 30 9 37 22l48 0c47 0 86 38 86 85l0 235c0 23-19 42-43 42l-256 0c-24 0-43-19-43-42l0-235c0-47 39-85 86-85z m0 42l-48 0c-24 0-43 19-43 43l0 235 256 0 0-235c0-24-19-43-43-43l-48 0c-7 13-21 22-37 22-16 0-30-9-37-22z m-27 235c0 12-10 21-21 21-12 0-22-9-22-21 0-12 10-21 22-21 11 0 21 9 21 21z m171 0c0 12-10 21-22 21-11 0-21-9-21-21 0-12 10-21 21-21 12 0 22 9 22 21z m-171 107l-43 42-64 0 43-42z m235 42l-64 0-43-42 64 0z m-86-213l-170 0c-12 0-22-10-22-21l0-86c0-11 10-21 22-21l170 0c12 0 22 10 22 21l0 86c0 11-10 21-22 21z" />
    </MaterialIconWrapper>
);

export const IconHolidays = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m348 244c5-38 4-72-1-100 14 10 28 23 41 38 16 19 32 46 37 77-23-14-50-20-77-15m-120-31c22-57 52-89 65-96 9 12 21 55 13 115-22-16-50-23-78-19m-117-31c18-26 45-42 68-51 19-8 37-12 54-15-17 22-34 52-47 88-22-16-49-24-75-22m310-27c-28-33-64-60-97-73 0-1 0-2 0-2 3-12-4-23-15-26-12-3-23 4-26 16 0 0 0 1 0 2-36-4-81 3-120 19-60 25-100 67-112 119 0 0 0 1 0 1-1 2-1 5-1 8 1 5 4 10 9 14 2 1 5 2 7 3 0 0 0 0 0 0 6 2 12 0 17-2 32-20 75-10 94 23 2 2 4 4 5 5 1 1 1 1 1 1 0 0 1 0 1 1 2 1 4 2 6 3 1 0 1 0 1 0 1 0 3 0 5 0 0 0 1 0 2 0 0 0 0 0 1 0 0 0 1 0 1 0 2-1 4-1 6-3 0 0 1 0 1 0 8-5 18-8 27-9l-36 128c-50-12-101-12-149 35-8 8-8 22 0 30 8 9 22 9 30 1 46-46 93-33 166-7 37 13 77 27 118 27 24 0 49-4 73-17 11-5 15-18 10-28-6-11-18-15-29-10-51 26-103 7-158-12-7-3-14-5-20-7l37-132c10 6 19 14 26 25 1 2 3 3 5 5 0 0 0 0 0 1 1 0 1 0 1 0 2 1 4 3 7 3 0 0 0 0 0 0 2 1 3 1 5 1 1 0 1 0 2 0 1-1 1-1 2-1 1 0 2 0 2 0 1 0 2-1 2-1 1 0 2-1 3-1 33-20 75-10 95 23 0 0 0 0 0 0 1 2 3 4 5 5 0 1 1 1 1 2 2 1 5 2 7 3 0 0 0 0 0 0 2 0 4 0 5 0 2 0 5 0 7-1 0 0 1 0 2-1 1 0 1 0 2-1 1 0 1 0 1 0 2-2 3-3 4-4 1-1 1-1 2-2 1-2 2-4 3-7 13-52-3-108-44-157" />
    </MaterialIconWrapper>
);

export const IconWithdrawal = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m308 299c-12 16-31 26-52 26-21 0-40-10-52-26z m-73 85c0-12 9-21 21-21 12 0 21 9 21 21 0 12-9 21-21 21-12 0-21-9-21-21z m106 43l0-128 43 0 0 149c0 12-10 21-21 21l-214 0c-11 0-21-9-21-21l0-149 43 0 0 128z m64-384c36 0 64 28 64 64l0 213c0 24-19 43-42 43l-22 0 0-43 22 0 0-43-342 0 0 43 22 0 0 43-22 0c-23 0-42-19-42-43l0-213c0-36 28-64 64-64z m-320 192l342 0 0-128c0-12-10-22-22-22l-298 0c-12 0-22 10-22 22z m118-107l0-21 21 0 0 21z m42 0l0-21 22 0 0 21z m43 0l0-21 21 0 0 21z m-85 43l0-22 21 0 0 22z m42 0l0-22 22 0 0 22z m43 0l0-22 21 0 0 22z m-85 42l0-21 21 0 0 21z m42 0l0-21 22 0 0 21z m43 0l0-21 21 0 0 21z" />
    </MaterialIconWrapper>
);

export const IconGroup = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m317 163c-4-15-10-28-18-41 16-10 34-15 53-15 53 0 96 43 96 96 0 53-43 96-96 96-24 0-46-9-63-24 10-11 17-24 23-37 9 11 24 18 40 18 29 0 53-24 53-53 0-30-24-54-53-54-14 0-26 5-35 14z m-18 166c17-6 35-9 53-9 46 0 87 19 113 51 7 9 6 22-4 30-9 7-22 6-30-4-17-21-46-34-79-34-4 0-7 0-11 0-12-13-26-25-42-34z m-107-30c-59 0-107-48-107-107 0-59 48-107 107-107 59 0 107 48 107 107 0 59-48 107-107 107z m0-43c35 0 64-29 64-64 0-35-29-64-64-64-35 0-64 29-64 64 0 35 29 64 64 64z m-111 162c-6 9-20 12-29 5-10-7-12-20-5-30 32-46 86-73 145-73 59 0 113 28 145 73 7 10 5 23-5 30-9 7-23 4-29-5-25-34-66-55-111-55-45 0-87 21-111 55z" />
    </MaterialIconWrapper>
);

export const IconSavings = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m77 236c11-23 27-43 48-60-5-12-8-24-8-37 0-17 5-34 13-48 9-15 21-27 35-35 15-9 31-13 48-13 17 0 34 4 48 13 15 8 27 20 36 35 7 12 11 26 12 41 7 1 14 3 21 4 16-20 30-31 49-35 23-5 44 13 44 37l-3 50c9 10 17 18 23 25l5 0c25 0 43 23 43 48l0 54c0 27-15 43-37 47-4 0-6 2-8 4-8 11-17 21-29 30-6 5-9 12-7 19l1 2c9 28-6 58-34 67l-20 7c-28 9-58-6-67-34l-4-11c-12 1-23 2-34 2-9 0-18 0-26-1l-3 10c-10 28-40 43-68 34l-20-7c-28-9-43-39-34-67l6-18c-28-27-43-62-43-104 0-7 1-15 2-22-9-5-18-11-23-19-9-12-12-28-10-41 1-5 6-9 11-8 4 1 8 4 8 8l1 0c1 9 7 16 13 20 3 2 7 3 11 3z m85-84c30-15 66-24 104-24-1-6-3-11-6-16-5-8-12-15-20-20-8-4-17-7-27-7-9 0-18 3-26 7-8 5-15 12-20 20-4 8-7 17-7 27 0 4 1 9 2 13z m218-6c-5 4-10 9-17 18-1 2-7 9-8 10l-9 12-15-5c-20-7-42-10-64-10-89 0-160 57-160 124 0 32 11 57 33 76 10 9 14 22 10 35l-8 24c-2 6 1 12 6 14l21 6c5 2 11-1 13-6l5-15c5-17 22-27 39-25 9 1 17 1 26 1 10 0 21 0 33-2 17-2 34 8 40 25l5 16c2 5 8 8 13 6l21-6c5-2 8-8 7-14l-1-2c-8-24 1-50 20-65 9-7 16-14 22-22 8-12 21-19 35-21 2-1 1 1 1-5l0-54c0-4-1-5 0-5l-29 0-6-11c-4-7-15-19-30-33l-7-7 1-10z m-17 153c-12 0-22-10-22-22 0-11 10-21 22-21 12 0 21 10 21 21 0 12-9 22-21 22z" />
    </MaterialIconWrapper>
);

export const IconSavingsXl = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 64 64"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.3057 23.7202C19.2199 23.8489 19.1101 23.9647 18.9775 24.0607C14.549 27.2642 12 31.7712 12 36.5791C12 40.8417 13.5898 44.3996 16.575 47.0048C17.4269 47.7477 17.7754 48.9137 17.4191 49.9902L16.4272 52.9858C15.965 54.3831 16.7223 55.8899 18.1192 56.352L20.6547 57.1918C22.0523 57.6541 23.5603 56.8966 24.0221 55.5003L24.6103 53.7223C25.1057 52.2274 26.5798 51.3111 28.1487 51.4729C29.2309 51.5856 30.3243 51.6431 31.4347 51.6431C32.8303 51.6431 34.2609 51.5435 35.7425 51.3502C37.3287 51.1436 38.839 52.065 39.3433 53.5846L39.9763 55.4996C40.4393 56.8967 41.9466 57.6541 43.3438 57.1919L45.8779 56.3534C47.2753 55.8903 48.0332 54.3818 47.5688 52.9804L47.4982 52.7647C46.6876 50.316 47.5642 47.659 49.6258 46.0197C50.7825 45.0994 51.7531 44.0996 52.5202 43.0325C53.3474 41.8825 54.6371 41.1425 56.0863 40.913C56.9979 40.7678 57.3333 40.3883 57.3333 38.9764V32.3097C57.3333 31.1481 56.6625 30.3097 56 30.3097H53.1486L52.7651 29.6358C52.1444 28.5449 50.779 27.0564 48.8279 25.1907L48.3796 24.762L48.4187 24.143L48.888 16.7537C48.888 16.3615 48.5351 16.0611 48.2168 16.1324C46.9659 16.4113 45.8629 17.3603 44.3591 19.2741C44.2202 19.4509 43.8671 19.9099 43.6098 20.2444L43.6086 20.246C43.4737 20.4214 43.3653 20.5623 43.3283 20.6099L42.742 21.3633L41.8398 21.051C40.1734 20.4741 38.4227 20.0677 36.6195 19.8441C36.3958 20.4234 36.1219 20.9815 35.8009 21.5124C36.879 21.6585 37.9575 21.8849 39.0298 22.1884C39.7384 22.389 40.1502 23.126 39.9496 23.8345C39.749 24.5431 39.0121 24.9549 38.3035 24.7543C36.6626 24.2898 35.012 24.0298 33.3801 23.9894C33.2467 24.0078 33.111 24.0059 32.9781 23.9839C30.1167 23.9764 27.3205 24.6507 24.744 26.0881C24.7087 26.1102 24.6724 26.1306 24.6352 26.1493C23.3374 26.886 22.0961 27.8176 20.9314 28.9546C20.4044 29.469 19.5603 29.4588 19.0459 28.9319C18.5315 28.4049 18.5417 27.5608 19.0686 27.0464C19.7694 26.3624 20.4948 25.7429 21.2415 25.1861C20.5437 24.7733 19.894 24.2815 19.3057 23.7202ZM34.6667 16.0005C34.6667 11.5822 31.0849 8.0005 26.6667 8.0005C22.2484 8.0005 18.6667 11.5822 18.6667 16.0005C18.6667 17.9556 19.3688 19.7984 20.6244 21.2439C21.51 22.2634 22.6373 23.0441 23.9002 23.5096C26.6577 22.0643 29.6228 21.3581 32.6443 21.3176C33.9359 19.8677 34.6667 17.9935 34.6667 16.0005ZM41.7942 18.2312C41.9823 17.9869 42.1669 17.7479 42.2623 17.6265C44.1216 15.2603 45.6073 13.9821 47.6351 13.53C49.6578 13.0767 51.5547 14.6914 51.552 16.8378L51.1189 23.695C52.703 25.2322 53.8813 26.509 54.6589 27.6431H56C58.2823 27.6431 60 29.7896 60 32.3097V38.9764C60 41.7191 58.693 43.1982 56.5045 43.5466C55.7299 43.6693 55.078 44.0434 54.6853 44.5894C53.7698 45.8627 52.6284 47.0385 51.2859 48.1067C50.076 49.0687 49.5806 50.5699 50.0312 51.931L50.1016 52.1463C51.0279 54.9411 49.5119 57.9583 46.7162 58.8849L44.1814 59.7236C41.3864 60.6481 38.3712 59.1331 37.4447 56.3375L36.8119 54.423C36.715 54.1312 36.4199 53.9512 36.0871 53.9945C34.4952 54.2022 32.9501 54.3097 31.4347 54.3097C30.2314 54.3097 29.0459 54.2474 27.8739 54.1254C27.5317 54.0901 27.237 54.2733 27.1419 54.5605L26.5539 56.3378C25.6293 59.1327 22.6126 60.6483 19.8168 59.7234L17.2813 58.8836C14.4863 57.959 12.9708 54.9436 13.8956 52.1479L14.8875 49.1521C14.8983 49.1195 14.8827 49.0673 14.822 49.0143C11.2514 45.8982 9.33333 41.6057 9.33333 36.5791C9.33333 35.4489 9.45052 34.3354 9.678 33.2474C8.02922 32.9769 6.48891 32.0993 5.49944 30.8389C4.35688 29.4231 3.88719 27.6213 4.02265 25.9564C4.05357 25.5837 4.38043 25.3052 4.75295 25.3362C5.08423 25.3627 5.3419 25.6249 5.37134 25.9461L5.37282 25.9564C5.50386 27.3192 6.13109 28.5686 7.06899 29.3715C8.00542 30.1877 9.20541 30.5104 10.345 30.3763C10.4175 30.3678 10.4894 30.3646 10.5603 30.3665C11.8861 27.1122 14.2427 24.1946 17.4145 21.9001C17.4991 21.8389 17.5885 21.7891 17.6807 21.7503C16.5944 20.0561 16 18.0732 16 16.0005C16 10.1095 20.7756 5.33383 26.6667 5.33383C32.5577 5.33383 37.3333 10.1095 37.3333 16.0005C37.3333 16.4174 37.3093 16.8306 37.262 17.2385C38.8132 17.448 40.3295 17.781 41.7942 18.2312ZM46 34.6672C44.8947 34.6672 44 33.7712 44 32.6672C44 31.5618 44.8947 30.6672 46 30.6672C47.1053 30.6672 48 31.5618 48 32.6672C48 33.7712 47.1053 34.6672 46 34.6672Z"
        />
    </MaterialIconWrapper>
);

export const IconBuildingSavingsContractXl = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 48 48"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36 5C38.7614 5 41 7.23858 41 10V26.0911L39 24.4378V10C39 8.34315 37.6569 7 36 7H12C10.3431 7 9 8.34315 9 10V38C9 39.6569 10.3431 41 12 41H22V42C22 42.3453 22.0438 42.6804 22.126 43H12C9.23858 43 7 40.7614 7 38V10C7 7.23858 9.23858 5 12 5H36ZM13 23H30.7756C30.6339 23.0971 30.4954 23.2012 30.3606 23.3124L28.319 25H13C12.4477 25 12 24.5523 12 24C12 23.4477 12.4477 23 13 23ZM13 28H24.6898L24.1336 28.4598C23.6039 28.8981 23.163 29.4209 22.8221 30H13C12.4477 30 12 29.5523 12 29C12 28.4477 12.4477 28 13 28ZM13 33H22.0001L22 33.0249V35H13C12.4477 35 12 34.5523 12 34C12 33.4477 12.4477 33 13 33ZM13 15H22C22.5523 15 23 14.5523 23 14C23 13.4477 22.5523 13 22 13H13C12.4477 13 12 13.4477 12 14C12 14.5523 12.4477 15 13 15ZM35 20H13C12.4477 20 12 19.5523 12 19C12 18.4477 12.4477 18 13 18H35C35.5523 18 36 18.4477 36 19C36 19.5523 35.5523 20 35 20ZM32.3333 42C32.3333 42.5523 31.8856 43 31.3333 43H26C25.4477 43 25 42.5523 25 42V33.0249C25 32.1503 25.3829 31.3199 26.0461 30.7712L32.2695 25.6267C33.2826 24.791 34.7179 24.791 35.7305 25.6274L41.9523 30.7705C42.6167 31.3192 43 32.1498 43 33.0249V42C43 42.5523 42.5523 43 42 43H36.6667C36.1144 43 35.6667 42.5523 35.6667 42V37.3529H32.3333V42ZM41 33.0249C41 32.7408 40.8786 32.4777 40.6784 32.3124L34.4565 27.1691C34.1834 26.9436 33.8161 26.9436 33.5429 27.1689L27.3207 32.3124L27.2404 32.3887C27.0893 32.5529 27 32.7813 27 33.0249V41H30.3333V36.3529C30.3333 35.8007 30.781 35.3529 31.3333 35.3529H36.6667C37.219 35.3529 37.6667 35.8007 37.6667 36.3529V41H41V33.0249Z"
        />
    </MaterialIconWrapper>
);

export const IconCalendar = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 24 24"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 1.97409V3.00779H16V1.97409C16 1.42181 16.4477 0.974091 17 0.974091C17.5523 0.974091 18 1.42181 18 1.97409V3.00779H19C20.6563 3.00779 22 4.35151 22 6.00779V19.0078C22 20.6641 20.6563 22.0078 19 22.0078H5C3.34372 22.0078 2 20.6641 2 19.0078V6.00779C2 4.35151 3.34372 3.00779 5 3.00779H6V1.97409C6 1.42181 6.44772 0.974091 7 0.974091C7.55228 0.974091 8 1.42181 8 1.97409ZM5 5.00779C4.44828 5.00779 4 5.45608 4 6.00779V6.99999H20V6.00779C20 5.45608 19.5517 5.00779 19 5.00779H5ZM4 8.99999V19.0078C4 19.5595 4.44828 20.0078 5 20.0078H19C19.5517 20.0078 20 19.5595 20 19.0078V8.99999H4ZM18 13C18 14.104 17.104 15 16 15C14.896 15 14 14.104 14 13C14 11.896 14.896 11 16 11C17.104 11 18 11.896 18 13Z"
        />
    </MaterialIconWrapper>
);

export const IconCalendarXl = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 48 48"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 8H13V5C13 4.44772 13.4477 4 14 4C14.5523 4 15 4.44772 15 5V8H33V5C33 4.44772 33.4477 4 34 4C34.5523 4 35 4.44772 35 5V8H38C40.7613 8 43 10.2387 43 13V39C43 41.7613 40.7613 44 38 44H10C7.23872 44 5 41.7613 5 39V13C5 10.2387 7.23872 8 10 8ZM10 10C8.34328 10 7 11.3433 7 13V16H41V13C41 11.3433 39.6567 10 38 10H10ZM7 18V39C7 40.6567 8.34328 42 10 42H38C39.6567 42 41 40.6567 41 39V18H7ZM35 28C36.6567 28 38 26.6567 38 25C38 23.3433 36.6567 22 35 22C33.3433 22 32 23.3433 32 25C32 26.6567 33.3433 28 35 28Z"
        />
    </MaterialIconWrapper>
);

export const IconBspOptionsProlongation = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 48 48"
    >
        <rect width="48" height="48" fill="white" fillOpacity="0.01" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.5557 32.7102C19.5954 34.7443 21.4136 36.1591 23.9704 36.1591C26.5841 36.1591 28.4534 34.7216 28.4477 32.733C28.4534 31.2841 27.5329 30.25 25.8227 30.0341V29.9432C27.1238 29.7102 28.0216 28.7898 28.0159 27.483C28.0216 25.6477 26.4136 24.2045 24.0045 24.2045C21.6182 24.2045 19.8227 25.6023 19.7886 27.6136H22.1466C22.175 26.7273 22.9875 26.1534 23.9932 26.1534C24.9875 26.1534 25.6523 26.7557 25.6466 27.6307C25.6523 28.5455 24.8738 29.1648 23.7545 29.1648H22.6693V30.9716H23.7545C25.0727 30.9716 25.8966 31.6307 25.8909 32.5682C25.8966 33.4943 25.1011 34.1307 23.9761 34.1307C22.8909 34.1307 22.0784 33.5625 22.0329 32.7102H19.5557Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.11122 41.1111H8.00011V37.5556H7.11122V41.1111Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.77789 37.5556V41.1111H10.6668V37.5556H9.77789Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 8H10C7.23872 8 5 10.2387 5 13V32.0703C2.60879 33.4535 1 36.0389 1 39C1 43.4183 4.58172 47 9 47C11.5264 47 13.7793 45.8289 15.2454 44H38C40.7613 44 43 41.7613 43 39V13C43 10.2387 40.7613 8 38 8H35V5C35 4.44772 34.5523 4 34 4C33.4477 4 33 4.44772 33 5V8H15V5C15 4.44772 14.5523 4 14 4C13.4477 4 13 4.44772 13 5V8ZM17 39C17 34.5817 13.4183 31 9 31C8.3094 31 7.63924 31.0875 7 31.252V18H41V39C41 40.6567 39.6567 42 38 42H16.4185C16.7935 41.0736 17 40.0609 17 39ZM7 13C7 11.3433 8.34328 10 10 10H38C39.6567 10 41 11.3433 41 13V16H7V13ZM9.24999 34.0766L13.25 35.8544C13.6336 36.0249 13.8456 36.4405 13.7585 36.8512C13.6714 37.2619 13.3088 37.5556 12.889 37.5556H12.4446V41.1111C12.9355 41.1111 13.3334 41.5091 13.3334 42C13.3334 42.4909 12.9355 42.8889 12.4446 42.8889H5.33344C4.84252 42.8889 4.44455 42.4909 4.44455 42C4.44455 41.5091 4.84252 41.1111 5.33344 41.1111V37.5556H4.88898C4.46917 37.5556 4.1066 37.2619 4.01945 36.8512C3.9323 36.4405 4.14434 36.0249 4.52797 35.8544L8.52797 34.0766C8.7578 33.9745 9.02015 33.9745 9.24999 34.0766Z"
        />
    </MaterialIconWrapper>
);

export const IconIchApp = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 89 65"
    >
        <path
            d="M61.9709 42.3455C62.4296 42.3455 62.8219 42.263 63.1478 42.098C63.4737 41.9331 63.7654 41.6616 64.0229 41.2834H64.047C64.047 41.4363 64.0551 41.5932 64.0712 41.7541C64.0873 41.915 64.1074 42.0638 64.1315 42.2006H64.8678C64.8357 42.0397 64.8115 41.8426 64.7954 41.6093C64.7793 41.3759 64.7713 41.1507 64.7713 40.9334V38.4594C64.7713 38.1134 64.7149 37.8117 64.6023 37.5542C64.4896 37.2968 64.3327 37.0836 64.1315 36.9146C63.9304 36.7456 63.697 36.6189 63.4314 36.5344C63.1659 36.45 62.8802 36.4077 62.5744 36.4077C62.0916 36.4077 61.6591 36.4841 61.2768 36.637C60.8946 36.7899 60.5868 36.983 60.3534 37.2163L60.8121 37.7594C61.0133 37.5583 61.2587 37.3973 61.5484 37.2767C61.8381 37.156 62.1519 37.0956 62.4899 37.0956C62.9808 37.0956 63.355 37.2163 63.6125 37.4577C63.87 37.6991 63.9988 38.0651 63.9988 38.5559V38.7369C63.4837 38.7369 62.9868 38.7551 62.508 38.7913C62.0292 38.8275 61.6047 38.9079 61.2346 39.0326C60.8644 39.1573 60.5687 39.3464 60.3474 39.5999C60.1261 39.8533 60.0154 40.1972 60.0154 40.6317C60.0154 40.9455 60.0778 41.211 60.2025 41.4282C60.3273 41.6455 60.4842 41.8225 60.6733 41.9593C60.8624 42.096 61.0716 42.1946 61.301 42.2549C61.5303 42.3153 61.7536 42.3455 61.9709 42.3455ZM62.1882 41.6696C62.0272 41.6696 61.8683 41.6515 61.7114 41.6153C61.5544 41.5791 61.4116 41.5188 61.2829 41.4343C61.1541 41.3498 61.0515 41.2392 60.9751 41.1024C60.8986 40.9656 60.8604 40.7967 60.8604 40.5955C60.8604 40.33 60.9489 40.1168 61.1259 39.9559C61.303 39.795 61.5303 39.6723 61.8079 39.5878C62.0856 39.5033 62.3954 39.447 62.7374 39.4188C63.0794 39.3907 63.4194 39.3766 63.7573 39.3766H63.9988V39.799C63.9988 40.0484 63.9585 40.2857 63.878 40.511C63.7976 40.7363 63.6809 40.9354 63.528 41.1084C63.3751 41.2814 63.186 41.4182 62.9607 41.5188C62.7354 41.6193 62.4779 41.6696 62.1882 41.6696ZM67.7044 45.0971V41.2472H67.7407C67.974 41.6012 68.2858 41.8728 68.6761 42.0618C69.0664 42.2509 69.4627 42.3455 69.8651 42.3455C70.3077 42.3455 70.708 42.269 71.0661 42.1161C71.4242 41.9633 71.73 41.7541 71.9835 41.4886C72.237 41.2231 72.4341 40.9093 72.5749 40.5472C72.7158 40.1852 72.7862 39.795 72.7862 39.3766C72.7862 38.9582 72.7158 38.568 72.5749 38.2059C72.4341 37.8439 72.237 37.5301 71.9835 37.2646C71.73 36.9991 71.4242 36.7899 71.0661 36.637C70.708 36.4841 70.3077 36.4077 69.8651 36.4077C69.4627 36.4077 69.0664 36.5022 68.6761 36.6913C68.2858 36.8804 67.974 37.16 67.7407 37.5301H67.7044V36.5525H66.8836V45.0971H67.7044ZM69.7806 41.6455C69.4668 41.6455 69.1771 41.5871 68.9115 41.4705C68.646 41.3538 68.4166 41.1949 68.2235 40.9938C68.0303 40.7926 67.8795 40.5533 67.7708 40.2757C67.6622 39.9981 67.6079 39.6984 67.6079 39.3766C67.6079 39.0548 67.6622 38.7551 67.7708 38.4775C67.8795 38.1999 68.0303 37.9585 68.2235 37.7534C68.4166 37.5482 68.646 37.3873 68.9115 37.2706C69.1771 37.154 69.4668 37.0956 69.7806 37.0956C70.1186 37.0956 70.4203 37.156 70.6859 37.2767C70.9514 37.3973 71.1748 37.5603 71.3558 37.7654C71.5369 37.9706 71.6757 38.212 71.7722 38.4895C71.8688 38.7671 71.9171 39.0628 71.9171 39.3766C71.9171 39.6904 71.8688 39.986 71.7722 40.2636C71.6757 40.5412 71.5369 40.7826 71.3558 40.9877C71.1748 41.1929 70.9514 41.3538 70.6859 41.4705C70.4203 41.5871 70.1186 41.6455 69.7806 41.6455ZM75.3693 45.0971V41.2472H75.4055C75.6389 41.6012 75.9507 41.8728 76.341 42.0618C76.7313 42.2509 77.1276 42.3455 77.5299 42.3455C77.9725 42.3455 78.3729 42.269 78.731 42.1161C79.0891 41.9633 79.3949 41.7541 79.6483 41.4886C79.9018 41.2231 80.099 40.9093 80.2398 40.5472C80.3806 40.1852 80.451 39.795 80.451 39.3766C80.451 38.9582 80.3806 38.568 80.2398 38.2059C80.099 37.8439 79.9018 37.5301 79.6483 37.2646C79.3949 36.9991 79.0891 36.7899 78.731 36.637C78.3729 36.4841 77.9725 36.4077 77.5299 36.4077C77.1276 36.4077 76.7313 36.5022 76.341 36.6913C75.9507 36.8804 75.6389 37.16 75.4055 37.5301H75.3693V36.5525H74.5485V45.0971H75.3693ZM77.4454 41.6455C77.1316 41.6455 76.8419 41.5871 76.5764 41.4705C76.3108 41.3538 76.0815 41.1949 75.8883 40.9938C75.6952 40.7926 75.5443 40.5533 75.4357 40.2757C75.327 39.9981 75.2727 39.6984 75.2727 39.3766C75.2727 39.0548 75.327 38.7551 75.4357 38.4775C75.5443 38.1999 75.6952 37.9585 75.8883 37.7534C76.0815 37.5482 76.3108 37.3873 76.5764 37.2706C76.8419 37.154 77.1316 37.0956 77.4454 37.0956C77.7834 37.0956 78.0852 37.156 78.3507 37.2767C78.6163 37.3973 78.8396 37.5603 79.0207 37.7654C79.2017 37.9706 79.3405 38.212 79.4371 38.4895C79.5337 38.7671 79.5819 39.0628 79.5819 39.3766C79.5819 39.6904 79.5337 39.986 79.4371 40.2636C79.3405 40.5412 79.2017 40.7826 79.0207 40.9877C78.8396 41.1929 78.6163 41.3538 78.3507 41.4705C78.0852 41.5871 77.7834 41.6455 77.4454 41.6455Z"
            fill="black"
        />
        <g filter="url(#filter0_d_23_11619)">
            <path
                d="M44.2091 8H21.5716C14.5656 8 8.88623 13.6794 8.88623 20.6853V43.3147C8.88623 50.3206 14.5656 56 21.5716 56H44.2091C51.215 56 56.8945 50.3206 56.8945 43.3147V20.6853C56.8945 13.6794 51.215 8 44.2091 8Z"
                fill="black"
            />
        </g>
        <path
            d="M44.2091 8H21.5716C14.5656 8 8.88623 13.6794 8.88623 20.6853V43.3147C8.88623 50.3206 14.5656 56 21.5716 56H44.2091C51.215 56 56.8945 50.3206 56.8945 43.3147V20.6853C56.8945 13.6794 51.215 8 44.2091 8Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.4474 42.5068H52.0639V38.7976H48.4474V42.5068Z"
            fill="#FF2013"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.6521 21.5471L37.6521 29.7664C38.355 29.4759 39.1084 29.3266 39.8691 29.3274H39.8695C43.0908 29.3312 45.7013 31.9492 45.7047 35.1797V42.525H42.0886V35.1797C42.0886 33.9505 41.0948 32.9543 39.8691 32.9543C38.6754 32.9543 37.7014 33.8998 37.652 35.0852L37.6521 42.5242H34.0329V21.5471H37.6521Z"
            fill="#DA3AB3"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.8011 29.2671C24.823 29.2671 22.2167 31.273 21.4457 34.1578C20.6751 37.0427 21.9322 40.087 24.5113 41.58C27.0903 43.0734 30.3476 42.6435 32.4536 40.5315L29.8964 37.9674C29.0491 38.8171 27.7743 39.0716 26.6671 38.6114C25.5595 38.1515 24.8375 37.068 24.8375 35.8657C24.8375 34.6638 25.5595 33.58 26.6671 33.1201C27.7743 32.6603 29.0491 32.9144 29.8964 33.7641L32.4536 31.1996C31.2221 29.9581 29.5471 29.2621 27.8011 29.2671Z"
            fill="#FF8205"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.2142 29.3659V42.5288H15.6476V29.3659H19.2142ZM19.2142 21.5977V25.4818H15.6476V21.5977H19.2142Z"
            fill="#00B3E3"
        />
        <defs>
            <filter
                id="filter0_d_23_11619"
                x="2.04467"
                y="2.83244"
                width="61.6914"
                height="61.6831"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1.674" />
                <feGaussianBlur stdDeviation="3.42078" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.624858 0 0 0 0 0.624858 0 0 0 0 0.624858 0 0 0 0.5 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_23_11619"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_23_11619"
                    result="shape"
                />
            </filter>
        </defs>
    </MaterialIconWrapper>
);

export const IconContractPayoutXl = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 48 48"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 10C7 7.23857 9.23877 5 12 5H36C38.7612 5 41 7.23857 41 10V25.4426C40.3645 25.4182 39.7058 25.432 39 25.4794V10C39 8.34314 37.6567 7 36 7H12C10.3433 7 9 8.34314 9 10V38C9 39.6569 10.3433 41 12 41H23.0039V41.0039C23.0039 41.7585 23.286 42.4631 23.7643 43H12C9.23877 43 7 40.7614 7 38V10Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 28H23.1744C23.0643 28.3114 23.0039 28.6487 23.0039 29.0039V30H13C12.4478 30 12 29.5523 12 29C12 28.4477 12.4478 28 13 28Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.0039 33V35H13C12.4478 35 12 34.5523 12 34C12 33.4477 12.4478 33 13 33H23.0039Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 14C12 13.4477 12.4478 13 13 13H22C22.5522 13 23 13.4477 23 14C23 14.5523 22.5522 15 22 15H13C12.4478 15 12 14.5523 12 14Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 18H35C35.5522 18 36 18.4477 36 19C36 19.5523 35.5522 20 35 20H13C12.4478 20 12 19.5523 12 19C12 18.4477 12.4478 18 13 18Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 23H35C35.5522 23 36 23.4477 36 24C36 24.5523 35.5522 25 35 25H13C12.4478 25 12 24.5523 12 24C12 23.4477 12.4478 23 13 23Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.0039 36.0039C28.4519 36.0039 28.0039 35.5559 28.0039 35.0039C28.0039 34.4519 28.4519 34.0039 29.0039 34.0039C29.5559 34.0039 30.0039 34.4519 30.0039 35.0039C30.0039 35.5559 29.5559 36.0039 29.0039 36.0039Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M42.0039 35.0039C42.0039 34.4519 41.5559 34.0039 41.0039 34.0039C40.4519 34.0039 40.0039 34.4519 40.0039 35.0039C40.0039 35.5559 40.4519 36.0039 41.0039 36.0039C41.5559 36.0039 42.0039 35.5559 42.0039 35.0039Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.0041 39.0039C37.0624 39.0039 38.6831 37.1893 38.6831 35.0039C38.6831 32.8185 37.0624 31.0039 35.0041 31.0039C32.9451 31.0039 31.3251 32.8181 31.3251 35.0039C31.3251 37.1897 32.9451 39.0039 35.0041 39.0039ZM33.3251 35.0039C33.3251 33.8754 34.1033 33.0039 35.0041 33.0039C35.9043 33.0039 36.6831 33.8759 36.6831 35.0039C36.6831 36.1319 35.9043 37.0039 35.0041 37.0039C34.1033 37.0039 33.3251 36.1324 33.3251 35.0039Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.6991 41.9563C25.285 41.8238 25.0039 41.4388 25.0039 41.0039V29.0039C25.0039 28.3264 25.6634 27.845 26.3087 28.0515C28.6091 28.7876 30.4985 28.712 34.8459 28.0165C39.4985 27.272 41.6091 27.1876 44.3087 28.0515C44.7229 28.184 45.0039 28.569 45.0039 29.0039V41.0039C45.0039 41.6814 44.3444 42.1628 43.6991 41.9563C41.3987 41.2202 39.5093 41.2957 35.1619 41.9913C30.5093 42.7357 28.3987 42.8202 25.6991 41.9563ZM27.0039 30.3083V40.2519C29.0208 40.7657 30.9426 40.641 34.8459 40.0165C38.7293 39.3951 40.8418 39.2336 43.0039 39.6995V29.7559C40.987 29.2421 39.0652 29.3668 35.1619 29.9913C31.2785 30.6127 29.166 30.7742 27.0039 30.3083Z"
        />
    </MaterialIconWrapper>
);

export const IconLockClosed = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 25 24"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5 7C15.5 5.34328 14.1567 4 12.5 4C10.8433 4 9.50001 5.34328 9.50001 7V8H15.5V7ZM17.5 7V8H17.7363C19.2626 8 20.5003 9.23772 20.5003 10.764V19.236C20.5003 20.7623 19.2626 22 17.7363 22H7.26331C5.73704 22 4.50031 20.7623 4.50031 19.236V10.764C4.50031 9.2377 5.73704 8 7.26331 8H7.50001V7C7.50001 4.23872 9.73872 2 12.5 2C15.2613 2 17.5 4.23872 17.5 7ZM18.5003 19.236V10.764C18.5003 10.3423 18.158 10 17.7363 10H7.26331C6.84196 10 6.50031 10.3419 6.50031 10.764V19.236C6.50031 19.6581 6.84196 20 7.26331 20H17.7363C18.158 20 18.5003 19.6577 18.5003 19.236ZM12.5001 17C13.6041 17 14.5001 16.104 14.5001 15C14.5001 13.896 13.6041 13 12.5001 13C11.3961 13 10.5001 13.896 10.5001 15C10.5001 16.104 11.3961 17 12.5001 17Z"
        />
    </MaterialIconWrapper>
);

export const IconShowOn = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m55 287c-10-19-10-43 0-62 39-72 116-118 201-118 85 0 162 46 201 118 10 19 10 43 0 62-39 72-116 118-201 118-85 0-162-46-201-118z m201 76c69 0 132-38 164-97 3-6 3-14 0-20-32-59-95-97-164-97-69 0-132 38-164 97-3 6-3 14 0 20 32 59 95 97 164 97z m0-192c47 0 85 38 85 85 0 47-38 85-85 85-47 0-85-38-85-85 0-47 38-85 85-85z m0 42c-24 0-43 19-43 43 0 24 19 43 43 43 24 0 43-19 43-43 0-24-19-43-43-43z" />
    </MaterialIconWrapper>
);

export const IconShowOff = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m256 341c-8 0-15-1-22-3l106-103c2 7 3 14 3 21 0 47-39 85-87 85z m205-116c11 20 11 42 0 62-40 73-119 118-205 118-27 0-53-4-77-13l35-34c14 3 28 5 42 5 70 0 134-37 167-97 4-6 4-14 0-20-11-20-25-37-42-51l31-30c19 17 36 37 49 60z m-15-154c8 8 8 22 0 30l-349 342c-4 4-10 6-15 6-6 0-12-2-16-6-8-9-8-22 0-31l52-51c-27-19-51-44-67-74l0 0c-11-20-11-42 0-62 40-73 119-118 205-118 35 0 69 8 99 22l60-58c8-8 22-8 31 0z m-190 100c16 0 31 4 44 12l23-22c-21-7-44-12-67-12-70 0-134 37-167 97-4 6-4 14 0 20 15 27 36 48 61 65l31-32c-7-12-12-27-12-43 0-47 39-85 87-85z m-42 96l54-52c-4-1-8-2-12-2-24 0-44 19-44 43 0 4 1 8 2 11z" />
    </MaterialIconWrapper>
);

export const IconPluginBudgets = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m59 320c-10-11-16-26-16-43l0-42c0-17 6-32 16-43-10-11-16-26-16-43l0-42c0-36 28-64 64-64l298 0c36 0 64 28 64 64l0 42c0 17-6 32-16 43 10 11 16 26 16 43l0 42c0 17-6 32-16 43 10 11 16 26 16 43l0 42c0 36-28 64-64 64l-298 0c-36 0-64-28-64-64l0-42c0-17 6-32 16-43z m346-21c12 0 22-10 22-22l0-42c0-12-10-22-22-22l-298 0c-12 0-22 10-22 22l0 42c0 12 10 22 22 22z m-33-128l31 0 24-24 0-31z m-90 0l30 0 85-86-30 0z m-91 0l31 0 85-86-30 0z m-60 0l85-86-29 0-85 85c2 1 3 1 5 1z m-4-86l-20 0c-12 0-22 10-22 22l0 20z m-20 256c-12 0-22 10-22 22l0 42c0 12 10 22 22 22l298 0c12 0 22-10 22-22l0-42c0-12-10-22-22-22z" />
    </MaterialIconWrapper>
);

export const IconProductSorting = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m149 107l0 42-42 0 0-42c0-24 19-43 42-43l278 0c23 0 42 19 42 43l0 64c0 23-19 42-42 42l-22 0 0-42 22 0 0-64z m-42 256l42 0 0 42 278 0 0-64-22 0 0-42 22 0c23 0 42 19 42 42l0 64c0 24-19 43-42 43l-278 0c-23 0-42-19-42-43z m234-22l-277 0c-24 0-43-19-43-42l0-86c0-23 19-42 43-42l277 0c24 0 43 19 43 42l0 86c0 23-19 42-43 42z m0-42l0-86-277 0 0 86z" />
    </MaterialIconWrapper>
);

export const IconFile = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m384 405c0 12-10 22-21 22l-214 0c-11 0-21-10-21-22l0-298c0-12 10-22 21-22l107 0 0 107c0 12 10 21 21 21l107 0z m-9-234l-76 0 0-77z m39-22l-94-94c-8-8-19-12-30-12l-141 0c-35 0-64 28-64 64l0 298c0 36 29 64 64 64l214 0c35 0 64-28 64-64l0-225c0-12-5-23-13-31z" />
    </MaterialIconWrapper>
);

export const IconArrowLeft = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m153 235l252 0c12 0 22 10 22 22 0 12-10 21-22 21l-252 0 113 113c8 8 8 22 0 30-9 8-22 8-30 0l-150-149c-8-8-8-22 0-30l150-150c8-8 21-8 30 0 8 9 8 22 0 31z" />
    </MaterialIconWrapper>
);

export const IconPlaceholder = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m64 107c-12 0-21 9-21 21l0 256c0 12 9 21 21 21l384 0c12 0 21-9 21-21l0-256c0-12-9-21-21-21z m0-43l384 0c35 0 64 29 64 64l0 256c0 35-29 64-64 64l-384 0c-35 0-64-29-64-64l0-256c0-35 29-64 64-64z" />
    </MaterialIconWrapper>
);

export const IconDropDown = (props: {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 24 24"
    >
        <path d="M7 10l5 5 5-5z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </MaterialIconWrapper>
);

export const IconInfo = (props: {
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper style={props.style} onClick={props.onClick}>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
    </MaterialIconWrapper>
);

export const IconCheck = (props: {
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper style={props.style} onClick={props.onClick}>
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
    </MaterialIconWrapper>
);

export const IconCancelCircle = (props: {
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper style={props.style} onClick={props.onClick}>
        <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </MaterialIconWrapper>
);

export const IconFastForward = (props: { style?: React.CSSProperties }) => (
    <MaterialIconWrapper style={props.style}>
        <path d="M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </MaterialIconWrapper>
);

export const IconFastRewind = (props: { style?: React.CSSProperties }) => (
    <MaterialIconWrapper style={props.style}>
        <path d="M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </MaterialIconWrapper>
);

export const IconZoomIn = (props: {
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper style={props.style} onClick={props.onClick}>
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z" />
    </MaterialIconWrapper>
);

export const IconZoomOut = (props: {
    style?: React.CSSProperties;
    onClick?: () => void;
}) => (
    <MaterialIconWrapper style={props.style} onClick={props.onClick}>
        <path fill="none" d="M0 0h24v24H0V0z" />
        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z" />
    </MaterialIconWrapper>
);

export const IconChevronLeft = (props: {
    onClick?: () => void;
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
    >
        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </MaterialIconWrapper>
);

export const IconChevronRight = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper className={props.className} style={props.style}>
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </MaterialIconWrapper>
);

export const IconChevronDown = (props: {
    onClick?: () => void;
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m256 290l92-92c8-8 21-8 30 0 8 9 8 22 0 30l-107 107c-8 8-22 8-30 0l-107-107c-8-8-8-21 0-30 9-8 22-8 30 0z" />
    </MaterialIconWrapper>
);

export const IconChevronUp = (props: {
    onClick?: () => void;
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        onClick={props.onClick}
        viewBox="0 0 512 512"
    >
        <path d="m256 222l92 92c8 8 21 8 30 0 8-9 8-22 0-30l-107-107c-8-8-22-8-30 0l-107 107c-8 8-8 21 0 30 9 8 22 8 30 0z" />
    </MaterialIconWrapper>
);

export const IconCheckbox = (props: {
    className?: string;
    onClick?: () => void;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        style={props.style}
        onClick={props.onClick}
        className={props.className}
    >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
    </MaterialIconWrapper>
);

export const IconCheckboxOutline = (props: {
    className?: string;
    onClick?: () => void;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        style={props.style}
        onClick={props.onClick}
        className={props.className}
    >
        <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
        <path d="M0 0h24v24H0z" fill="none" />
    </MaterialIconWrapper>
);

export const IconComputer = (props: { style?: React.CSSProperties }) => (
    <MaterialIconWrapper style={props.style}>
        <path
            d="M12.999,17.0364 L12.999,19.0306 L16.998,19.0306 C17.5502847,19.0306 17.998,19.4783153 17.998,20.0306 C17.998,20.5828847 17.5502847,21.0306 16.998,21.0306 L12.1073329,21.0306 C12.0717479,21.0344334 12.0356036,21.0364 11.999,21.0364 C11.9623964,21.0364 11.9262521,21.0344334 11.8906671,21.0306 L7,21.0306 C6.44771525,21.0306 6,20.5828847 6,20.0306 C6,19.4783153 6.44771525,19.0306 7,19.0306 L10.999,19.0306 L10.999,17.0364 L5,17.0364 C3.34371525,17.0364 2,15.6926847 2,14.0364 L2,6.0364 C2,4.37938323 3.34344712,3.0364 5,3.0364 L19,3.0364 C20.6565529,3.0364 22,4.37938323 22,6.0364 L22,14.0364 C22,15.6926847 20.6562847,17.0364 19,17.0364 L12.999,17.0364 Z M19,15.0364 C19.5517153,15.0364 20,14.5881153 20,14.0364 L20,6.0364 C20,5.48410738 19.552138,5.0364 19,5.0364 L5,5.0364 C4.44786203,5.0364 4,5.48410738 4,6.0364 L4,14.0364 C4,14.5881153 4.44828475,15.0364 5,15.0364 L19,15.0364 Z"
            id="path-1"
        />
    </MaterialIconWrapper>
);

export const IconPhone = (props: { style?: React.CSSProperties }) => (
    <MaterialIconWrapper style={props.style}>
        <>
            <defs>
                <path
                    d="M9,19.9921 L3,19.9921 C1.34371525,19.9921 0,18.6483847 0,16.9921 L0,3.0001 C0,1.34308323 1.34344712,0.000100000001 3,0.000100000001 L9,0.000100000001 C10.6565529,0.000100000001 12,1.34308323 12,3.0001 L12,16.9921 C12,18.6483847 10.6562847,19.9921 9,19.9921 Z M9,17.9921 C9.55171525,17.9921 10,17.5438153 10,16.9921 L10,3.0001 C10,2.44780738 9.55213797,2.0001 9,2.0001 L3,2.0001 C2.44786203,2.0001 2,2.44780738 2,3.0001 L2,16.9921 C2,17.5438153 2.44828475,17.9921 3,17.9921 L9,17.9921 Z M2,4.9999 L2,3.9999 L10,3.9999 L10,4.9999 L2,4.9999 Z M2,15.9999 L2,14.9999 L10,14.9999 L10,15.9999 L2,15.9999 Z"
                    id="path-1"
                />
            </defs>
            <mask id="mask-2" fill="white">
                <use href="#path-1" />
            </mask>
            <g id="📱-Screens" stroke="none">
                <g
                    id="12-Profile-2---Signing"
                    transform="translate(-16.000000, -324.000000)"
                >
                    <g id="View-Content">
                        <g
                            id="Cell-/-01-Default"
                            transform="translate(0.000000, 304.000000)"
                        >
                            <g
                                id="🔧-Left"
                                transform="translate(22.000000, 11.000000)"
                            >
                                <g
                                    id="🔧-Left-2"
                                    transform="translate(0.000000, 11.000000)"
                                >
                                    <g id="secondary-200" mask="url(#mask-2)">
                                        <g
                                            transform="translate(-6.000000, -2.000000)"
                                            id="bg_color"
                                        >
                                            <polygon points="0 0 24.8447205 0 24.8447205 23.7714286 0 23.7714286" />
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </>
    </MaterialIconWrapper>
);

export const IconSearch = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper className={props.className} style={props.style}>
        <path
            d="M9.999,1.9993 C14.4152847,1.9993 17.999,5.58301525 17.999,9.9993 C17.999,11.9029815 17.3331016,13.6519614 16.2216611,15.0258834 C16.399718,15.0643812 16.56866,15.1537465 16.7071068,15.2921932 L16.7071068,15.2921932 L20.7071068,19.2921932 C21.0976311,19.6827175 21.0976311,20.3158825 20.7071068,20.7064068 C20.3165825,21.0969311 19.6834175,21.0969311 19.2928932,20.7064068 L19.2928932,20.7064068 L15.2928932,16.7064068 C15.1544465,16.56796 15.0650812,16.399018 15.0247974,16.2212027 C13.6525026,17.3330813 11.9031394,17.9993 9.999,17.9993 C5.58271525,17.9993 1.999,14.4155847 1.999,9.9993 C1.999,5.58301525 5.58271525,1.9993 9.999,1.9993 Z M9.999,3.9993 C6.68728475,3.9993 3.999,6.68758475 3.999,9.9993 C3.999,13.3110153 6.68728475,15.9993 9.999,15.9993 C13.3107153,15.9993 15.999,13.3110153 15.999,9.9993 C15.999,6.68758475 13.3107153,3.9993 9.999,3.9993 Z"
            id="path-1"
        />
        {/* <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" /><path d="M0 0h24v24H0z" fill="none" /> */}
    </MaterialIconWrapper>
);

export const IconFreeze = (props: { style?: React.CSSProperties }) => (
    <MaterialIconWrapper style={props.style}>
        <rect
            width="24"
            height="24"
            transform="translate(0.5)"
            fill="white"
            fillOpacity="0.01"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.5199 2C13.0668 2 13.5101 2.44825 13.5101 3.00119V4.02295L14.8751 3.33286C15.3643 3.08558 15.9591 3.28604 16.2036 3.78061C16.4482 4.27518 16.2499 4.87656 15.7608 5.12385L13.5101 6.26168V8.80363L14.8043 9.55913L16.8641 8.35669L16.8635 8.34714L16.7058 5.69117C16.6731 5.13922 17.089 4.66492 17.6349 4.63179C18.1808 4.59866 18.6499 5.01925 18.6827 5.57119L18.7816 7.23736L19.7545 6.66943C20.2281 6.39296 20.8336 6.55703 21.1071 7.03589C21.3805 7.51475 21.2182 8.12707 20.7446 8.40354L19.8526 8.92428L21.0558 9.72749C21.5121 10.0322 21.6378 10.6532 21.3365 11.1146C21.0352 11.5761 20.421 11.7032 19.9646 11.3985L17.9351 10.0436L15.6913 11.3535V12.7671L17.7488 13.9681L17.7666 13.9559L19.9627 12.4899C20.419 12.1852 21.0333 12.3123 21.3346 12.7737C21.6359 13.2352 21.5102 13.8562 21.0538 14.1609L19.666 15.0874L20.7248 15.7054C21.1984 15.9819 21.3607 16.5942 21.0873 17.0731C20.8138 17.5519 20.2082 17.716 19.7346 17.4395L18.7664 16.8743L18.6807 18.3171C18.648 18.869 18.1789 19.2896 17.633 19.2565C17.0871 19.2233 16.6711 18.749 16.7039 18.1971L16.8489 15.755L14.6387 14.4647L14.6177 14.4522L13.4705 15.1219V17.5897L15.7424 18.7653C16.2292 19.0172 16.4219 19.6204 16.1727 20.1127C15.9236 20.6049 15.327 20.7997 14.8402 20.5478L13.4705 19.839V20.9988C13.4705 21.5518 13.0272 22 12.4803 22C11.9334 22 11.4901 21.5518 11.4901 20.9988V19.813L10.0932 20.5028C9.60176 20.7454 9.00886 20.5393 8.76889 20.0424C8.52892 19.5456 8.73275 18.9461 9.22415 18.7035L11.4901 17.5846V15.1214L10.3239 14.4407L8.14665 15.7117L8.27138 18.2034C8.29903 18.7556 7.87868 19.2259 7.33251 19.2539C6.78634 19.2818 6.32117 18.8568 6.29353 18.3046L6.22002 16.8363L5.30968 17.3678C4.83608 17.6442 4.23049 17.4802 3.95705 17.0013C3.68362 16.5224 3.84588 15.9101 4.31949 15.6337L5.31737 15.0511L3.95879 14.1255C3.50527 13.8166 3.38534 13.1944 3.69093 12.7358C3.99651 12.2772 4.61189 12.156 5.06542 12.465L7.22602 13.9369L9.27003 12.7437V11.2845L7.09017 10.012L5.02862 11.3604C4.56944 11.6607 3.95642 11.5278 3.65939 11.0635C3.36237 10.5992 3.49381 9.97941 3.95299 9.67909L5.16355 8.88731L4.33931 8.40615C3.86571 8.12968 3.70344 7.51736 3.97687 7.0385C4.25031 6.55964 4.8559 6.39557 5.32951 6.67204L6.25092 7.20992L6.36526 5.54509C6.40314 4.99347 6.87611 4.57735 7.42167 4.61566C7.96722 4.65396 8.37877 5.13218 8.34089 5.6838L8.15956 8.32411L10.2161 9.52465L11.5297 8.7578V6.28001L9.2428 5.12385C8.75367 4.87656 8.55541 4.27518 8.79997 3.78061C9.04454 3.28604 9.63933 3.08558 10.1285 3.33286L11.5297 4.04128V3.00119C11.5297 2.44825 11.9731 2 12.5199 2ZM12.4807 10.5148L11.2504 11.233V12.6694L12.4807 13.3875L13.7109 12.6694V11.233L12.4807 10.5148Z"
            fill="#A3B5C9"
        />
    </MaterialIconWrapper>
);

export const IconAlimonyLegal = (props: { style?: React.CSSProperties }) => (
    <MaterialIconWrapper style={props.style}>
        <rect
            width="24"
            height="24"
            transform="translate(0.5)"
            fill="white"
            fillOpacity="0.01"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.2324 4H20.5C21.0523 4 21.5 4.44772 21.5 5C21.5 5.52916 21.089 5.96233 20.5688 5.99767L23.1704 12.8113C23.3675 13.3275 23.567 14.0448 23.3926 14.8109C22.9833 16.6085 21.4225 18 19.4993 18C17.576 18 16.0152 16.6085 15.606 14.8109C15.4316 14.0448 15.6311 13.3275 15.8282 12.8113L18.4289 6H14.2324C14.0568 6.30363 13.8036 6.5568 13.5 6.73244V20H16.5C17.0523 20 17.5 20.4477 17.5 21C17.5 21.5523 17.0523 22 16.5 22H8.5C7.94772 22 7.5 21.5523 7.5 21C7.5 20.4477 7.94772 20 8.5 20H11.5V6.73244C11.1964 6.5568 10.9432 6.30363 10.7676 6H6.56968L9.17036 12.8113C9.36747 13.3275 9.56697 14.0448 9.39257 14.8109C8.98335 16.6085 7.42248 18 5.49927 18C3.57605 18 2.01518 16.6085 1.60596 14.8109C1.43156 14.0448 1.63107 13.3275 1.82817 12.8113L4.42978 5.99757C3.91026 5.96153 3.5 5.52868 3.5 5C3.5 4.44772 3.94772 4 4.5 4H10.7676C11.1134 3.4022 11.7597 3 12.5 3C13.2403 3 13.8866 3.4022 14.2324 4ZM3.89695 13H7.10158L5.49927 8.80346L3.89695 13ZM3.55806 14C3.53223 14.1495 3.53379 14.2691 3.55607 14.367C3.77642 15.3349 4.58977 16 5.49927 16C6.40876 16 7.22211 15.3349 7.44246 14.367C7.46474 14.2691 7.4663 14.1495 7.44047 14H3.55806ZM19.4993 8.80346L17.897 13H21.1016L19.4993 8.80346ZM17.5561 14.367C17.7764 15.3349 18.5898 16 19.4993 16C20.4088 16 21.2221 15.3349 21.4425 14.367C21.4647 14.2691 21.4663 14.1495 21.4405 14H17.5581C17.5322 14.1495 17.5338 14.2691 17.5561 14.367Z"
            fill="#A3B5C9"
        />
    </MaterialIconWrapper>
);

export const IconWrench = (props: { style?: React.CSSProperties }) => (
    <MaterialIconWrapper style={props.style}>
        <rect
            width="24"
            height="24"
            transform="translate(0.5)"
            fill="white"
            fillOpacity="0.01"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.50049 9C8.50313 5.13405 11.6343 2 15.5003 2C16.5256 2 17.502 2.22107 18.3821 2.6191C18.6813 2.75439 18.895 3.0279 18.9539 3.35089C19.0128 3.67388 18.9093 4.00521 18.6772 4.23736L15.4145 7.5L17.0003 9.08579L20.263 5.82315C20.4951 5.59099 20.8265 5.48759 21.1494 5.54647C21.4724 5.60536 21.7459 5.81905 21.8812 6.1182C22.2793 6.99833 22.5003 7.9747 22.5003 9C22.5003 12.866 19.3663 16 15.5003 16C14.7239 16 13.9755 15.8732 13.2757 15.6388C13.2757 15.6388 7.1956 21.719 6.41455 22.5M6.41455 22.5C5.6335 23.281 4.36717 23.281 3.58612 22.5L2.00034 20.9142C1.21929 20.1332 1.21929 18.8668 2.00034 18.0858L8.86152 11.2246C8.62712 10.5248 8.49989 9.88013 8.50049 9M15.5003 4C12.7389 4 10.5003 6.23858 10.5003 9C10.5003 9.73551 10.6585 10.4314 10.9417 11.0577C11.1132 11.4369 11.032 11.8826 10.7377 12.1768L3.41455 19.5L5.00034 21.0858L12.3235 13.7626C12.6177 13.4684 13.0635 13.3871 13.4427 13.5586C14.069 13.8418 14.7648 14 15.5003 14C18.2618 14 20.5003 11.7614 20.5003 9C20.5003 8.81212 20.49 8.62683 20.4699 8.44462L17.7074 11.2071C17.5199 11.3946 17.2656 11.5 17.0003 11.5C16.7351 11.5 16.4808 11.3946 16.2932 11.2071L13.2932 8.20711C13.1057 8.01957 13.0003 7.76522 13.0003 7.5C13.0003 7.23478 13.1057 6.98043 13.2932 6.79289L16.0557 4.03041C15.8735 4.01032 15.6882 4 15.5003 4Z"
            fill="#A3B5C9"
        />
    </MaterialIconWrapper>
);

export const IconElectronics = (props: { style?: React.CSSProperties }) => (
    <MaterialIconWrapper style={props.style}>
        <rect
            width="24"
            height="24"
            transform="translate(0.5)"
            fill="white"
            fillOpacity="0.01"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.50078 6.99992C9.05307 6.99991 9.50079 7.44762 9.5008 7.99991L9.50081 9H10.5C11.0523 9 11.5 9.44772 11.5 10C11.5 10.5523 11.0523 11 10.5 11H9.50083L9.50084 11.9999C9.50085 12.5522 9.05314 12.9999 8.50086 12.9999C7.94857 12.9999 7.50085 12.5522 7.50084 11.9999L7.50083 11H6.5C5.94772 11 5.5 10.5523 5.5 10C5.5 9.44772 5.94772 9 6.5 9H7.50081L7.5008 7.99993C7.50079 7.44765 7.9485 6.99993 8.50078 6.99992Z"
            fill="#A3B5C9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.5 11.5C19.5 12.3284 18.8284 13 18 13C17.1716 13 16.5 12.3284 16.5 11.5C16.5 10.6716 17.1716 10 18 10C18.8284 10 19.5 10.6716 19.5 11.5Z"
            fill="#A3B5C9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 10C14.1716 10 13.5 9.32843 13.5 8.5C13.5 7.67157 14.1716 7 15 7C15.8284 7 16.5 7.67157 16.5 8.5C16.5 9.32843 15.8284 10 15 10Z"
            fill="#A3B5C9"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.6187 3.44233C19.8716 3.86474 21.6505 5.59847 22.1308 7.83968L23.6998 15.1618C24.2334 17.6518 22.3352 19.9999 19.7886 19.9999H18.8856C17.635 19.9999 16.5157 19.2242 16.0766 18.0533L15.3066 15.9999H9.69255L8.92254 18.0533C8.48345 19.2242 7.36408 19.9999 6.11355 19.9999H5.21051C2.66394 19.9999 0.765721 17.6518 1.2993 15.1618L2.86833 7.83968C3.34859 5.59847 5.12754 3.86474 7.38037 3.44233C10.7637 2.80796 14.2354 2.80796 17.6187 3.44233ZM17.2502 5.40807C14.1104 4.81938 10.8887 4.81938 7.74895 5.40807C6.28851 5.68191 5.13527 6.80583 4.82393 8.25874L3.25491 15.5809C2.98812 16.8259 3.93722 17.9999 5.21051 17.9999H6.11355C6.53039 17.9999 6.90351 17.7413 7.04988 17.351L8.06322 14.6488C8.20959 14.2585 8.58271 13.9999 8.99955 13.9999H15.9996C16.4164 13.9999 16.7895 14.2585 16.9359 14.6488L17.9492 17.351C18.0956 17.7413 18.4687 17.9999 18.8856 17.9999H19.7886C21.0619 17.9999 22.011 16.8259 21.7442 15.5808L20.1752 8.25874C19.8638 6.80583 18.7106 5.68191 17.2502 5.40807Z"
            fill="#A3B5C9"
        />
    </MaterialIconWrapper>
);
export const IconPet = (props: { style?: React.CSSProperties }) => (
    <MaterialIconWrapper style={props.style}>
        <rect
            width="24"
            height="24"
            transform="translate(0.5)"
            fill="white"
            fillOpacity="0.01"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.02664 3.19258C7.4994 2.57197 8.22449 2.10205 9.10388 2.10205C9.98192 2.10205 10.7063 2.57235 11.1785 3.19209C11.6504 3.81129 11.9139 4.62307 11.9139 5.47905C11.9139 6.33505 11.6509 7.1472 11.1793 7.76691C10.7071 8.38728 9.98263 8.85805 9.10388 8.85805C8.22507 8.85805 7.50012 8.38773 7.02744 7.76734C6.55529 7.14765 6.29187 6.33534 6.29187 5.47905C6.29187 4.62403 6.55464 3.81219 7.02664 3.19258ZM8.61761 4.40452C8.43411 4.64541 8.29187 5.02207 8.29187 5.47905C8.29187 5.93676 8.43446 6.31395 8.61831 6.55526C8.80163 6.79587 8.98268 6.85805 9.10388 6.85805C9.22412 6.85805 9.40461 6.79632 9.58773 6.5557C9.77137 6.3144 9.91387 5.93705 9.91387 5.47905C9.91387 5.02203 9.7714 4.64531 9.58772 4.40426C9.40446 4.16375 9.22383 4.10205 9.10388 4.10205C8.98126 4.10205 8.80035 4.16463 8.61761 4.40452ZM13.8207 3.19272C14.2927 2.57275 15.0172 2.10205 15.8959 2.10205C16.7746 2.10205 17.4991 2.57201 17.9715 3.19238C18.4432 3.81188 18.7059 4.62366 18.7059 5.47905C18.7059 6.33417 18.4441 7.14633 17.9727 7.76647C17.5004 8.38778 16.7756 8.85805 15.8959 8.85805C15.0174 8.85805 14.293 8.38711 13.821 7.76705C13.3493 7.1475 13.0859 6.33534 13.0859 5.47905C13.0859 4.62374 13.3491 3.81205 13.8207 3.19272ZM15.4118 4.40438C15.2282 4.64555 15.0859 5.02236 15.0859 5.47905C15.0859 5.93676 15.2285 6.31411 15.4123 6.55555C15.5957 6.79649 15.7763 6.85805 15.8959 6.85805C16.0182 6.85805 16.1983 6.79582 16.3805 6.55614C16.5636 6.31527 16.7059 5.93793 16.7059 5.47905C16.7059 5.02144 16.5636 4.64473 16.3803 4.40397C16.1976 4.16409 16.0172 4.10205 15.8959 4.10205C15.7756 4.10205 15.595 4.16385 15.4118 4.40438ZM1.29688 11.5171C1.29688 9.87275 2.39871 8.14005 4.19887 8.14005C5.99597 8.14005 7.10087 9.86942 7.10087 11.5171C7.10087 13.1628 5.99951 14.8961 4.19887 14.8961C2.39824 14.8961 1.29688 13.1628 1.29688 11.5171ZM4.19887 10.1401C3.89704 10.1401 3.29688 10.5373 3.29688 11.5171C3.29688 12.4993 3.89751 12.8961 4.19887 12.8961C4.50024 12.8961 5.10087 12.4993 5.10087 11.5171C5.10087 10.5367 4.49978 10.1401 4.19887 10.1401ZM17.8989 11.5171C17.8989 9.87275 19.0007 8.14005 20.8009 8.14005C22.6006 8.14005 23.7029 9.87016 23.7029 11.5171C23.7029 13.1628 22.6015 14.8961 20.8009 14.8961C19.0002 14.8961 17.8989 13.1628 17.8989 11.5171ZM20.8009 10.1401C20.499 10.1401 19.8989 10.5373 19.8989 11.5171C19.8989 12.4993 20.4995 12.8961 20.8009 12.8961C21.1022 12.8961 21.7029 12.4993 21.7029 11.5171C21.7029 10.5359 21.1032 10.1401 20.8009 10.1401ZM9.74743 14.7125C9.07635 15.6552 8.74388 16.8392 8.74388 17.727C8.74388 18.3536 9.08554 18.8615 9.79463 19.2635C10.5241 19.6772 11.5326 19.8981 12.4999 19.8981C13.467 19.8981 14.4755 19.677 15.205 19.2632C15.9143 18.8609 16.2559 18.353 16.2559 17.727C16.2559 16.8392 15.9234 15.6552 15.2523 14.7125C14.597 13.7918 13.6838 13.1791 12.4999 13.1791C11.3159 13.1791 10.4028 13.7918 9.74743 14.7125ZM8.11807 13.5526C9.04796 12.2463 10.5128 11.1791 12.4999 11.1791C14.4869 11.1791 15.9518 12.2463 16.8817 13.5526C17.7959 14.8369 18.2559 16.4269 18.2559 17.727C18.2559 19.2891 17.3134 20.3667 16.1917 21.0029C15.0902 21.6276 13.7207 21.8981 12.4999 21.8981C11.2792 21.8981 9.90968 21.6279 8.80812 21.0033C7.68621 20.3671 6.74388 19.2895 6.74388 17.727C6.74388 16.4269 7.2039 14.8369 8.11807 13.5526Z"
            fill="#A3B5C9"
        />
    </MaterialIconWrapper>
);
export const IconSport = (props: { style?: React.CSSProperties }) => (
    <MaterialIconWrapper style={props.style}>
        <rect
            width="24"
            height="24"
            transform="translate(0.5)"
            fill="white"
            fillOpacity="0.01"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.5 4H11C11.5523 4 12 4.44772 12 5C12 5.55228 11.5523 6 11 6H10.1328L10.3748 7.9364L16.8587 7.01013C16.9061 7.00336 16.9533 7.00004 17 7V6C17 5.44772 17.4477 5 18 5H21C21.5523 5 22 5.44772 22 6C22 6.55228 21.5523 7 21 7H19V8C19 8.44346 18.7113 8.8195 18.3117 8.95048L18.6157 10.0146C18.7425 10.0049 18.8707 10 19 10C21.7614 10 24 12.2386 24 15C24 17.7614 21.7614 20 19 20C16.2386 20 14 17.7614 14 15C14 13.0709 15.0924 11.397 16.6924 10.5632L16.2782 9.11337L10.5841 9.9268L9.54961 11.4786C10.4462 12.3823 11 13.6265 11 15C11 17.7614 8.76142 20 6 20C3.23858 20 1 17.7614 1 15C1 12.2386 3.23858 10 6 10C6.66737 10 7.30421 10.1308 7.88629 10.368L8.56372 9.35189C8.53673 9.27991 8.51767 9.20366 8.50772 9.12403L8.11722 6H7.5C6.94772 6 6.5 5.55228 6.5 5C6.5 4.44772 6.94772 4 7.5 4ZM17.2614 12.5548C16.4979 13.0987 16 13.9912 16 15C16 16.6569 17.3431 18 19 18C20.6569 18 22 16.6569 22 15C22 13.4051 20.7555 12.1009 19.1845 12.0056L19.9616 14.7254C20.1134 15.2564 19.8059 15.8099 19.2748 15.9616C18.7438 16.1133 18.1903 15.8058 18.0386 15.2748L17.2614 12.5548ZM5.16806 14.4454L6.73744 12.0913C6.50151 12.0317 6.25446 12 6 12C4.34315 12 3 13.3431 3 15C3 16.6569 4.34315 18 6 18C7.65685 18 9 16.6569 9 15C9 14.3252 8.77721 13.7024 8.40117 13.2013L6.83216 15.5548C6.5258 16.0143 5.90493 16.1385 5.44541 15.8321C4.98588 15.5258 4.8617 14.9049 5.16806 14.4454Z"
            fill="#A3B5C9"
        />
    </MaterialIconWrapper>
);
export const IconBrokenGlass = (props: { style?: React.CSSProperties }) => (
    <MaterialIconWrapper style={props.style}>
        <rect
            width="24"
            height="24"
            transform="translate(0.5)"
            fill="white"
            fillOpacity="0.01"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.5 3C3.5 2.44772 3.94772 2 4.5 2H11.4611C11.7674 2 12.0568 2.14038 12.2465 2.38093C12.4361 2.62148 12.505 2.93567 12.4335 3.23351L11.9307 5.32733L14.1514 6.63896C14.5081 6.84964 14.698 7.25846 14.6288 7.66693L14.1665 10.3975L16.6606 12.0343L20.0079 11.0413C20.3105 10.9515 20.6376 11.0099 20.8905 11.1986C21.1434 11.3874 21.2924 11.6844 21.2924 12V21.0001C21.2924 21.5524 20.8446 22.0001 20.2924 22.0001H4.5C3.94772 22.0001 3.5 21.5524 3.5 21.0001V3ZM12.5036 7.98851L10.2772 6.67353C9.89895 6.45015 9.71079 6.0061 9.81336 5.57899L10.1926 4H5.5V20.0001H19.2924V13.3397L16.7844 14.0837C16.5022 14.1674 16.1974 14.1225 15.9513 13.961L13.7639 12.5255L13.486 14.1669C13.3938 14.7115 12.8776 15.0782 12.3331 14.986C11.7885 14.8938 11.4218 14.3776 11.514 13.8331L12.5036 7.98851ZM13.8603 2.62096C14.0142 2.24535 14.3798 2 14.7857 2H20.5C21.0523 2 21.5 2.44772 21.5 3V8.62499C21.5 9.02802 21.2581 9.39166 20.8863 9.54736C20.5146 9.70306 20.0857 9.62038 19.7985 9.33765L14.0842 3.71265C13.7949 3.42791 13.7065 2.99656 13.8603 2.62096ZM17.2271 4L19.5 6.23741V4H17.2271Z"
            fill="#A3B5C9"
        />
    </MaterialIconWrapper>
);

export const IconExtendedPremiumRisks = (props: {
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper style={props.style} viewBox="0 0 256 256">
        <rect width="256" height="256" fill="white" fillOpacity="0.01" />
        <path
            d="M88,128a8,8,0,0,1,8-8h24V96a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16H136v24a8,8,0,0,1-16,0V136H96A8,8,0,0,1,88,128ZM224,56v56c0,52.72-25.52,84.67-46.93,102.19-23.06,18.86-46,25.27-47,25.53a8,8,0,0,1-4.2,0c-1-.26-23.91-6.67-47-25.53C57.52,196.67,32,164.72,32,112V56A16,16,0,0,1,48,40H208A16,16,0,0,1,224,56Zm-16,0L48,56l0,56c0,37.3,13.82,67.51,41.07,89.81A128.25,128.25,0,0,0,128,223.62a129.3,129.3,0,0,0,39.41-22.2C194.34,179.16,208,149.07,208,112Z"
            fill="#A3B5C9"
        ></path>
    </MaterialIconWrapper>
);

export const IconHouseholdElectronics = (props: {
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper style={props.style} viewBox="0 0 256 256">
        <rect width="256" height="256" fill="white" fillOpacity="0.01" />
        <path
            d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208ZM72,76A12,12,0,1,1,84,88,12,12,0,0,1,72,76Zm44,0a12,12,0,1,1,12,12A12,12,0,0,1,116,76Zm44,0a12,12,0,1,1,12,12A12,12,0,0,1,160,76Zm24,28H72a8,8,0,0,0-8,8v72a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V112A8,8,0,0,0,184,104Zm-8,72H80V120h96Z"
            fill="#A3B5C9"
        ></path>
    </MaterialIconWrapper>
);

export const IconGeorgeApp = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 24 24"
    >
        <rect width="24" height="24" fill="white" fill-opacity="0.01" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.5003 8.00431C18.5003 4.41781 15.5824 1.49994 11.9959 1.49994C8.40923 1.49994 5.49154 4.41781 5.49154 8.00431C5.49154 11.5908 8.40923 14.5087 11.9959 14.5087C15.5824 14.5087 18.5003 11.5908 18.5003 8.00431ZM16.4546 15.9956C16.4546 18.4496 14.4581 20.446 12.0041 20.446V22.5C15.5906 22.5 18.5086 19.5821 18.5086 15.9956H16.4546ZM7.54541 8.00431C7.54541 5.5505 9.54191 3.554 11.9959 3.554C14.4497 3.554 16.4462 5.5505 16.4462 8.00431C16.4462 10.4583 14.4497 12.4546 11.9959 12.4546C9.54191 12.4546 7.54541 10.4583 7.54541 8.00431Z"
            fill="#135EE2"
        />
    </MaterialIconWrapper>
);

export const IconGJuniorGeorgeLogo = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 24 24"
    >
        <rect width="24" height="24" fill="white" fill-opacity="0.01" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.5009 8.00437C18.5009 4.41788 15.5831 1.5 11.9966 1.5C8.40987 1.5 5.49219 4.41788 5.49219 8.00437C5.49219 11.5909 8.40987 14.5087 11.9966 14.5087C15.5831 14.5087 18.5009 11.5909 18.5009 8.00437ZM16.4552 15.9957C16.4552 18.4497 14.4587 20.446 12.0047 20.446V22.5001C15.5912 22.5001 18.5093 19.5822 18.5093 15.9957H16.4552ZM7.54606 8.00438C7.54606 5.55056 9.54256 3.55406 11.9966 3.55406C14.4504 3.55406 16.4469 5.55056 16.4469 8.00438C16.4469 10.4584 14.4504 12.4547 11.9966 12.4547C9.54256 12.4547 7.54606 10.4584 7.54606 8.00438Z"
            fill="#115e96"
        />
    </MaterialIconWrapper>
);

export const IconGJuniorHandMoney = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 48 48"
    >
        <rect width="48" height="48" fill="white" fill-opacity="0.01" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M28.8818 24.0112C25.9449 24.0112 23.6212 21.5013 23.6212 18.4742C23.6212 15.4471 25.9449 12.9372 28.8818 12.9372C31.8186 12.9372 34.1423 15.4471 34.1423 18.4742C34.1423 21.5013 31.8186 24.0112 28.8818 24.0112ZM32.016 18.4742C32.016 16.5375 30.5749 15.0335 28.8818 15.0335C27.1887 15.0335 25.7476 16.5375 25.7476 18.4742C25.7476 20.4109 27.1887 21.9149 28.8818 21.9149C30.5749 21.9149 32.016 20.4109 32.016 18.4742ZM21.1686 18.4742C21.1686 19.4715 20.3449 20.2705 19.3423 20.2705C18.3397 20.2705 17.516 19.4715 17.516 18.4742C17.516 17.477 18.3397 16.6779 19.3423 16.6779C20.3449 16.6779 21.1686 17.477 21.1686 18.4742ZM39.4844 18.4742C39.4844 19.4715 38.6607 20.2705 37.6581 20.2705C36.6555 20.2705 35.8318 19.4715 35.8318 18.4742C35.8318 17.477 36.6555 16.6779 37.6581 16.6779C38.6607 16.6779 39.4844 17.477 39.4844 18.4742Z"
            fill="#75167d"
        />
        <path
            d="M13.7002 9.59677V26.1001H15.8265V10.9793C19.277 11.8089 22.4941 11.5921 28.6659 10.6321C34.9463 9.65516 37.8993 9.49766 41.1739 10.3802V26.0211C37.7577 25.1998 34.5703 25.404 28.5178 26.3398C29.3894 26.6236 30.1538 27.1452 30.7342 27.8278C30.8093 27.9161 30.8813 28.0071 30.9501 28.1006C32.4504 27.8923 33.7369 27.7476 34.8844 27.671C35.8887 27.4243 36.9284 27.4198 37.9205 27.6461C39.3156 27.7361 40.5681 27.9835 41.9171 28.4032C42.5943 28.6139 43.3002 28.1202 43.3002 27.4036V9.59677C43.3002 9.13611 42.9962 8.73386 42.557 8.59721C38.5206 7.34145 35.3261 7.47386 28.3345 8.56143C21.5876 9.61094 18.6777 9.71545 15.0833 8.59721C14.4061 8.38652 13.7002 8.88017 13.7002 9.59677Z"
            fill="#75167d"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11 27C11 25.8954 10.1046 25 9 25H6C4.89543 25 4 25.8954 4 27V36C4 37.1046 4.89543 38 6 38H9C9.96603 38 10.7721 37.3151 10.9591 36.4044L19.2431 39.363C22.3237 40.4632 25.7199 40.2581 28.6457 38.7952L38.8348 33.7007C39.8455 33.1953 40.2552 31.9662 39.7498 30.9554C39.5906 30.6369 39.351 30.3655 39.0547 30.1679C37.8515 29.3658 36.3454 29.1641 34.9735 29.6214L29.9868 31.2837C29.9955 31.1903 30 31.0957 30 31C30 29.3431 28.6569 28 27 28H11V27ZM27 30C27.5523 30 28 30.4477 28 31C28 31.5523 27.5523 32 27 32H21.8571C21.3049 32 20.8571 32.4477 20.8571 33C20.8571 33.5523 21.3049 34 21.8571 34H27.6754C27.9979 34 28.3182 33.948 28.6241 33.8461L35.606 31.5188C36.3318 31.2768 37.1233 31.3567 37.7832 31.7321L37.9453 31.8321C37.952 31.8365 37.9574 31.8426 37.961 31.8498C37.9724 31.8726 37.9632 31.9004 37.9403 31.9118L27.7513 37.0063C25.3131 38.2254 22.4829 38.3963 19.9158 37.4795L11 34.2953V30H27ZM9 35.0232V36H6V27H9V35.0232Z"
            fill="#75167d"
        />
    </MaterialIconWrapper>
);

export const IconGJuniorCoinSavings = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 48 48"
    >
        <rect width="48" height="48" fill="white" fill-opacity="0.01" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13 35C11.6193 35 11 35.6193 11 37V39.5C11 40.8807 11.6529 41.5 13.0336 41.5H33C34.3807 41.5 35 40.8807 35 39.5V37C36.3807 37 37 36.3807 37 35V32.6414C37 31.2607 36.3807 30.5 35 30.5V28C35 26.6193 34.3807 26.2408 33 26.2408H24V21.7408L27.4922 20.8621C31.8467 19.9912 35.2505 16.5875 36.1214 12.233L36.6893 9.39325C36.9677 8.00151 35.7481 6.77078 34.3539 7.03634L31.4042 7.5982C26.8141 8.47251 23.4649 11.5295 22.7718 16.1504C22.1686 13.8819 20.5176 12.8404 18.2039 12.4449L14.1685 11.7551C13.8329 11.6977 13.4912 11.815 13.2616 12.0664C13.032 12.3178 12.9461 12.6687 13.0336 12.9978L14.0086 16.6643C14.6118 18.9328 16.4824 20.6412 18.7961 21.0367L22 21.7408V26.2408H13C11.6193 26.2408 11 26.6193 11 28V30.5C11 31.8807 11.6193 32.6414 13 32.6414V35ZM15 32.6414H35V35H15V32.6414ZM13 30.5V28H33V30.5H13ZM21.6334 19.4927L19.1331 19.0653C17.5906 18.8016 16.3435 17.6627 15.9414 16.1504L15.3666 13.9889L17.8669 14.4163C19.4094 14.68 20.6565 15.8189 21.0586 17.3312L21.6334 19.4927ZM27.1 18.901L24.2002 19.4809L24.562 17.0689C25.1291 13.2881 28.0229 10.2782 31.7784 9.56288L34.7281 9.00102L34.1602 11.8408C33.4476 15.4036 30.6628 18.1884 27.1 18.901ZM13.0336 37H33V39.5H13.0336V37Z"
            fill="#b8004b"
        />
    </MaterialIconWrapper>
);

export const IconGJuniorGames = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 48 48"
    >
        <rect width="48" height="48" fill="white" fill-opacity="0.01" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26 7C23.2386 7 21 9.23858 21 12V16H23V12C23 10.3431 24.3431 9 26 9H38C39.6569 9 41 10.3431 41 12V24C41 25.6569 39.6569 27 38 27H30V29H38C40.7614 29 43 26.7614 43 24V12C43 9.23858 40.7614 7 38 7H26Z"
            fill="#027454"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 28C13.1046 28 14 27.1046 14 26C14 24.8954 13.1046 24 12 24C10.8954 24 10 24.8954 10 26C10 27.1046 10.8954 28 12 28Z"
            fill="#027454"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20 36C21.1046 36 22 35.1046 22 34C22 32.8954 21.1046 32 20 32C18.8954 32 18 32.8954 18 34C18 35.1046 18.8954 36 20 36Z"
            fill="#027454"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 32C17.1046 32 18 31.1046 18 30C18 28.8954 17.1046 28 16 28C14.8954 28 14 28.8954 14 30C14 31.1046 14.8954 32 16 32Z"
            fill="#027454"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22 26C22 24.8954 21.1046 24 20 24C18.8954 24 18 24.8954 18 26C18 27.1046 18.8954 28 20 28C21.1046 28 22 27.1046 22 26Z"
            fill="#027454"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 36C13.1046 36 14 35.1046 14 34C14 32.8954 13.1046 32 12 32C10.8954 32 10 32.8954 10 34C10 35.1046 10.8954 36 12 36Z"
            fill="#027454"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 19C7.23858 19 5 21.2386 5 24V36C5 38.7614 7.23858 41 10 41H22C24.7614 41 27 38.7614 27 36V24C27 21.2386 24.7614 19 22 19H10ZM7 24C7 22.3431 8.34315 21 10 21H22C23.6569 21 25 22.3431 25 24V36C25 37.6569 23.6569 39 22 39H10C8.34315 39 7 37.6569 7 36V24Z"
            fill="#027454"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30 14C30 12.8954 29.1046 12 28 12C26.8954 12 26 12.8954 26 14C26 15.1046 26.8954 16 28 16C29.1046 16 30 15.1046 30 14Z"
            fill="#027454"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M38 22C38 20.8954 37.1046 20 36 20C34.8954 20 34 20.8954 34 22C34 23.1046 34.8954 24 36 24C37.1046 24 38 23.1046 38 22Z"
            fill="#027454"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M34 18C34 16.8954 33.1046 16 32 16C30.8954 16 30 16.8954 30 18C30 19.1046 30.8954 20 32 20C33.1046 20 34 19.1046 34 18Z"
            fill="#027454"
        />
    </MaterialIconWrapper>
);

export const IconNewTab = (props: {
    className?: string;
    style?: React.CSSProperties;
}) => (
    <MaterialIconWrapper
        className={props.className}
        style={props.style}
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15 5C14.4477 5 14 4.55228 14 4C14 3.44772 14.4477 3 15 3H20C20.5523 3 21 3.44772 21 4V9C21 9.55228 20.5523 10 20 10C19.4477 10 19 9.55228 19 9V6.41421L11.7071 13.7071C11.3166 14.0976 10.6834 14.0976 10.2929 13.7071C9.90237 13.3166 9.90237 12.6834 10.2929 12.2929L17.5858 5H15ZM3.87868 5.87868C4.44129 5.31607 5.20435 5 6 5H12C12.5523 5 13 5.44772 13 6C13 6.55228 12.5523 7 12 7H6C5.73478 7 5.48043 7.10536 5.29289 7.29289C5.10536 7.48043 5 7.73478 5 8V18C5 18.2652 5.10536 18.5196 5.29289 18.7071C5.48043 18.8946 5.73478 19 6 19H16C16.2652 19 16.5196 18.8946 16.7071 18.7071C16.8946 18.5196 17 18.2652 17 18V12C17 11.4477 17.4477 11 18 11C18.5523 11 19 11.4477 19 12V18C19 18.7957 18.6839 19.5587 18.1213 20.1213C17.5587 20.6839 16.7957 21 16 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V8C3 7.20435 3.31607 6.44129 3.87868 5.87868Z"
            fill="#135EE2"
        />
    </MaterialIconWrapper>
);

export { A11yPopupHider } from "../common/A11yPopupHider";
export { A11yRefocus } from "../common/A11yRefocus";

export const styleNoPadding: React.CSSProperties = {
    margin: 0,
    padding: 0,
};

// Component that focuses automatically for screen readers
export class H1WithFocus extends React.Component<
    {
        style: React.CSSProperties;
        className?: string;
        children: any;
        skipFocus?: boolean;
    },
    {}
> {
    ref: any;

    componentDidMount() {
        if (this.ref && !this.props.skipFocus) {
            this.ref.focus();
        }
    }

    render() {
        return (
            <h1
                className={this.props.className}
                style={{
                    ...this.props.style,
                    outline: "none", // needed to avoid orange frame in some browsers
                }}
                tabIndex={-1} // needed to allow focusing
                ref={(c: any) => (this.ref = c)}
            >
                {...this.props.children}
            </h1>
        );
    }
}

export const MessageScreenText = (props: { children: any }) => (
    <div
        style={{
            color: "white",
            fontSize: 16 /*Math.min(0.05 * ui.windowWidth, 24)*/,
        }}
    >
        {props.children}
    </div>
);

export const SigningLabelTitle = (props: { children: any }) => (
    <h2
        className="theme-paragraph-color"
        style={{
            margin: 0,
            padding: 0,
            fontWeight: "normal",
            fontSize: "12px",
            lineHeight: "16px",
        }}
    >
        {props.children}
    </h2>
);

export const P_SEMI_20_007AFF = styledP({
    ...styleNoPadding,
    color: "#007AFF",
    fontSize: 20,
    fontWeight: 600,
});

export const P_20_FF3B30 = styledP({
    ...styleNoPadding,
    color: "#FF3B30",
    fontSize: 20,
});

export const P_SEMI_22 = styledP({
    ...styleNoPadding,
    fontSize: 22,
    fontWeight: 600,
});

export const P_SEMI_18 = styledP({
    ...styleNoPadding,
    fontSize: 18,
    fontWeight: 600,
});

export const P_SEMI_16 = styledP({
    ...styleNoPadding,
    fontSize: 16,
    fontWeight: 600,
});

// Helper HOC to add fontSize
function withFontSize(WrappedComponent: any, fontSize: number) {
    return (props: any) => <WrappedComponent fontSize={fontSize} {...props} />;
}

// Helper HOC to add className
function withClassName(WrappedComponent: any, className: string) {
    return (props: any) => (
        <WrappedComponent className={className} {...props} />
    );
}

export const P = (props: {
    className?: string;
    fontSize?: number;
    children?: any;
    style?: React.CSSProperties;
    dangerouslySetInnerHTML?: any;
}) => {
    const {
        className,
        fontSize,
        children,
        style,
        dangerouslySetInnerHTML,
        ...other
    } = props;
    return (
        <p
            className={className}
            style={{
                ...styleNoPadding,
                fontSize: props.fontSize,
                ...props.style,
            }}
            dangerouslySetInnerHTML={props.dangerouslySetInnerHTML}
            {...other}
        >
            {props.children}
        </p>
    );
};

export const P_CONTENT = withClassName(P, "theme-paragraph-color");
export const P_TITLE = withClassName(P, "theme-title-color");

export const P_10_CONTENT = withFontSize(P_CONTENT, 10);
export const P_12_CONTENT = withFontSize(P_CONTENT, 12);
export const P_14_CONTENT = withFontSize(P_CONTENT, 14);
export const P_16_CONTENT = withFontSize(P_CONTENT, 16);
export const P_18_CONTENT = withFontSize(P_CONTENT, 18);
export const P_20_CONTENT = withFontSize(P_CONTENT, 20);
export const P_24_CONTENT = withFontSize(P_CONTENT, 24);
export const P_28_CONTENT = withFontSize(P_CONTENT, 28);

export const P_14_TITLE = withFontSize(P_TITLE, 14);
export const P_16_TITLE = withFontSize(P_TITLE, 16);
export const P_18_TITLE = withFontSize(P_TITLE, 18);
export const P_20_TITLE = withFontSize(P_TITLE, 20);
export const P_22_TITLE = withFontSize(P_TITLE, 22);
export const P_24_TITLE = withFontSize(P_TITLE, 24);
export const P_28_TITLE = withFontSize(P_TITLE, 28);
export const P_30_TITLE = withFontSize(P_TITLE, 30);
export const P_32_TITLE = withFontSize(P_TITLE, 32);
export const P_48_TITLE = withFontSize(P_TITLE, 48);

export const H1_16_TITLE = (props: {
    children: any;
    style?: React.CSSProperties;
}) => (
    <h1
        className="theme-title-color"
        style={{ ...styleNoPadding, fontSize: 16, ...props.style }}
    >
        {props.children}
    </h1>
);

export const SigningApproval = P_14_CONTENT;
export const SigningLabel = P_16_TITLE;

export const H1_16_FFFFFF = styledH1({
    ...styleNoPadding,
    color: "white",
    fontSize: 16,
});

export const LandingPageTitle = (props: {
    children: any;
    style?: React.CSSProperties;
}) => {
    return (
        <h1
            className="theme-title-color"
            style={{
                padding: 0,
                margin: 0,
                marginTop: 10,
                fontSize: 24,
                fontWeight: 600,
                ...props.style,
            }}
        >
            {props.children}
        </h1>
    );
};

export const LandingPageSubtitle = (props: {
    children: any;
    style?: React.CSSProperties;
}) => {
    return (
        <h2
            className="theme-title-color"
            style={{
                padding: 0,
                margin: 0,
                marginTop: 10,
                fontSize: 14,
                fontWeight: 600,
                ...props.style,
            }}
        >
            {props.children}
        </h2>
    );
};

export const H3_SEMI_16_TITLE = (props: {
    children: any;
    style?: React.CSSProperties;
}) => {
    return (
        <h3
            className="theme-title-color"
            style={{
                padding: 0,
                margin: 0,
                fontSize: 16,
                fontWeight: 600,
                ...props.style,
            }}
        >
            {props.children}
        </h3>
    );
};

export const STYLE_CENTERED_CARD = {
    width: "95%",
    marginLeft: "auto",
    marginRight: "auto",
};

export const STYLE_SEMI_24_WHITE: React.CSSProperties = {
    margin: 0,
    padding: 0,
    color: "white",
    fontSize: 24,
    fontWeight: 600,
};

export const STYLE_LIGHT_28: React.CSSProperties = {
    margin: 0,
    padding: 0,
    fontSize: 28,
    fontWeight: 200,
};

export const STYLE_CENTERED_TEXT_FIELD: React.CSSProperties = {
    ...STYLE_LIGHT_28,
    textAlign: "center",
};

export const BoldLabel = (props: {
    children: any;
    style?: React.CSSProperties;
}) => (
    <P_18_CONTENT style={{ fontWeight: "bold", ...props.style }}>
        {props.children}
    </P_18_CONTENT>
);

export function styledDiv(_style: React.CSSProperties) {
    return (props: any) => {
        const { children, style, ...otherProps } = props;
        return (
            <div style={{ ..._style, ...style }} {...otherProps}>
                {children}
            </div>
        );
    };
}

export function styledDivWithClassName(
    _style: React.CSSProperties,
    _className: string,
) {
    return (props: any) => {
        const { children, style, ...otherProps } = props;
        return (
            <div
                className={_className}
                style={{ ..._style, ...style }}
                {...otherProps}
            >
                {children}
            </div>
        );
    };
}

export function styledP(_style: React.CSSProperties) {
    return (props: any) => {
        const { children, style, ...otherProps } = props;
        return (
            <p style={{ ..._style, ...style }} {...otherProps}>
                {children}
            </p>
        );
    };
}

export function styledH1(_style: React.CSSProperties) {
    return (props: any) => {
        const { children, style, ...otherProps } = props;
        return (
            <h1 style={{ ..._style, ...style }} {...otherProps}>
                {children}
            </h1>
        );
    };
}

export const MessageLabelContainer = styledDiv({ padding: "15px 20px" });

export const SigningLabelSet = styledDiv({
    position: "relative",
    margin: "0px 0 0px 0",
});

export const SigningLabelContainer = MessageLabelContainer;

export const HeaderBackground = (props: {
    children?: any;
    style?: React.CSSProperties;
}) => (
    <div
        className="theme-header-background-color"
        style={{ height: theme.HEADER_HEIGHT, ...props.style }}
    >
        {props.children}
    </div>
);

export const LightSeparatorLine = ({
    style,
    spacing,
}: {
    style?: CSSProperties;
    spacing?: number;
}) => (
    <div
        style={{
            width: "100%",
            height: 0,
            borderBottomStyle: "solid",
            borderBottomWidth: 1,
            marginTop: spacing,
            marginBottom: spacing,
            ...style,
        }}
        className="theme-light-separator-line-color"
    />
);

export const HFlex = styledDiv({ display: "flex" });

export const HFlexCentered = styledDiv({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
});

export const VFlex = styledDiv({
    display: "flex",
    flexDirection: "column",
});

export const HCenterDiv = styledDiv({
    width: "100%",
    textAlign: "center",
});
// Needs a height to work. Children are centered vertically.
export const VCenterDiv = styledDiv({
    width: "100%",
    display: "flex",
    alignItems: "center",
});

// Fallback if pointer-events is not supported
export const InputBlocker = (props: { inputBlocked: boolean }) => (
    <div
        style={{
            display: props.inputBlocked ? "block" : "none",
            position: "fixed",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
        }}
    />
);

export const FullscreenOverlay = styledDivWithClassName(
    {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 100,
    },
    "theme-modal-overlay",
);

// Use these to wrap for semantic web
export const A11yH1 = (props: { children: any }) => (
    <h1 style={{ margin: 0, padding: 0 }}>{props.children}</h1>
);
export const A11yH2 = (props: { children: any }) => (
    <h2 style={{ margin: 0, padding: 0 }}>{props.children}</h2>
);
export const A11yH3 = (props: { children: any }) => (
    <h3 style={{ margin: 0, padding: 0 }}>{props.children}</h3>
);



// WEBPACK FOOTER //
// ./src/components/util/primitives.tsx